import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { LOGOUT } from '../../features/actions/Is-Logged-Actions';
import { connect } from 'react-redux';

import Container from 'react-bootstrap/Container';
//import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
//import Button from 'react-bootstrap/Button';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
//import Tooltip from 'react-bootstrap/Tooltip';
//import Modal from 'react-bootstrap/Modal';
import Navbar from '../../components/Navbar';
import {
    Box,
    Button,
    FileInput,
    Grid,
    LoadingOverlay,
    Modal,
    NumberInput,
    Paper,
    Table,
    Tabs,
    Text,
    Textarea,
    TextInput,
    Tooltip,
    Select,
    Switch,
    Group,
    Title,
    Divider,
    Collapse,
    Anchor,
} from '@mantine/core';

import {
    DateInput,
    DateTimePicker
} from '@mantine/dates';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import { IconEdit, IconPlus, IconChevronDown, IconChevronUp } from "@tabler/icons-react";

import HardwareAssetDataService from '../../services/hardware-asset-activities';

import { UPDATE_SELECTED_COMPANY_IN_ADD_ASSET_FORM_HARDWARE } from '../../features/actions/Hardware-Asset-Filter-Actions';
//import { Table } from 'react-bootstrap';

import authorizedDomainsForTenantChange from '../../authorized-domains-for-tenant-change';

import classes from './Edit-Hardware-Asset.module.css';


import RichTextInput from "../RichTextInput";
import { cleanHTML } from '../../html-cleaner';
import parse from 'html-react-parser';

class EditHardwareAsset extends Component {

    constructor(props) {
        super(props);

        this.toggleAddFormAssignedAssetInputVisible = this.toggleAddFormAssignedAssetInputVisible.bind(this);
        this.closeEditPage = this.closeEditPage.bind(this);
        this.closeCategoryModal = this.closeCategoryModal.bind(this);
        this.openCategoryModal = this.openCategoryModal.bind(this);
        this.closeTypeModal = this.closeTypeModal.bind(this);
        this.openTypeModal = this.openTypeModal.bind(this);
        this.closeModelModal = this.closeModelModal.bind(this);
        this.openModelModal = this.openModelModal.bind(this);
        this.closeManufacturerModal = this.closeManufacturerModal.bind(this);
        this.openManufacturerModal = this.openManufacturerModal.bind(this);
        this.closeSiteModal = this.closeSiteModal.bind(this);
        this.openSiteModal = this.openSiteModal.bind(this);
        this.closeLocationModal = this.closeLocationModal.bind(this);
        this.openLocationModal = this.openLocationModal.bind(this);
        this.closeVendorModal = this.closeVendorModal.bind(this);
        this.openVendorModal = this.openVendorModal.bind(this);

        this.getHardwareAssetTypes = this.getHardwareAssetTypes.bind(this);
        this.getUserList = this.getUserList.bind(this);
        this.getTenantList = this.getTenantList.bind(this);
        this.getCategories = this.getCategories.bind(this);
        this.getManufacturers = this.getManufacturers.bind(this);
        this.getModels = this.getModels.bind(this);
        this.getSites = this.getSites.bind(this);
        this.getLocations = this.getLocations.bind(this);
        this.getAssignableAssets = this.getAssignableAssets.bind(this);


        this.handleIsCoreChange = this.handleIsCoreChange.bind(this);
        this.handleTenantChange = this.handleTenantChange.bind(this);
        this.handleAssetNameEnteredChange = this.handleAssetNameEnteredChange.bind(this);
        this.handleSelectedCategoryChange = this.handleSelectedCategoryChange.bind(this);
        this.handleSelectedTypeChange = this.handleSelectedTypeChange.bind(this);
        this.handleSelectedModelChange = this.handleSelectedModelChange.bind(this);
        this.handleSelectedSiteChange = this.handleSelectedSiteChange.bind(this);
        this.handleSelectedLocationChange = this.handleSelectedLocationChange.bind(this);
        this.handleSelectedAssignedPersonChange = this.handleSelectedAssignedPersonChange.bind(this);
        this.handleSelectedVendorChange = this.handleSelectedVendorChange.bind(this);
        this.handleAssetTagEnteredChange = this.handleAssetTagEnteredChange.bind(this);
        this.handleSerialNumberEnteredChange = this.handleSerialNumberEnteredChange.bind(this);
        this.handleBarcodeEnteredChange = this.handleBarcodeEnteredChange.bind(this);
        this.handleIPAddressEnteredChange = this.handleIPAddressEnteredChange.bind(this);
        this.handleMACAddressEnteredChange = this.handleMACAddressEnteredChange.bind(this);
        this.handleRAMEnteredChange = this.handleRAMEnteredChange.bind(this);
        this.handleCPUEnteredChange = this.handleCPUEnteredChange.bind(this);
        this.handleAcquisitionDateChange = this.handleAcquisitionDateChange.bind(this);
        this.handleWebsiteEnteredChange = this.handleWebsiteEnteredChange.bind(this);
        this.handleWarrantyStartDateChange = this.handleWarrantyStartDateChange.bind(this);
        this.handleWarrantyEndDateChange = this.handleWarrantyEndDateChange.bind(this);
        this.handleLeaseStartDateChange = this.handleLeaseStartDateChange.bind(this);
        this.handleLeaseEndDateChange = this.handleLeaseEndDateChange.bind(this);
        this.handleTrackAssetChange = this.handleTrackAssetChange.bind(this);
        this.handleIsPeripheralChange = this.handleIsPeripheralChange.bind(this);
        this.handleAssignedAssetCategoryChange = this.handleAssignedAssetCategoryChange.bind(this);
        this.handleAssignedAssetTypeChange = this.handleAssignedAssetTypeChange.bind(this);
        this.handleContractNumberEnteredChange = this.handleContractNumberEnteredChange.bind(this);

        this.handleAssetCodeEnteredChange = this.handleAssetCodeEnteredChange.bind(this);
        this.handleInvoiceNumberEnteredChange = this.handleInvoiceNumberEnteredChange.bind(this);
        this.handleOrderNumberEnteredChange = this.handleOrderNumberEnteredChange.bind(this);

        this.submitEditAssetForm = this.submitEditAssetForm.bind(this);


        this.handleCreateCategoryNameChange = this.handleCreateCategoryNameChange.bind(this);
        this.submitCreateCategoryForm = this.submitCreateCategoryForm.bind(this);

        this.handleCreateTypeNameChange = this.handleCreateTypeNameChange.bind(this);
        this.submitCreateTypeForm = this.submitCreateTypeForm.bind(this);

        this.handleCreateModelNameChange = this.handleCreateModelNameChange.bind(this);
        this.handleCreateModelTypeChange = this.handleCreateModelTypeChange.bind(this);
        this.handleCreateModelCostChange = this.handleCreateModelCostChange.bind(this);
        this.handleCreateModelManufacturerChange = this.handleCreateModelManufacturerChange.bind(this);
        this.submitCreateModelForm = this.submitCreateModelForm.bind(this);

        this.handleCreateManufacturerNameChange = this.handleCreateManufacturerNameChange.bind(this);
        this.handleCreateManufacturerTypeChange = this.handleCreateManufacturerTypeChange.bind(this);
        this.handleCreateManufacturerPhoneChange = this.handleCreateManufacturerPhoneChange.bind(this);
        this.submitCreateManufacturerForm = this.submitCreateManufacturerForm.bind(this);

        this.handleCreateSiteNameChange = this.handleCreateSiteNameChange.bind(this);
        this.handleCreateSiteStreetAddressChange = this.handleCreateSiteStreetAddressChange.bind(this);
        this.handleCreateSiteCityChange = this.handleCreateSiteCityChange.bind(this);
        this.handleCreateSiteStateChange = this.handleCreateSiteStateChange.bind(this);
        this.handleCreateSiteZipCodeChange = this.handleCreateSiteZipCodeChange.bind(this);
        this.submitCreateSiteForm = this.submitCreateSiteForm.bind(this);

        this.handleCreateLocationFloorChange = this.handleCreateLocationFloorChange.bind(this);
        this.handleCreateLocationAisleChange = this.handleCreateLocationAisleChange.bind(this);
        this.handleCreateLocationDeskChange = this.handleCreateLocationDeskChange.bind(this);
        this.submitCreateLocationForm = this.submitCreateLocationForm.bind(this);

        this.handleCreateVendorNameChange = this.handleCreateVendorNameChange.bind(this);
        this.submitCreateVendorForm = this.submitCreateVendorForm.bind(this);


        this.state = {
            enable_assigned_asset_input: false,

            asset_field_settings: {},

            // drop down menu items
            asset_categories: [],       // {id: 1, name_of_category: "IT"}
            asset_types: [],    // can reuse code from asset list   {id: 1, name_of_type: "Printer"}
            model_names: [],    // {id: 1, name_of_model: "Think Pad"}
            sites: [{id: 0, name_of_site: "None"}],      // {id: 1, name_of_site: "Irvine Office"}
            locations_at_site: [{ id: 0, floor_number: "None", aisle_number: "None", desk_number: "None" }],      // contains data for the currently selected site  {id: 1, floor_number: 1, aisle_number: 2, desk_number: 5"}
            people: [{ id: 0, full_name: "None", name_of_tenant: "All" }],         // for the assigned to drop down menu   // can reuse code from asset list {id: 1, full_name: "Tom Johnson", name_of_tenant: "ProGroup"}
            vendors: [{ id: 0, name_of_vendor: "None" }],        // {id: 1, name_of_vendor: "EMC"}
            tenants: [],    // can reuse code from asset list   {id: 1, name_of_tenant: "ProGroup"}
            assigned_asset_names: [],   // gets populated with values of assets with matching type and company info from assigned to drop downs

            departments: [{id: 0, name_of_department: "None"}],
            managing_groups: [{id: 0, name: "None"}],

            asset: {},      // will contain the currently saved details of this asset that has been called up

            // core add asset form variables
            selected_tenant_id: 0,
            asset_name_entered: "",
            selected_category_id: 0,
            selected_type_id: 0,
            selected_type_name: "",     // this is used to determine what tabs to show in the asset form - gets set on component mount + whenever user changes selected type
            selected_model_id: 0,
            selected_site_id: 0,
            selected_location_in_building_id: 0,
            selected_person_id: 0,
            selected_vendor_id: 0,
            asset_tag_entered: "",
            serial_number_entered: "",
            barcode_entered: "",
            ip_address_entered: "",
            mac_address_entered: "",
            ram_entered: "",
            cpu_entered: "",
            aquisition_date_entered: "",
            website_entered: "",
            warranty_start_date_entered: "",
            warranty_end_date_entered: "",
            lease_start_date_entered: "",
            lease_end_date_entered: "",
            track_asset: true,
            is_peripheral: false,
            contract_number_entered: "",


            // After Rework
            impact_level_selected: "",
            end_of_life_date: "",
            location_description_entered: "",
            department_id_selected: 0,
            department_name_selected: "",
            managing_group_id_selected: 0,
            managing_group_name_selected: "",
            selected_managing_person_id: 0,
            assignment_time: "",
            quote_status_entered: "",
            renewal_status_entered: "",
            attachments: [],
            asset_cost_entered: "",
            salvage_cost_entered: "",
            depreciation_type_selected: "",
            usage_type_selected: "",
            hardware_domain_selected: "",
            hardware_asset_state_selected: "",
            last_audit_date: "",
            firmware_entered: "",
            firmware_version_entered: "",
            ports_entered: "",
            subnet_mask_entered: "",
            cloud_cost_entered: "",
            cloud_last_audit_date_entered: "",
            cloud_region_selected: "",
            cloud_availability_zone_selected: "",
            cloud_provider_selected: "",
            item_id_entered: "",
            item_name_entered: "",
            computer_os_selected: "",
            computer_os_version_entered: "",
            computer_os_service_pack_entered: "",
            computer_memory_entered: "",
            computer_disk_space_entered: "",
            computer_cpu_speed_entered: "",
            computer_cpu_core_count_entered: "",
            computer_uuid_entered: "",
            computer_hostname_entered: "",
            computer_last_login_by_entered: "",
            consumable_state_selected: "",
            consumable_quantity_entered: "",
            database_port_entered: "",
            database_engine_version_entered: "",
            database_allocated_storage_entered: "",
            database_max_allocated_storage_entered: "",
            database_endpoint_entered: "",
            database_created_time_entered: "",
            database_multiple_availabilty_zone: false,
            database_license_model_entered: "",
            database_class_selected: "",
            database_status_selected: "",
            datacenter_state_selected: "",
            datastore_state_selected: "",
            datastore_size_entered: "",
            datastore_free_space_entered: "",
            datastore_connection_state_selected: "",
            disk_drive_type_selected: "",
            disk_space_entered: "",
            disk_free_space_entered: "",
            disk_free_space_checked_on: "",
            document_status_selected: "",
            document_type_selected: "",
            document_version_entered: "",
            host_state_selected: "",
            host_creation_timestamp_entered: "",
            image_source_entered: "",
            guest_os_selected: "",
            dns_name_entered: "",
            mobile_os_selected: "",
            imei_number_entered: "",
            network_state_selected: "",
            network_connection_state_selected: "",
            bandwidth_entered: "",
            network_range_entered: "",
            network_interface_state_selected: "",
            printer_type_selected: "",
            public_ip_state_selected: "",
            footprint_entered: "",
            power_consumption_entered: "",
            rack_units_entered: "",
            rack_units_in_use_entered: "",
            resource_pool_state_selected: "",
            resource_pool_last_updated: "",
            inbound_rule_count_entered: "",
            outbound_rule_count_entered: "",
            health_selected: "",
            sla_availability_entered: "",
            service_support_hours_entered: "",
            system_oid_entered: "",
            cidr_block_entered: "",
            battery_status_selected: "",
            battery_voltage_entered: "",
            battery_current_entered: "",
            instance_type_selected: "",
            vm_private_address_entered: "",
            vm_public_address_entered: "",
            vm_state_selected: "",
            vm_os_name_entered: "",
            volume_type_entered: "",
            volume_state_selected: "",
            iops_entered: "",

            description_entered: "",


            // Extra fields from Crowdstrike Integration
            os_build_entered: "",
            average_memory_utilization_entered: "",
            disk_in_use_entered: "",
            drive_encryption_status_selected: "",
            //cpu_entered: "",
            average_processor_utlization_entered: "",
            internal_ip_address_entered: "",
            last_login_timestamp_entered: "",
            
            physical_location_entered: "",
            ad_ou_entered: "",

            connection_types_entered: "",

            asset_note_text_input: "",
            show_notes_modal: false,

            attachments: [],
            installed_software: [],
            notes: [],



            // variables for assigning peripheral to core asset (3 drop downs at end of form)
            selected_assigned_asset_category_id: 0,
            selected_assigned_asset_type_id: 0,
            selected_assigned_asset_name_id: 0,

            // Extra Fields From Tony
            asset_code_entered: "",
            invoice_number_entered: "",
            order_number_entered: "",

            // Power Details Items
            power_type_entered: "",
            kasa_name_entered: "",
            kasa_mac_address_entered: "",
            kasa_ip_address_entered: "",
            kasa_outlet_id_entered: "",
            kasa_plug_number_entered: "",
            pdu_name_entered: "",
            pdu_ip_address_entered: "",
            pdu_outlet_id_entered: "",

            // view modal controllers
            show_category_modal: false,
            show_type_modal: false,
            show_model_modal: false,
            show_manufacturer_modal: false,
            show_site_modal: false,
            show_location_modal: false,
            show_vendor_modal: false,
            show_welcome_modal: false,
            show_department_modal: false,
            show_managing_group_modal: false,

            show_loading_overlay: true,     // shows loading screen while form fields load. turns off when page fully loaded

            from_model_modal: false,    // determines if user came from model or core form (affects where they get sent back to after closing)

            selected_form_tab: "Basic Info",      // will determine what form section actually renders (to optomize text input) - starts on Basic Info


            // modal form values

            // add category form
            createCategory_category_name_entered: "",

            // Add type form
            type_name_entered: "",
            selected_is_core_value: true,

            // Model form
            model_name_entered: "",
            model_type_id_selected: 0,
            cost_entered: "",
            manufacturer_id_selected: 0,        // this one is now being used by the welcome modal
            manufacturer_id_selected_create_model_form: 0,  // this one is now used by the actual model form
            manufacturers: [],      // {id: 1, name_of_manufacturer: "Dell"}

            // manufacturer form
            manufacturer_name_entered: "",
            manufacturer_type_entered: "",
            manufacturer_phone_number_entered: "",

            // site form
            // tenant_id_selected is based on selected_tenant_id from core asset form above
            site_name_entered: "",
            site_street_address_entered: "",
            site_city_entered: "",
            site_state_entered: "",
            site_zip_code_entered: "",

            // location at site form
            location_site_id_selected: 0,
            location_floor_entered: "",
            location_aisle_entered: "",
            location_desk_entered: "",

            // vendor form
            vendor_name_entered: "",

            // department form
            department_name_entered: "",

            // managing group form
            managing_group_name_entered: "",


            canSeeErrorMessage: false,       // gets set to true if user tries to submit and incomplete form
            canSeeDuplicateNameError: false,     // gets set to true if user tries to submit a duplicate asset name

            canSeeErrorMessageCreateCategory: false,
            canSeeDuplicateNameErrorCreateCategory: false,

            canSeeErrorMessageCreateType: false,
            canSeeDuplicateNameErrorCreateType: false,

            canSeeErrorMessageCreateModel: false,
            canSeeDuplicateNameErrorCreateModel: false,

            canSeeErrorMessageCreateManufacturer: false,
            canSeeDuplicateNameErrorCreateManufacturer: false,

            canSeeDuplicateNameErrorCreateSite: false,
            canSeeErrorMessageCreateSite: false,

            canSeeDuplicateNameErrorCreateLocation: false,
            canSeeErrorMessageCreateLocation: false,

            canSeeDuplicateNameErrorCreateVendor: false,
            canSeeErrorMessageCreateVendor: false,

            canSeeDuplicateNameErrorCreateDepartment: false,
            canSeeErrorMessageCreateDepartment: false,
            
            canSeeDuplicateNameErrorCreateManagingGroup: false,
            canSeeErrorMessageCreateManagingGroup: false,

            showSaving: false,

            editModeActive: false,      // this trigger determines if the items displayed are text (false) or form input elements (true) - allows for inline editing of asset fields
            history: [],
            attachmentsSection: false,
            notesSection: true,
            installedSoftwareSection: false,

            attachments: [],
            installed_software: [],
            notes: [],

            // inTune integration value
            inTuneAssetId: null,

            interaction_mode: "",       // if set to "add" - the form is in add mode with no defaults, if set to "edit", the form behaves like the original edit form with defaults, etc.

            authorizedDomainsForTenantChange: authorizedDomainsForTenantChange /* [
                "prorepro.com", "progroupco.com", "progroupco.org"
            ] */
        };
    }

    toMantineDate(dateString) {
        // dateString expected: "YYYY-MM-DD"
        if (!dateString) return "";
      
        const [year, month, day] = dateString.split("-").map(Number);
      
        // Month is zero-based in JS Date
        return new Date(year, month - 1, day);
    }

    mysqlDatetimeToDate(mysqlDatetime) {
        // mysqlDatetime expected: "YYYY-MM-DD HH:MM:SS"
        if (!mysqlDatetime) return "";
      
        const [datePart, timePart] = mysqlDatetime.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hour, minute, second] = timePart.split(":").map(Number);
      
        return new Date(year, month - 1, day, hour, minute, second);
    }

    // returns currently selected values for this asset
    async getAssetDetails(assetId, timezoneAdjustmentFactor) {
        let response = await HardwareAssetDataService.getSpecificAsset(assetId, timezoneAdjustmentFactor);

        if(response && response.data && response.data.results && response.data.results.length > 0) {
            console.log("Inner reposne value: ", response);
            // update the attachment and notes data for this asset
            this.setState({
                attachments: response.data.attachments,
                installed_software: response.data.installed_software,
                notes: response.data.asset_notes,
                inTuneAssetId: response.data.inTuneId,
            })

            return response.data.results[0];
        }

        else {
            console.log("Bad response from get asset endpoint: ", response);
            return null;
        }
        
    }

    getHistoryDetails(id) {
        return new Promise ((resolve, reject) => {
    
            HardwareAssetDataService.getHistory(id, this.props.loggedStatus.timezone_adjustment_factor)
            .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                resolve(response.data);
            })
            .catch(e => {
                console.log(e);
                reject(e);
            });
        });
    }

    // calls get specific asset and loads the state with default values after componentDidMount has loaded all of the selection values
    async populateDefaultValues(assetId, timezoneAdjustmentFactor, cameFromEdit = false) {
        const assetData = await this.getAssetDetails(assetId, timezoneAdjustmentFactor);

        console.log("Response from get asset: ", assetData);

        let assignedToTypeIdToUse = assetData.core_asset_assigned_to_type_id !== null ? assetData.core_asset_assigned_to_type_id : 0;
        let assignedToCategoryIdToUse = assetData.core_asset_assigned_to_category_id !== null ? assetData.core_asset_assigned_to_category_id : 0;
        let siteIdToUse = assetData.site_id !== null ? assetData.site_id : 0;

        if(cameFromEdit === false) {
            // before actually setting the state, we need to get the appropriate dropdown values to prevent selection errors
            await this.getDropdownItems(assetData.tenant_id, assetData.asset_type_id, assetData.manufacturer_id, assignedToTypeIdToUse, assignedToCategoryIdToUse, siteIdToUse);
        }

        this.setState({
            asset: assetData,
            // core add asset form variables
            selected_tenant_id: assetData.tenant_id,
            asset_name_entered: assetData.name_of_asset,
            selected_category_id: this.state.asset_field_settings.show_asset_category_id === 1 && assetData.asset_category_id,
            selected_type_id: assetData.asset_type_id,
            selected_type_name: assetData.asset_type_name,     // this is used to determine what tabs to show in the asset form - gets set on component mount + whenever user changes selected type
            selected_model_id: assetData.model_id,
            selected_site_id: assetData.site_id !== null ? assetData.site_id : 0,
            //selected_location_in_building_id: 0,
            selected_person_id: assetData.assigned_person_id !== null ? assetData.assigned_person_id : 0,
            selected_vendor_id: assetData.vendor_id !== null ? assetData.vendor_id : 0,
            asset_tag_entered: assetData.asset_tag !== null ? assetData.asset_tag : "",
            serial_number_entered: assetData.asset_serial_number !== null ? assetData.asset_serial_number : "",
            barcode_entered: assetData.asset_bar_code !== null ? assetData.asset_bar_code : "",
            ip_address_entered: assetData.ip_address !== null ? assetData.ip_address : "",
            mac_address_entered: assetData.mac_address !== null ? assetData.mac_address : "",
            ram_entered: assetData.ram !== null ? assetData.ram : "",
            cpu_entered: assetData.cpu !== null ? assetData.cpu : "",
            aquisition_date_entered: assetData.acquisition_date !== null ? this.toMantineDate(assetData.acquisition_date) : "",
            website_entered: assetData.manufacturer_website !== null ? assetData.manufacturer_website : "",
            warranty_start_date_entered: assetData.warranty_start_date !== null ? this.toMantineDate(assetData.warranty_start_date) : "",
            warranty_end_date_entered: assetData.warranty_expiration_date !== null ? this.toMantineDate(assetData.warranty_expiration_date) : "",
            lease_start_date_entered: assetData.lease_start_date !== null ? this.toMantineDate(assetData.lease_start_date) : "",
            lease_end_date_entered: assetData.lease_end_date !== null ? this.toMantineDate(assetData.lease_end_date) : "",
            track_asset: assetData.isTracked !== null ? assetData.isTracked : 0,
            is_peripheral: assetData.is_peripheral !== null ? assetData.is_peripheral : 0,
            contract_number_entered: assetData.contract_number !== null ? assetData.contract_number : "",
            manufacturer_id_selected: assetData.manufacturer_id !== null ? assetData.manufacturer_id : 0,


            // After Rework
            impact_level_selected: assetData.impact !== null ? assetData.impact : "",
            end_of_life_date: assetData.end_of_life !== null ? this.toMantineDate(assetData.end_of_life) : "",
            location_description_entered: assetData.location_description !== null ? assetData.location_description : "",
            department_id_selected: assetData.department_id !== null ? assetData.department_id : 0,
            department_name_selected: assetData.name_of_department !== null ? assetData.name_of_department : "",
            managing_group_id_selected: assetData.managing_group_id !== null ? assetData.managing_group_id : 0,
            managing_group_name_selected: assetData.managing_group_name !== null ? assetData.managing_group_name : "",
            selected_managing_person_id: assetData.person_managing_id !== null ? assetData.person_managing_id : 0,
            assignment_time: assetData.date_assigned !== null ? this.mysqlDatetimeToDate(assetData.date_assigned) : "",
            quote_status_entered: assetData.quote_status !== null ? assetData.quote_status : "",
            renewal_status_entered: assetData.renewal_status !== null ? assetData.renewal_status : "",
            //attachments: [],
            asset_cost_entered: assetData.cost !== null ? assetData.cost : "",
            salvage_cost_entered: assetData.salvage !== null ? assetData.salvage : "",
            depreciation_type_selected: assetData.depreciation_type !== null ? assetData.depreciation_type : "",
            usage_type_selected: assetData.usage_type !== null ? assetData.usage_type : "",
            hardware_domain_selected: assetData.domain !== null ? assetData.domain : "",
            hardware_asset_state_selected: assetData.state !== null ? assetData.state : "",
            last_audit_date: assetData.last_audit_date !== null ? this.mysqlDatetimeToDate(assetData.last_audit_date) : "",
            firmware_entered: assetData.firmware !== null ? assetData.firmware : "",
            firmware_version_entered: assetData.firmware_version !== null ? assetData.firmware_version : "",
            ports_entered: assetData.port !== null ? assetData.port : "",
            subnet_mask_entered: assetData.subnet_mask !== null ? assetData.subnet_mask : "",
            cloud_cost_entered: assetData.cloud_cost !== null ? assetData.cloud_cost : "",
            cloud_last_audit_date_entered: assetData.cloud_last_audit_date !== null ? this.mysqlDatetimeToDate(assetData.cloud_last_audit_date) : "",
            cloud_region_selected: assetData.cloud_region !== null ? assetData.cloud_region : "",
            cloud_availability_zone_selected: assetData.cloud_availability_zone !== null ? assetData.cloud_availability_zone : "",
            cloud_provider_selected: assetData.provider !== null ? assetData.provider : "",
            item_id_entered: assetData.item_id !== null ? assetData.item_id : "",
            item_name_entered: assetData.item_name !== null ? assetData.item_name : "",
            computer_os_selected: assetData.os_name !== null ? assetData.os_name : "",         // os_name is used for BOTH computer and VM
            computer_os_version_entered: assetData.os_version !== null ? assetData.os_version : "",
            computer_os_service_pack_entered: assetData.os_service_pack !== null ? assetData.os_service_pack : "",
            computer_memory_entered: assetData.memory !== null ? assetData.memory : "",
            computer_disk_space_entered: assetData.computer_disk_space !== null ? assetData.computer_disk_space : "",
            computer_cpu_speed_entered: assetData.cpu_speed !== null ? assetData.cpu_speed : "",
            computer_cpu_core_count_entered: assetData.cpu_core_count !== null ? assetData.cpu_core_count : "",
            computer_uuid_entered: assetData.uuid !== null ? assetData.uuid : "",
            computer_hostname_entered: assetData.hostname !== null ? assetData.hostname : "",
            computer_last_login_by_entered: assetData.last_login_by !== null ? assetData.last_login_by : "",
            consumable_state_selected: assetData.consumable_state !== null ? assetData.consumable_state : "",
            consumable_quantity_entered: assetData.quantity !== null ? assetData.quantity : "",
            database_port_entered: assetData.database_port !== null ? assetData.database_port : "",
            database_engine_version_entered: assetData.engine_version !== null ? assetData.engine_version : "",
            database_allocated_storage_entered: assetData.allocated_storage !== null ? assetData.allocated_storage : "",
            database_max_allocated_storage_entered: assetData.max_allocated_storage !== null ? assetData.max_allocated_storage : "",
            database_endpoint_entered: assetData.endpoint !== null ? assetData.endpoint : "",
            database_created_time_entered: assetData.created_time !== null ? this.mysqlDatetimeToDate(assetData.created_time) : "",
            database_multiple_availabilty_zone: assetData.multiple_availability_zone !== null ? assetData.multiple_availability_zone : "",
            database_license_model_entered: assetData.license_model !== null ? assetData.license_model : "",
            database_class_selected: assetData.database_class !== null ? assetData.database_class : "",
            database_status_selected: assetData.database_status !== null ? assetData.database_status : "",
            datacenter_state_selected: assetData.datacenter_state !== null ? assetData.datacenter_state : "",
            datastore_state_selected: assetData.datastore_state !== null ? assetData.datastore_state : "",
            datastore_size_entered: assetData.size !== null ? assetData.size : "",
            datastore_free_space_entered: assetData.free_space !== null ? assetData.free_space : "",
            datastore_connection_state_selected: assetData.connection_state !== null ? assetData.connection_state : "",
            disk_drive_type_selected: assetData.drive_type !== null ? assetData.drive_type : "",
            disk_space_entered: assetData.disk_space !== null ? assetData.disk_space : "",
            disk_free_space_entered: assetData.disk_free_space !== null ? assetData.disk_free_space : "",
            disk_free_space_checked_on: assetData.free_space_checked_on !== null ? this.mysqlDatetimeToDate(assetData.free_space_checked_on) : "",
            document_status_selected: assetData.document_status !== null ? assetData.document_status : "",
            document_type_selected: assetData.document_type !== null ? assetData.document_type : "",
            document_version_entered: assetData.version !== null ? assetData.version : "",
            host_state_selected: assetData.host_state !== null ? assetData.host_state : "",
            host_creation_timestamp_entered: assetData.host_created_time !== null ? this.mysqlDatetimeToDate(assetData.host_created_time) : "",
            image_source_entered: assetData.image_source !== null ? assetData.image_source : "",
            guest_os_selected: assetData.guest_os !== null ? assetData.guest_os : "",
            dns_name_entered: assetData.dns_name !== null ? assetData.dns_name : "",
            mobile_os_selected: assetData.mobile_os !== null ? assetData.mobile_os : "",
            imei_number_entered: assetData.imei_number !== null ? assetData.imei_number : "",
            network_state_selected: assetData.network_state !== null ? assetData.network_state : "",
            network_connection_state_selected: assetData.network_connection_state !== null ? assetData.network_connection_state : "",
            bandwidth_entered: assetData.bandwidth !== null ? assetData.bandwidth : "",
            network_range_entered: assetData.network_range !== null ? assetData.network_range : "",
            network_interface_state_selected: assetData.network_interface_state !== null ? assetData.network_interface_state : "",
            printer_type_selected: assetData.printer_type !== null ? assetData.printer_type : "",
            public_ip_state_selected: assetData.public_ip !== null ? assetData.public_ip : "",
            footprint_entered: assetData.footprint !== null ? assetData.footprint : "",
            power_consumption_entered: assetData.power_consumption !== null ? assetData.power_consumption : "",
            rack_units_entered: assetData.rack_units !== null ? assetData.rack_units : "",
            rack_units_in_use_entered: assetData.rack_units_in_use !== null ? assetData.rack_units_in_use : "",
            resource_pool_state_selected: assetData.resource_pool_state !== null ? assetData.resource_pool_state : "",
            resource_pool_last_updated: assetData.last_updated !== null ? this.mysqlDatetimeToDate(assetData.last_updated) : "",
            inbound_rule_count_entered: assetData.inbound_rule_count !== null ? assetData.inbound_rule_count : "",
            outbound_rule_count_entered: assetData.outbound_rule_count !== null ? assetData.outbound_rule_count : "",
            health_selected: assetData.health !== null ? assetData.health : "",
            sla_availability_entered: assetData.sla_availability !== null ? assetData.sla_availability : "",
            service_support_hours_entered: assetData.service_support_hours !== null ? assetData.service_support_hours : "",
            system_oid_entered: assetData.system_oid !== null ? assetData.system_oid : "",
            cidr_block_entered: assetData.cidr_block !== null ? assetData.cidr_block : "",
            battery_status_selected: assetData.battery_status !== null ? assetData.battery_status : "",
            battery_voltage_entered: assetData.battery_voltage !== null ? assetData.battery_voltage : "",
            battery_current_entered: assetData.battery_current !== null ? assetData.battery_current : "",
            instance_type_selected: assetData.instance_type !== null ? assetData.instance_type : "",
            vm_private_address_entered: assetData.private_address !== null ? assetData.private_address : "",
            vm_public_address_entered: assetData.public_address !== null ? assetData.public_address : "",
            vm_state_selected: assetData.vm_state !== null ? assetData.vm_state : "",
            vm_os_name_entered: assetData.vm_os_name !== null ? assetData.vm_os_name : "",
            volume_type_entered: assetData.volume_type !== null ? assetData.volume_type : "",
            volume_state_selected: assetData.volume_state !== null ? assetData.volume_state : "",
            iops_entered: assetData.iops !== null ? assetData.iops : "",

            maintenance_dates_entered: assetData.maintenance_dates !== null ? assetData.maintenance_dates : "",

            description_entered: assetData.description !== null ? assetData.description : "",


            // Crowdstrike additional values
            os_build_entered: assetData.os_build !== null ? assetData.os_build : "",
            average_memory_utilization_entered: assetData.average_memory_utilization !== null ? assetData.average_memory_utilization : "",
            average_memory_utilization_percent: assetData.average_memory_utilization_percent !== null ? assetData.average_memory_utilization_percent : "",
            disk_in_use_entered: assetData.disk_in_use !== null ? assetData.disk_in_use : "",
            disk_in_use_percent: assetData.disk_in_use_percent !== null ? assetData.disk_in_use_percent : "",
            drive_encryption_status_selected: assetData.drive_encryption_status !== null ? assetData.drive_encryption_status : "",
            //cpu_entered: assetData.cpu !== null ? assetData.cpu : "",
            average_processor_utlization_entered: assetData.average_processor_utilization !== null ? assetData.average_processor_utilization : "",
            internal_ip_address_entered: assetData.internal_ip_address !== null ? assetData.internal_ip_address : "",
            last_login_timestamp_entered: assetData.last_login_timestamp !== null ? assetData.last_login_timestamp : "",
            
            physical_location_entered: assetData.physical_location !== null ? assetData.physical_location : "",
            ad_ou_entered: assetData.ad_ou !== null ? assetData.ad_ou : "",

            connection_types_entered: assetData.connection_types !== null ? assetData.connection_types : "",


            // variables for assigning peripheral to core asset (3 drop downs at end of form)
            selected_assigned_asset_category_id: assetData.core_asset_assigned_to_category_id !== null ? assetData.core_asset_assigned_to_category_id : 0,
            selected_assigned_asset_type_id: assetData.core_asset_assigned_to_type_id !== null ? assetData.core_asset_assigned_to_type_id : 0,
            selected_assigned_asset_name_id: assetData.core_asset_assigned_to_id !== null ? assetData.core_asset_assigned_to_id : 0,

            enable_assigned_asset_input: assetData.is_peripheral === 0 ? false : true,

            // Extra fields from Tony
            asset_code_entered: assetData.asset_code !== null ? assetData.asset_code : "",
            invoice_number_entered: assetData.invoice_number !== null ? assetData.invoice_number : "",
            order_number_entered: assetData.order_number !== null ? assetData.order_number : "",


            // Power Details items
            power_type_entered: assetData.power_type !== null ? assetData.power_type : "",
            kasa_name_entered: assetData.kasa_name !== null ? assetData.kasa_name : "",
            kasa_mac_address_entered: assetData.kasa_mac_address !== null ? assetData.kasa_mac_address : "",
            kasa_ip_address_entered: assetData.kasa_ip_address !== null ? assetData.kasa_ip_address : "",
            kasa_outlet_id_entered: assetData.kasa_outlet_id !== null ? assetData.kasa_outlet_id : "",
            kasa_plug_number_entered: assetData.kasa_plug_number !== null ? assetData.kasa_plug_number : "",
            pdu_name_entered: assetData.pdu_name !== null ? assetData.pdu_name : "",
            pdu_ip_address_entered: assetData.pdu_ip_address !== null ? assetData.pdu_ip_address : "",
            pdu_outlet_id_entered: assetData.pdu_outlet_id !== null ? assetData.pdu_outlet_id : "",

        })

        return;
    }

    // this will need to run after getting the specific asset, but BEFORE populating the state with defaults
    // it will get the tenant specific details for the dropdowns
    async getDropdownItems(tenantId, typeId, manufacturerId, assignedAssetTypeId, assignedAssetCategoryId, siteId) {

        // In the case where we are calling this from the edit functionality, we need to clear the lists first to prevent duplicates from populating
        this.setState({
            asset_types: [],
            tenants: [],
            manufacturers: [],
            people: [],
            asset_categories: [],
            vendors: [],
            model_names: [],
            assigned_asset_names: [],
            sites: [],
            locations_at_sites: [],
            departments: [],
            managing_groups: []
        }, () => {
            // call the GET functions to populate the dropdowns throughout screen
            this.getHardwareAssetTypes(tenantId).then(response => {
                console.log("types response before filtering: ", response.results);
                // check to see if this client has requested turning off some asset types
                if(this.state.asset_field_settings.asset_types_to_show !== null) {
                    console.log("You'll be setting the specific type selections here");
                    // the string is comma separated, need to turn that into an array for asset_types population
                    // need to use the old default values to determine the id numbers of these

                    const sortedArray = this.state.asset_field_settings.asset_types_to_show
                    .split(",")                       // Split string into an array by comma
                    .map(item => item.trim())         // Remove extra whitespace around items
                    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })); // Case-insensitive sort

                    // go through the original set of asset types that includes all of them and only include ones that appear in the array specified in the settings field
                    const filteredObjects = response.results.filter(obj => 
                        sortedArray.includes(obj.name_of_type) || obj.tenant_id != null
                    );

                    //console.log("Original value of specific types to display: ", this.state.asset_field_settings.asset_types_to_show);
                    //console.log("Sorted array version: ", sortedArray);
                    //console.log("Original full default values: ", response.results);

                    this.setState({
                        asset_types: filteredObjects
                    });
                }

                else {
                    // no specifications made, so show all the original default values
                    this.setState({
                        asset_types: response.results
                    });
                }


                this.getTenantList(this.props.loggedStatus.id).then(response => {
                    this.setState({
                        tenants: response.results
                    });

                    this.getManufacturers(tenantId).then(response => {
                        this.setState({
                            manufacturers: response.results,
                            show_loading_overlay: false     // may need to change this line
                        });


                        this.getUserList(this.props.loggedStatus.id, tenantId).then(response => {
                            this.setState({
                                people: [...this.state.people, ...response.results],
                                //selected_person_id: 0   // we have hardcoded the "None" option so we know that's going to be the iniital value automatically
                            });


                            this.getCategories().then(response => {
                                if(this.state.asset_field_settings.show_asset_category_id !== 0) {  // they are showing a required field so continue as before
                                    this.setState({
                                        asset_categories: response.results
                                    });
                                }

                                else {
                                    // they are not showing a required field so we need to force a default value
                                    if(response.results && response.results.length > 0) {
                                        this.setState({
                                            asset_categories: response.results,
                                            selected_category_id: response.results[0].id
                                        });
                                    }

                                    else{
                                        console.log("You're hiding the asset category id selected field on basic info tab - this is a required field, but we had problems getting a default value - likely need to input a placeholder into the db")
                                        this.setState({
                                            asset_categories: response.results
                                        });
                                    }
                                }


                                this.getVendors(tenantId/* this.props.loggedStatus.primary_tenant_id */).then(response => {
                                    this.setState({
                                        vendors: [...this.state.vendors, ...response.results],
                                        //selected_vendor_id: 0   // we have hardcoded "None" value so we know it's automatically 0 to start
                                    });

                                    // get model names based on the selected type in the types drop down menu
                                    this.getModels(typeId, manufacturerId/* this.state.selected_type_id, this.state.manufacturer_id_selected */).then(response => {
                                        this.setState({
                                            model_names: response.results
                                        });


                                        this.getAssignableAssets(tenantId, assignedAssetTypeId, assignedAssetCategoryId).then(response => {

                                            this.setState({
                                                assigned_asset_names: response.results
                                            });


                                            this.getSites(tenantId).then(response => {

                                                this.setState({
                                                    sites: [...this.state.sites, ...response.results]
                                                }, () => {
                                                    if (this.state.sites && this.state.sites.length > 0) {
                                                        /* this.setState({
                                                            selected_site_id: this.state.sites[0].id
                                                        }); */

                                                        // get locations in building based on that site id - Note: get locations is not going to be used anymore
                                                        this.getLocations(siteId).then(async response => {
                                                            this.setState({
                                                                locations_at_site: [...this.state.locations_at_site, ...response.results],
                                                                selected_location_in_building_id: 0 // we have hardcoded "None" option that drop down starts at
                                                            });

                                                            // get departments list
                                                            await this.getInitialDepartments(tenantId);

                                                            // get managing groups list
                                                            await this.getInitialManagingGroups(tenantId);

                                                            // populate the form fields with the proper default values
                                                            //await this.populateDefaultValues(this.props.match.params.id, token);

                                                            // remove the loading overlay
                                                            this.setState({
                                                                show_loading_overlay: false
                                                            });


                                                        })
                                                            .catch(e => {
                                                                console.log(e);
                                                            });
                                                    }
                                                });

                                            })
                                                .catch(e => {
                                                    console.log(e);
                                                });
                                        })
                                            .catch(e => {
                                                console.log(e);
                                            });

                                    })
                                        .catch(e => {
                                            console.log(e);
                                        });

                                })
                                    .catch(e => {
                                        console.log(e);
                                    });

                            })
                                .catch(e => {
                                    console.log(e);
                                });

                        })
                            .catch(e => {
                                console.log(e);
                            });

                    })
                        .catch(e => {
                            console.log(e);
                        });

                })
                    .catch(e => {
                        console.log(e);
                    });
            })
                .catch(e => {
                    console.log(e)
                });

        })
    }


    async getFieldDisplaySettings(tenantId) {
        console.log("Get field settings!");
        HardwareAssetDataService.getHardwareAssetFieldSettings(tenantId).then(response => {
            let resultToUse;

            if(response && response.data && response.data.results !== "No settings found") {
                console.log("use the db value", response.data.results[0]);
                this.setState({
                    asset_field_settings: response.data.results[0]
                }, () => {
                    return;
                });
            }

            else {
                console.log("use the DEFAULT value");
                this.setState({
                    asset_field_settings: {
                        show_isTracked: 1,
                        asset_types_to_show: null,
                        allow_asset_attachments: 1,
                        show_asset_code: 1,
                        show_asset_invoice_number: 1,
                        show_asset_order_number: 1,
                        show_model_id: 1,
                        show_vendor_id: 1,
                        show_asset_tag: 1,
                        show_asset_serial_number: 1,
                        show_ip_address: 1,
                        show_mac_address: 1,
                        show_ram: 1,
                        show_cpu: 1,
                        show_asset_bar_code: 1,
                        show_acquisition_date: 1,
                        show_warranty_start_date: 1,
                        show_warranty_expiration_date: 1,
                        show_site_id: 1,
                        show_assigned_person_id: 1,
                        show_assigned_location_at_site_id: 1,
                        show_lease_start_date: 1,
                        show_lease_end_date: 1,
                        show_manufacturer_website: 1,
                        show_asset_category_id: 1,
                        show_core_asset_assigned_to_id: 1,
                        show_use_case: 1,
                        show_department_id: 1,
                        show_managing_group_id: 1,
                        show_person_managing_id: 1,
                        show_date_assigned: 1,
                        show_impact: 1,
                        show_description: 1,
                        show_end_of_life: 1,
                        show_health: 1,
                        show_sla_availability: 1,
                        show_cost: 1,
                        show_service_support_hours: 1,
                        show_last_audit_date: 1,
                        show_provider: 1,
                        show_item_id: 1,
                        show_item_name: 1,
                        show_private_address: 1,
                        show_public_address: 1,
                        show_state: 1,
                        show_os_name: 1,
                        show_account_id: 1,
                        show_instance_id: 1,
                        show_ami_launch_index: 1,
                        show_image_id: 1,
                        show_key_name: 1,
                        show_launch_time: 1,
                        show_monitoring_state: 1,
                        show_platform: 1,
                        show_private_dns_name: 1,
                        show_public_dns_name: 1,
                        show_subnet_id: 1,
                        show_vpc_id: 1,
                        show_ebs_optimized: 1,
                        show_hypervisor: 1,
                        show_iam_instance_profile: 1,
                        show_instance_lifecycle: 1,
                        show_security_groups: 1,
                        show_resource_uri: 1,
                        show_subscription_id: 1,
                        show_publisher: 1,
                        show_offer: 1,
                        show_sku: 1,
                        show_os_disk_name: 1,
                        show_computer_name: 1,
                        show_creation_timestamp: 1,
                        show_on_host_maintenance: 1,
                        show_automatic_restart: 1,
                        show_preemptible: 1,
                        show_start_restricted: 1,
                        show_enable_display: 1,
                        show_enable_secure_boot: 1,
                        show_last_start_timestamp: 1,
                        show_last_stop_timestamp: 1,
                        show_self_link: 1,
                        show_deletion_protection: 1,
                        show_hostname: 1,
                        show_datacenter: 1,
                        show_cluster: 1,
                        show_resource_group: 1,
                        show_folder: 1,
                        show_datastore: 1,
                        show_number_of_cpu: 1,
                        show_memory_size: 1,
                        show_bios_uuid: 1,
                        show_morefid: 1,
                        show_instance_uuid: 1,
                        show_vcenter_instance_uuid: 1,
                        show_firmware: 1,
                        show_guest_full_name: 1,
                        show_version: 1,
                        show_template: 1,
                        show_volume_type: 1,
                        show_size: 1,
                        show_iops: 1,
                        show_cpu_core_count: 1,
                        show_total_disk_size: 1,
                        show_free_space: 1,
                        show_connection_state: 1,
                        show_image_source: 1,
                        show_guest_os: 1,
                        show_inbound_rule_count: 1,
                        show_outbound_rule_count: 1,
                        show_last_updated: 1,
                        show_allocated_storage: 1,
                        show_max_allocated_storage: 1,
                        show_created_time: 1,
                        show_multiple_availability_zone: 1,
                        show_salvage: 1,
                        show_nic_count: 1,
                        show_free_space_checked_on: 1,
                        show_public_ip: 1,
                        show_port: 1,
                        show_status: 1,
                        show_usage_type: 1,
                        show_asset_state: 1,
                        show_depreciation_type: 1,
                        show_battery_status: 1,
                        show_type: 1,
                        show_dns_name: 1,
                        show_private_ip_address: 1,
                        show_public_dns: 1,
                        show_cidr_block: 1,
                        show_engine_version: 1,
                        show_endpoint: 1,
                        show_license_model: 1,
                        show_database_class: 1,
                        show_product: 1,
                        show_domain: 1,
                        show_os: 1,
                        show_os_version: 1,
                        show_os_service_pack: 1,
                        show_memory: 1,
                        show_disk_space: 1,
                        show_cpu_speed: 1,
                        show_uuid: 1,
                        show_last_login_by: 1,
                        show_logical_processors: 1,
                        show_drive_type: 1,
                        show_footprint: 1,
                        show_power_consumption: 1,
                        show_rack_units: 1,
                        show_rack_units_in_use: 1,
                        show_battery_voltage: 1,
                        show_battery_current: 1,
                        show_imei_number: 1,
                        show_printer_type: 1,
                        show_subnet_mask: 1,
                        show_firmware_version: 1,
                        show_ports: 1,
                        show_system_oid: 1,
                        show_quantity: 1,
                        show_bandwidth: 1,
                        show_network_range: 1,
                        show_customer_id: 1,
                        show_product_number: 1,
                        show_warranty_type: 1,
                        show_is_peripheral: 1,
                        show_contract_number: 1,
                        show_location_description: 1,
                        show_quote_status: 1,
                        show_renewal_status: 1,
                        show_cloud_cost: 1,
                        show_cloud_last_audit_date: 1,
                        show_cloud_region: 1,
                        show_cloud_availability_zone: 1,
                        show_consumable_state: 1,
                        show_database_status: 1,
                        show_datacenter_state: 1,
                        show_datastore_state: 1,
                        show_document_status: 1,
                        show_document_type: 1,
                        show_host_state: 1,
                        show_mobile_os: 1,
                        show_network_state: 1,
                        show_network_connection_state: 1,
                        show_network_interface_state: 1,
                        show_public_ip_state: 1,
                        show_resource_pool_state: 1,
                        show_instance_type: 1,
                        show_vm_state: 1,
                        show_vm_os_name: 1,
                        show_volume_state: 1,
                        show_computer_disk_space: 1,
                        show_database_port: 1,
                        show_disk_free_space: 1,
                        show_host_created_time: 1,
                        show_maintenance_dates: 1,
                        show_physical_location: 1,
                        show_ad_ou: 1,
                        show_connection_types: 1,
                        show_last_patch_date: 1,
                        show_os_build: 1,
                        show_average_memory_utilization: 1,
                        show_disk_in_use: 1,
                        show_drive_encryption_status: 1,
                        show_average_processor_utilization: 1,
                        show_internal_ip_address: 1,
                        show_last_login_timestamp: 1,
                        show_average_memory_utilization_percent: 1,
                        show_disk_in_use_percent: 1,
                    }
                }, () => {
                    return;
                });
            }
        })
        .catch(e => {
            console.log(e);
            return {};
        });
    }

    async componentDidMount() {
        if (this.props.loggedStatus.loggedIn) {

            await this.getFieldDisplaySettings(this.props.hardwareAssetFilter.selectedHardwareAssetCustomerId);

            if(this.props.match.params.id && this.props.match.params.id !== null) {
                console.log("EDIT mode!");
            
                this.populateDefaultValues(this.props.match.params.id, this.props.loggedStatus.timezone_adjustment_factor);

                this.getHistoryDetails(this.props.match.params.id).then(response => {
                    this.setState({
                        history: response.results,
                        interaction_mode: "edit",        // makes sure all features are available on the page that facilitate editing an existing asset
                    });
                })
                .catch(e => {
                    console.log(e);
                });

            }
              

            else {
                console.log("ADD mode!");
                this.setState({
                    show_loading_overlay: false,
                    interaction_mode: "add",
                    editModeActive: true,       // setting this to true simulates the edit page's "edit mode" being on which forces the data fields to be able to receive input (as opposed to displaying text)
                    selected_tenant_id: this.props.hardwareAssetFilter.selectedHardwareAssetCustomerId,
                    show_welcome_modal: true,   // going to force them to specify a manufacturer first
                });

                let assignedToTypeIdToUse = 0;
                let assignedToCategoryIdToUse = 0;
                let siteIdToUse = 0;

                await this.getDropdownItems(this.props.hardwareAssetFilter.selectedHardwareAssetCustomerId, 0, 0, assignedToTypeIdToUse, assignedToCategoryIdToUse, siteIdToUse);

            }
        }
    }

    componentWillUnmount() {
        // Clean up the interval when the component unmounts
        clearInterval(this.interval);
    }


    // determines whether user sees form field for specific asset a peripheral is assigned to
    toggleAddFormAssignedAssetInputVisible(newValue) {

        if (this.state.enable_assigned_asset_input && newValue === false) {
            this.setState({
                enable_assigned_asset_input: false
            });
        }

        else if (!this.state.enable_assigned_asset_input && newValue === true) {
            this.setState({
                enable_assigned_asset_input: true
            });
        }

    }


    closeEditPage() {
        this.props.history.push(`/hardwareAssetDetails/${this.props.match.params.id}`);
    }

    openCategoryModal() {
        this.setState({
            show_category_modal: true
        });
    }

    closeCategoryModal() {
        this.setState({
            show_category_modal: false,
            createCategory_category_name_entered: "",
            canSeeDuplicateNameErrorCreateCategory: false,
            canSeeErrorMessageCreateCategory: false
        });
    }

    openTypeModal(fromModel) {

        if (fromModel) {     // if coming from the model modal, hide model and show type
            this.setState({
                show_model_modal: false,
                show_type_modal: true,
                from_model_modal: true
            });
        }

        else {
            this.setState({
                show_type_modal: true
            });
        }
    }

    closeTypeModal() {

        if (this.state.from_model_modal) {
            this.setState({
                show_type_modal: false,
                show_model_modal: true,
                from_model_modal: false,
                type_name_entered: "",
                selected_is_core_value: true,
                canSeeDuplicateNameErrorCreateType: false,
                canSeeErrorMessageCreateType: false
            });
        }

        else {

            this.setState({
                show_type_modal: false,
                type_name_entered: "",
                selected_is_core_value: true,
                canSeeDuplicateNameErrorCreateType: false,
                canSeeErrorMessageCreateType: false
            });
        }
    }

    openModelModal() {
        this.setState({
            show_model_modal: true,
            model_name_entered: "",
            cost_entered: 0
        });

        if (this.state.asset_types && this.state.asset_types.length > 0) {
            this.setState({
                model_type_id_selected: this.state.asset_types[0].id
            });
        }

        else {
            this.setState({
                model_type_id_selected: 0
            });
        }

        if (this.state.manufacturers && this.state.manufacturers.length > 0) {
            this.setState({
                manufacturer_id_selected_create_model_form: this.state.manufacturers[0].id
            });
        }

        else {
            this.setState({
                manufacturer_id_selected_create_model_form: 0
            });
        }
    }

    closeModelModal() {
        this.setState({
            show_model_modal: false
        });
    }

    openManufacturerModal() {
        this.setState({
            show_manufacturer_modal: true,
            show_model_modal: false
        });
    }

    closeManufacturerModal() {
        this.setState({
            show_manufacturer_modal: false,
            show_model_modal: true,
            manufacturer_name_entered: "",          // reset form fields
            manufacturer_type_entered: "",
            manufacturer_phone_number_entered: ""
        });
    }

    openSiteModal() {
        this.setState({
            show_site_modal: true,
            canSeeErrorMessageCreateSite: false,
            canSeeDuplicateNameErrorCreateSite: false
        });
    }

    closeSiteModal() {
        this.setState({
            show_site_modal: false,
            site_name_entered: "",  // reset form fields
            site_street_address_entered: "",
            site_city_entered: "",
            site_state_entered: "",
            site_zip_code_entered: "",
            canSeeErrorMessageCreateSite: false,
            canSeeDuplicateNameErrorCreateSite: false
        });
    }

    openLocationModal() {
        this.setState({
            show_location_modal: true
        });
    }

    closeLocationModal() {
        this.setState({
            show_location_modal: false,
            location_floor_entered: "",
            location_aisle_entered: "",
            location_desk_entered: ""
        });
    }

    openVendorModal() {
        this.setState({
            show_vendor_modal: true
        });
    }

    closeVendorModal() {
        this.setState({
            show_vendor_modal: false,
            vendor_name_entered: ""
        });
    }


    openWelcomeModal() {
        this.setState({
            show_welcome_modal: true
        });
    }

    closeWelcomeModal() {
        this.setState({
            show_welcome_modal: false
        });
    }


    handleIsCoreChange(newValue) {
        this.setState({
            selected_is_core_value: newValue    // will be either true or false
        });
    }

    async handleTenantChange(tenantId) {
        this.setState({
            selected_tenant_id: tenantId
        });

        // update the global state with this new value
        this.props.UPDATE_SELECTED_COMPANY_IN_ADD_ASSET_FORM_HARDWARE(tenantId);

        await this.getDepartments(tenantId);
        await this.getManagingGroups(tenantId);

        this.getManufacturers(tenantId).then(response => {
            this.setState({
                manufacturers: response.results
            });
        });


        // get new sites for this new tenant
        this.getSites(tenantId).then(response => {
            this.setState({
                sites: [{ id: 0, name_of_site: "None"}, ...response.results]
            }, () => {
                if (this.state.sites && this.state.sites.length > 0) {
                    this.setState({
                        selected_site_id: this.state.sites[0].id
                    });

                    // get locations in building based on that site id
                    this.getLocations(this.state.sites[0].id).then(response => {
                        this.setState({
                            locations_at_site: [{ id: 0, floor_number: "None", aisle_number: "None", desk_number: "None" }, ...response.results],
                            selected_location_in_building_id: 0 // we have hardcoded "None" option that drop down starts at
                        });


                    })
                        .catch(e => {
                            console.log(e);
                        });
                }

                else {      // there were no sites entered for that tenant, so we just have empty lists there and reset to default 0 selected
                    this.setState({
                        sites: [{id: 0, name_of_site: "None"}],
                        selected_site_id: 0,
                        locations_at_site: [{ id: 0, floor_number: "None", aisle_number: "None", desk_number: "None" }],
                        selected_location_in_building_id: 0
                    });
                }


            });

            // get the new user list for that tenant for the assigned to drop down menu
            this.getUserList(this.props.loggedStatus.id, tenantId).then(response => {
                this.setState({
                    people: [{ id: 0, full_name: "None", name_of_tenant: "All" }, ...response.results],
                    selected_person_id: 0,   // we have hardcoded the "None" option so we know that's going to be the iniital value automatically
                    selected_managing_person_id: 0
                });

                // get the new assignable asset list for this tenant (the drop down at bottom of form)
                // get new values for the assignable assets drop down menu
                this.getAssignableAssets(tenantId, this.state.selected_assigned_asset_type_id, this.state.selected_assigned_asset_category_id).then(response => {

                    this.setState({
                        assigned_asset_names: response.results
                    });

                    if (response.results && response.results.length > 0) {
                        this.setState({
                            selected_assigned_asset_name_id: response.results[0].id
                        });
                    }

                    else {
                        this.setState({
                            selected_assigned_asset_name_id: 0
                        });
                    }

                })
                    .catch(e => {
                        console.log(e);
                    });
            })
                .catch(e => {
                    console.log(e);
                });
        })
            .catch(e => {
                console.log(e);
            });

    }

    // Extra fields from CrowdStrike integration
    handleOSBuildEnteredChange(e) {
        this.setState({
            os_build_entered: e.target.value
        });
    }

    handleAverageMemoryUtilizationEnteredChange(e) {
        this.setState({
            average_memory_utilization_entered: e.target.value
        });
    }

    handleDiskInUseEnteredChange(e) {
        this.setState({
            disk_in_use_entered: e.target.value
        });
    }

    handleDriveEncryptionStatusSelectedChange(newValue) {
        this.setState({
            drive_encryption_status_selected: newValue
        });
    }
    
    handleCPUEnteredChange(e) {
        this.setState({
            cpu_entered: e.target.value
        });
    }
    
    handleAverageProcessorUtilizationEnteredChange(e) {
        this.setState({
            average_processor_utlization_entered: e.target.value
        });
    }

    handleInternalIPAddressEnteredChange(e) {
        this.setState({
            internal_ip_address_entered: e.target.value
        });
    }

    handleLastLoginTimestampEnteredChange(e) {
        this.setState({
            last_login_timestamp_entered: e.target.value
        });
    }
    
    handlePhysicalLocationEnteredChange(e) {
        this.setState({
            physical_location_entered: e.target.value
        });
    }

    handleADOUEnteredChange(e) {
        this.setState({
            ad_ou_entered: e.target.value
        });
    }
    
    handleConnectionTypesEnteredChange(e) {
        this.setState({
            connection_types_entered: e.target.value
        });
    }
    
    // *******************************************

    handleAssetNameEnteredChange(e) {
        this.setState({
            asset_name_entered: e.target.value
        });
    }

    handleSelectedCategoryChange(categoryId) {
        this.setState({
            selected_category_id: categoryId
        });
    }

    handleSelectedTypeChange(typeId) {
        this.setState({
            selected_type_id: typeId,
            selected_type_name: this.state.asset_types.find((e) => e.id === typeId).name_of_type
        });

        // changed type, so update the values in the model drop down menu
        this.getModels(typeId, this.state.manufacturer_id_selected).then(response => {
            this.setState({
                model_names: response.results
            });

            if (response.results && response.results.length > 0) {
                this.setState({
                    selected_model_id: response.results[0].id
                });
            }

            else {
                this.setState({
                    selected_model_id: 0        // if nothing was returned, we go back to default 0 value
                });
            }
        });
    }

    handleSelectedModelChange(modelId) {
        this.setState({
            selected_model_id: modelId
        });
    }

    handleSelectedSiteChange(siteId) {
        this.setState({
            selected_site_id: siteId
        });

        // now get a new list of locations based on site selected
        // get locations in building based on that site id
        this.getLocations(siteId).then(response => {
            this.setState({
                locations_at_site: [{ id: 0, floor_number: "None", aisle_number: "None", desk_number: "None" }, ...response.results],
                selected_location_in_building_id: 0 // we have hardcoded "None" option that drop down starts at
            });


        })
            .catch(e => {
                console.log(e);
            });
    }

    handleSelectedDepartmentChange(departmentId, departmentName) {
        this.setState({
            department_id_selected: departmentId,
            department_name_selected: departmentName
        });


    }

    handleSelectedManagingGroupChange(managingGroupId, managingGroupName) {
        this.setState({
            managing_group_id_selected: managingGroupId,
            managing_group_name_selected: managingGroupName
        });
    }

    handleSelectedLocationChange(locationId) {
        this.setState({
            selected_location_in_building_id: locationId
        });
    }

    handleSelectedAssignedPersonChange(personId) {
        this.setState({
            selected_person_id: personId
        });
    }

    handleSelectedAssignedManagingPersonChange(personId) {
        this.setState({
            selected_managing_person_id: personId
        });
    }

    handleSelectedVendorChange(vendorId) {
        this.setState({
            selected_vendor_id: vendorId
        });
    }

    handleAssetTagEnteredChange(e) {
        this.setState({
            asset_tag_entered: e.target.value
        });
    }

    handleAssetCodeEnteredChange(e) {
        this.setState({
            asset_code_entered: e.target.value
        });
    }

    handleInvoiceNumberEnteredChange(e) {
        this.setState({
            invoice_number_entered: e.target.value
        });
    }

    handleOrderNumberEnteredChange(e) {
        this.setState({
            order_number_entered: e.target.value
        });
    }

    handleSerialNumberEnteredChange(e) {
        this.setState({
            serial_number_entered: e.target.value
        });
    }

    handleBarcodeEnteredChange(e) {
        this.setState({
            barcode_entered: e.target.value
        });
    }

    handleIPAddressEnteredChange(e) {
        this.setState({
            ip_address_entered: e.target.value
        });
    }

    handleMACAddressEnteredChange(e) {
        this.setState({
            mac_address_entered: e.target.value
        });
    }

    handleRAMEnteredChange(e) {
        this.setState({
            ram_entered: e.target.value
        });
    }

    // handleCPUEnteredChange(e) {
    //     this.setState({
    //         cpu_entered: e.target.value
    //     });
    // }

    // convert the date to MySQL format before updating the state
    handleAcquisitionDateChange(e) {
        this.setState({
            aquisition_date_entered: e
        });
    }

    handleWebsiteEnteredChange(e) {
        this.setState({
            website_entered: e.target.value
        });
    }

    handleWarrantyStartDateChange(e) {
        this.setState({
            warranty_start_date_entered: e
        });
    }

    handleWarrantyEndDateChange(e) {
        this.setState({
            warranty_end_date_entered: e
        });
    }

    handleLeaseStartDateChange(e) {
        this.setState({
            lease_start_date_entered: e
        });
    }

    handleLeaseEndDateChange(e) {
        this.setState({
            lease_end_date_entered: e
        });
    }

    handleTrackAssetChange(e) {
        if (e.target.checked === true) {
            this.setState({
                track_asset: true
            });
        }

        else {
            this.setState({
                track_asset: false
            });
        }
    }

    handleIsPeripheralChange(e) {
        if (e.target.checked === true) {
            this.setState({
                is_peripheral: true
            });
        }

        else {
            this.setState({
                is_peripheral: false
            });
        }
    }

    handleAssignedAssetCategoryChange(categoryId) {
        this.setState({
            selected_assigned_asset_category_id: categoryId
        });

        console.log("Received a category id of: ", categoryId);

        // get new values for the assignable assets drop down menu
        this.getAssignableAssets(this.state.selected_tenant_id, this.state.selected_assigned_asset_type_id, categoryId).then(response => {

            this.setState({
                assigned_asset_names: response.results
            });

            if (response.results && response.results.length > 0) {
                this.setState({
                    selected_assigned_asset_name_id: response.results[0].id
                });
            }

            else {
                this.setState({
                    selected_assigned_asset_name_id: 0
                });
            }

        })
            .catch(e => {
                console.log(e);
            });
    }

    handleAssignedAssetTypeChange(typeId) {
        this.setState({
            selected_assigned_asset_type_id: typeId
        });

        // get new values for the assignable assets drop down menu
        this.getAssignableAssets(this.state.selected_tenant_id, typeId, this.state.selected_assigned_asset_category_id).then(response => {

            this.setState({
                assigned_asset_names: response.results
            });

            if (response.results && response.results.length > 0) {
                this.setState({
                    selected_assigned_asset_name_id: response.results[0].id
                });
            }

            else {
                this.setState({
                    selected_assigned_asset_name_id: 0
                });
            }

        })
            .catch(e => {
                console.log(e);
            });

    }

    handleAssignedAssetNameChange(assetId) {
        this.setState({
            selected_assigned_asset_name_id: assetId
        });
    }

    handleCreateCategoryNameChange(e) {
        this.setState({
            createCategory_category_name_entered: e.target.value
        });
    }

    handleCreateTypeNameChange(e) {
        this.setState({
            type_name_entered: e.target.value
        });
    }

    handleCreateModelNameChange(e) {
        this.setState({
            model_name_entered: e.target.value
        });
    }

    handleCreateModelTypeChange(typeId) {
        this.setState({
            model_type_id_selected: typeId
        });
    }

    handleCreateModelCostChange(e) {

        console.log(typeof(e));

        // if(e !== "") {
        //     console.log(e.toFixed(2));
        //     this.setState({
        //         cost_entered: e.toFixed(2)
        //     });
        // }

        // else {
        //     this.setState({
        //         cost_entered: ""
        //     });
        // }

        // they have cleared the field
        if (e/* .target.value */ === "") {
            this.setState({
                cost_entered: ""
            });
        }

        // they input an integer
        else if (Number.isInteger(Number(e/* .target.value */))) {
            this.setState({
                cost_entered: parseInt(e/* .target.value */)
            });
        }

        // they have input a float
        else if (!isNaN(e/* .target.value */) && e/* .target.value */.toString().indexOf('.') !== -1) {

            console.log("Float condition caught");

            this.setState({
                //cost_entered: parseFloat(e/* .target.value */).toFixed(2)
                cost_entered: e
                
            });
        }

        else {
            console.log("Bad input");
        }

    }

    handleCreateModelManufacturerChange(manufacturerId) {
        this.setState({
            manufacturer_id_selected: manufacturerId
        }, () => {this.getModels(this.state.selected_type_id, this.state.manufacturer_id_selected).then(response => {
            this.setState({
                model_names: response.results
            });

            if (response.results && response.results.length > 0) {
                this.setState({
                    selected_model_id: response.results[0].id
                });
            }

            else {
                this.setState({
                    selected_model_id: 0        // if nothing was returned, we go back to default 0 value
                });
            }
        })
        
        });
    }

    handleCreateModelManufacturerChangeCreateModelModalForm(manufacturerId) {
        this.setState({
            manufacturer_id_selected_create_model_form: manufacturerId
        });
    }

    handleCreateManufacturerNameChange(e) {
        this.setState({
            manufacturer_name_entered: e.target.value
        });
    }

    handleCreateManufacturerTypeChange(e) {
        this.setState({
            manufacturer_type_entered: e.target.value
        });
    }

    handleCreateManufacturerPhoneChange(e) {
        this.setState({
            manufacturer_phone_number_entered: e.target.value
        });
    }

    handleCreateSiteNameChange(e) {
        this.setState({
            site_name_entered: e.target.value
        });
    }

    handleCreateSiteStreetAddressChange(e) {
        this.setState({
            site_street_address_entered: e.target.value
        });
    }

    handleCreateSiteCityChange(e) {
        this.setState({
            site_city_entered: e.target.value
        });
    }

    handleCreateSiteStateChange(e) {
        this.setState({
            site_state_entered: e.target.value
        });
    }

    handleCreateSiteZipCodeChange(e) {
        this.setState({
            site_zip_code_entered: e.target.value
        });
    }

    handleCreateLocationFloorChange(e) {
        this.setState({
            location_floor_entered: e.target.value
        });
    }

    handleCreateLocationAisleChange(e) {
        this.setState({
            location_aisle_entered: e.target.value
        });
    }

    handleCreateLocationDeskChange(e) {
        this.setState({
            location_desk_entered: e.target.value
        });
    }

    handleCreateVendorNameChange(e) {
        this.setState({
            vendor_name_entered: e.target.value
        });
    }

    handleContractNumberEnteredChange(e) {
        this.setState({
            contract_number_entered: e.target.value
        });
    }

    // After Rework
    handleQuoteStatusEnteredChange(e) {
        this.setState({
            quote_status_entered: e
        });
    }

    handleRenewalStatusEnteredChange(e) {
        this.setState({
            renewal_status_entered: e
        });
    }

    handleMaintenanceDatesChange(e) {
        this.setState({
            maintenance_dates_entered: e.target.value
        });
    }

    handlePowerTypeEnteredChange(e) {
        this.setState({
            power_type_entered: e
        });
    } 

    handleKasaNameEnteredChange(e) {
        this.setState({
            kasa_name_entered: e.target.value
        });
    }

    handleKasaMACAddressEnteredChange(e) {
        this.setState({
            kasa_mac_address_entered: e.target.value
        });
    }

    handleKasaIPAddressEnteredChange(e) {
        this.setState({
            kasa_ip_address_entered: e.target.value
        });
    }

    handleKasaOutletIDEnteredChange(e) {
        this.setState({
            kasa_outlet_id_entered: e.target.value
        });
    }

    handleKasaPlugNumberEnteredChange(e) {
        this.setState({
            kasa_plug_number_entered: e.target.value
        });
    }

    handlePDUNameEnteredChange(e) {
        this.setState({
            pdu_name_entered: e.target.value
        });
    }

    handlePDUIPAddressEnteredChange(e) {
        this.setState({
            pdu_ip_address_entered: e.target.value
        });
    }

    handlePDUOutletIDEnteredChange(e) {
        this.setState({
            pdu_outlet_id_entered: e.target.value
        });
    }

    handleDescriptionEnteredChange(e) {
        this.setState({
            description_entered: e.target.value
        });
    }

    handleAttachmentUploadChange = (files) => {
        if (!files) {
          // Clear state when user clears selection
          this.setState({ attachments: [] });
          return;
        }
      
        // Ensure files is always an array
        const fileArray = Array.isArray(files) ? files : [files];
      
        // Optional: validate file types and size
        const validFiles = fileArray.filter((file) => {
          const maxSizeMB = 50;
          const allowedTypes = [
            "image/jpeg", "image/png", "image/bmp", "image/heic",
            "application/pdf", "application/msword", 
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "application/octet-stream", // sometimes .dwg or .txt files come in as this
            "text/plain"
          ];
      
          const isValidType = allowedTypes.includes(file.type);
          const isValidSize = file.size <= maxSizeMB * 1024 * 1024;
      
          if (!isValidType) {
            console.log(`Rejected file: ${file.name} — unsupported type (${file.type})`);
          }
          if (!isValidSize) {
            console.log(`Rejected file: ${file.name} — exceeds ${maxSizeMB}MB`);
          }
      
          return isValidType && isValidSize;
        });
      
        // Store in component state (you can upload later when the form submits)
        this.setState({ attachments: validFiles });
    };

    openAssetNotesModal() {
        console.log("Open modal clicked!");
        this.setState({
            asset_note_text_input: "",
            show_notes_modal: true
        }); 
    }

    closeAssetNotesModal() {
        this.setState({
            asset_note_text_input: "",
            show_notes_modal: false
        });
    }

    onChangeAssetNote = (value) => {
        this.setState({
            asset_note_text_input: value
        });

    }

    handleAssetCostEnteredChange(e) {
        console.log(e);
        this.setState({
            asset_cost_entered: e
        });
    }

    handleSalvageCostEnteredChange(e) {
        this.setState({
            salvage_cost_entered: e
        });
    }

    handleDepeciationTypeSelectedChange(newValue) {
        this.setState({
            depreciation_type_selected: newValue
        });
    }


    handleImpactLevelChange(newValue) {
        this.setState({
            impact_level_selected: newValue
        });;
    }

    handleEndofLifeDateChange(date) {
        console.log(date);

        this.setState({
            end_of_life_date: date
        });
    }

    handleUsageTypeSelectedChange(newValue) {
        this.setState({
            usage_type_selected: newValue
        });
    }

    handleHardwareDomainSelectedChange(e) {
        this.setState({
            hardware_domain_selected: e.target.value
        });
    }
    
    handleHardwareAssetStateSelectedChange(newValue) {
        this.setState({
            hardware_asset_state_selected: newValue
        });
    }
    
    handleLastAuditDateChange(date) {
        this.setState({
            last_audit_date: date
        });
    }

    handleFirmwareEnteredChange(e) {
        this.setState({
            firmware_entered: e.target.value
        });
    }
    
    handleFirmwareVersionEnteredChange(e) {
        this.setState({
            firmware_version_entered: e.target.value
        });
    }
    
    handlePortsEnteredChange(e) {
        this.setState({
            ports_entered: e.target.value
        });
    }
    
    handleSubnetMaskEnteredChange(e) {
        this.setState({
            subnet_mask_entered: e.target.value
        });
    }

    handleCloudCostChange(e) {
        this.setState({
            cloud_cost_entered: e
        });
    }
    
    handleCloudLastAuditDateEnteredChange(date) {
        this.setState({
            cloud_last_audit_date_entered: date
        });
    }
    
    handleCloudRegionSelectedChange(newValue) {
        this.setState({
            cloud_region_selected: newValue
        });
    }
    
    handleCloudAvailabilityZoneSelectedChange(newValue) {
        this.setState({
            cloud_availability_zone_selected: newValue
        });
    }
    
    handleCloudProviderSelectedChange(newValue) {
        this.setState({
            cloud_provider_selected: newValue
        });
    }

    handleItemIdEnteredChange(e) {
        this.setState({
            item_id_entered: e.target.value
        });
    }
    
    handleItemNameEnteredChange(e) {
        this.setState({
            item_name_entered: e.target.value
        });
    }

    handleComputerOSSelectedChange(e) {
        this.setState({
            computer_os_selected: e.target.value
        });
    }
    
    handleComputerOSVersionEnteredChange(e) {
        this.setState({
            computer_os_version_entered: e.target.value
        });
    }
    
    handleComputerServicePackEnteredChange(e) {
        this.setState({
            computer_os_service_pack_entered: e.target.value
        });
    }
    
    handleComputerMemoryEnteredChange(e) {
        this.setState({
            computer_memory_entered: e
        });
    }
    
    handleComputerDiskSpaceEnteredChange(e) {
        this.setState({
            computer_disk_space_entered: e
        });
    }
    
    handleComputerCPUSpeedEnteredChange(e) {
        this.setState({
            computer_cpu_speed_entered: e.target.value
        });
    }
    
    handleComputerCPUCoreCountEnteredChange(e) {
        this.setState({
            computer_cpu_core_count_entered: e
        });
    }
    
    handleComputerUUIDEnteredChange(e) {
        this.setState({
            computer_uuid_entered: e.target.value
        });
    }
    
    handleComputerHostnameEnteredChange(e) {
        this.setState({
            computer_hostname_entered: e.target.value
        });
    }
    
    handleComputerLastLoginByEnteredChange(e) {
        this.setState({
            computer_last_login_by_entered: e.target.value
        });
    }

    handleConsumableStateSelectedChange(newValue) {
        this.setState({
            consumable_state_selected: newValue
        });
    }
    
    handleConsumableQuantityEnteredChange(e) {
        this.setState({
            consumable_quantity_entered: e
        });
    }

    handleDatabasePortEnteredChange(e) {
        this.setState({
            database_port_entered: e.target.value
        });
    }
    
    handleDatabaseEngineVersionEnteredChange(e) {
        this.setState({
            database_engine_version_entered: e.target.value
        });
    }
    
    handleDatabaseAllocatedStorageEnteredChange(e) {
        this.setState({
            database_allocated_storage_entered: e
        });
    }
    
    handleDatabaseMaxAllocatedStorageEnteredChange(e) {
        this.setState({
            database_max_allocated_storage_entered: e
        });
    }
    
    handleDatabaseEndpointEnteredChange(e) {
        this.setState({
            database_endpoint_entered: e.target.value
        });
    }
    
    handleDatabaseCreatedTimeEnteredChange(e) {
        this.setState({
            database_created_time_entered: e
        });
    }
    
    handleDatabaseMultipleAvailabilityZoneChange() {
        this.setState({
            database_multiple_availabilty_zone: !this.state.database_multiple_availabilty_zone
        });
    }
    
    handleDatabaseLicenseModelEnteredChange(e) {
        this.setState({
            database_license_model_entered: e.target.value
        });
    }
    
    handleDatabaseClassSelectedChange(newValue) {
        this.setState({
            database_class_selected: newValue
        });
    }
    
    handleDatabaseStatusSelectedChange(newValue) {
        this.setState({
            database_status_selected: newValue
        });
    }

    handleDatacenterStateSelectedChange(newValue) {
        this.setState({
            datacenter_state_selected: newValue
        });
    }

    handleDatastoreStateSelectedChange(newValue) {
        this.setState({
            datastore_state_selected: newValue
        });
    }
    
    handleDatastoreSizeEnteredChange(e) {
        this.setState({
            datastore_size_entered: e
        });
    }
    
    handleDatastoreFreeSpaceEnteredChange(e) {
        this.setState({
            datastore_free_space_entered: e
        });
    }
    
    handleDatastoreConnectionStateSelectedChange(newValue) {
        this.setState({
            datastore_connection_state_selected: newValue
        });
    }

    handleDiskDriveTypeSelectedChange(newValue) {
        this.setState({
            disk_drive_type_selected: newValue
        });
    }
    
    handleDiskSpaceEnteredChange(e) {
        this.setState({
            disk_space_entered: e.target.value
        });
    }
    
    handleDiskFreeSpaceEnteredChange(e) {
        this.setState({
            disk_free_space_entered: e.target.value
        });
    }
    
    handleDiskFreeSpaceCheckedOnChange(date) {
        this.setState({
            disk_free_space_checked_on: date
        });
    }

    handleDocumentStatusSelectedChange(newValue) {
        this.setState({
            document_status_selected: newValue
        });
    }
    
    handleDocumentTypeSelectedChange(newValue) {
        this.setState({
            document_type_selected: newValue
        });
    }
    
    handleDocumentVersionEnteredChange(e) {
        this.setState({
            document_version_entered: e.target.value
        });
    }

    handleHostStateSelectedChange(newValue) {
        this.setState({
            host_state_selected: newValue
        });
    }

    handleHostCreationTimestampEnteredChange(date) {
        this.setState({
            host_creation_timestamp_entered: date
        });
    }

    handleImageSourceEnteredChange(e) {
        this.setState({
            image_source_entered: e.target.value
        });
    }
    
    handleGuestOSSelectedChange(newValue) {
        this.setState({
            guest_os_selected: newValue
        });
    }

    handleDNSNameEnteredChange(e) {
        this.setState({
            dns_name_entered: e.target.value
        });
    }

    handleMobileOSSelectedChange(newValue) {
        this.setState({
            mobile_os_selected: newValue
        });
    }

    handleIMEINumberEnteredChange(e) {
        this.setState({
            imei_number_entered: e.target.value
        });
    }

    handleNetworkStateSelectedChange(newValue) {
        this.setState({
            network_state_selected: newValue
        });
    }
    
    handleNetworkConnectionStateSelectedChange(newValue) {
        this.setState({
            network_connection_state_selected: newValue
        });
    }
    
    handleBandwidthEnteredChange(e) {
        this.setState({
            bandwidth_entered: e.target.value
        });
    }
    
    handleNetworkRangeEnteredChange(e) {
        this.setState({
            network_range_entered: e.target.value
        });
    }

    handleNetworkInterfaceStateSelectedChange(newValue) {
        this.setState({
            network_interface_state_selected: newValue
        });
    }

    handlePrinterTypeSelectedChange(newValue) {
        this.setState({
            printer_type_selected: newValue
        });
    }

    handlePublicIPStateSelectedChange(newValue) {
        this.setState({
            public_ip_state_selected: newValue
        });
    }

    handleFootprintEnteredChange(e) {
        this.setState({
            footprint_entered: e.target.value
        });
    }
    
    handlePowerConsumptionEnteredChage(e) {
        this.setState({
            power_consumption_entered: e.target.value
        });
    }
    
    handleRackUnitsEnteredChange(e) {
        this.setState({
            rack_units_entered: e.target.value
        });
    }
    
    handleRackUnitsInUseEnteredChage(e) {
        this.setState({
            rack_units_in_use_entered: e.target.value
        });
    }

    handleResourcePoolStateSelectedChange(newValue) {
        this.setState({
            resource_pool_state_selected: newValue
        });
    }

    handleResourcePoolLastUpdatedChange(date) {
        this.setState({
            resource_pool_last_updated: date
        });
    }

    handleInboundRuleCountEnteredChange(e) {
        this.setState({
            inbound_rule_count_entered: e
        });
    }
    
    handleOutboundRuleCountEnteredChange(e) {
        this.setState({
            outbound_rule_count_entered: e
        });
    }

    handleHealthSelectedChange(newValue) {
        this.setState({
            health_selected: newValue
        });
    }
    
    handleSLAAvailabilityEnteredChange(e) {
        this.setState({
            sla_availability_entered: e
        });
    }
    
    handleServiceSupportHoursEnteredChange(e) {
        this.setState({
            service_support_hours_entered: e.target.value
        });
    }

    handleSystemOIDEnteredChange(e) {
        this.setState({
            system_oid_entered: e.target.value
        });
    }

    handleCIDRBlockEnteredChange(e) {
        this.setState({
            cidr_block_entered: e.target.value
        });
    }

    handleBatteryStatusSelectedChange(newValue) {
        this.setState({
            battery_status_selected: newValue
        });
    }
    
    handleBatteryVoltageEnteredChange(e) {
        this.setState({
            battery_voltage_entered: e.target.value
        });
    }
    
    handleBatteryCurrentEnteredChange(e) {
        this.setState({
            battery_current_entered: e.target.value
        });
    }

    handleInstanceTypeSelectedChange(newValue) {
        this.setState({
            instance_type_selected: newValue
        });
    }
    
    handleVMPrivateAddressEnteredChange(e) {
        this.setState({
            vm_private_address_entered: e.target.value
        });
    }
    
    handleVMPublicAddressEnteredChange(e) {
        this.setState({
            vm_public_address_entered: e.target.value
        });
    }
    
    handleVMStateSelectedChange(newValue) {
        this.setState({
            vm_state_selected: newValue
        });
    }
    
    handleVMOSNameEnteredChange(e) {
        this.setState({
            vm_os_name_entered: e.target.value
        });
    }

    handleVolumeTypeEnteredChange(e) {
        this.setState({
            volume_type_entered: e.target.value
        });
    }
    
    handleVolumeStateSelectedChange(newValue) {
        this.setState({
            volume_state_selected: newValue
        });
    }
    
    handleIOPSEnteredChange(e) {
        this.setState({
            iops_entered: e.target.value
        });
    }

    openDepartmentModal() {
        this.setState({
            department_name_entered: "",
            show_department_modal: true,
            canSeeDuplicateNameErrorCreateDepartment: false,
            canSeeErrorMessageCreateDepartment: false
        });
    }

    closeDepartmentModal() {
        this.setState({
            department_name_entered: "",
            show_department_modal: false,
            canSeeDuplicateNameErrorCreateDepartment: false,
            canSeeErrorMessageCreateDepartment: false
        });
    }

    handleCreateDepartmentNameChange = (e) =>  {
        this.setState({
            department_name_entered: e.target.value
        });
    }

    handleCreateManagingGroupNameChange = (e) => {
        this.setState({
            managing_group_name_entered: e.target.value
        });
    }

    handleLocationDescriptionChange(e) {
        this.setState({
            location_description_entered: e.target.value
        });
    }

    openManagingGroupModal() {
        this.setState({
            managing_group_name_entered: "",
            show_managing_group_modal: true,
            canSeeDuplicateNameErrorCreateManagingGroup: false,
            canSeeErrorMessageCreateManagingGroup: false
        });
    }

    closeManagingGroupModal() {
        this.setState({
            managing_group_name_entered: "",
            show_managing_group_modal: false,
            canSeeDuplicateNameErrorCreateManagingGroup: false,
            canSeeErrorMessageCreateManagingGroup: false
        });
    }

    handleAssignmentTimeChange(e) {
        this.setState({
            assignment_time: e
        });
    }

    toggleSection = (sectionName) => {
        this.setState((prevState) => ({
          [sectionName]: !prevState[sectionName],
        }));
    };

    // similar to getDepartments, but gets run on page load of the edit form and does not reset the selection to item 0 - selection has already been set by defaults
    async getInitialDepartments(tenantId) {
        let response = await HardwareAssetDataService.getDepartments(tenantId);
    
        console.log("Response from get initial departments: ", response);
    
        if (response.data.results.length > 0) {
            // prepend "None" option
            const departments = [{ id: 0, name_of_department: "None" }, ...response.data.results];
    
            // select the second item (index 1, after "None")
            //const selectedDept = departments[1];
    
            this.setState({
                departments,
                //department_id_selected: 0 //selectedDept.id
            });
        } else {
            this.setState({
                departments: [{ id: 0, name_of_department: "None" }],
                department_id_selected: 0
            });
        }
    }

    // gets the departments for selected tenant and populates the drop down menu
    async getDepartments(tenantId) {
        let response = await HardwareAssetDataService.getDepartments(tenantId);
    
        console.log("Response from get departments: ", response);
    
        if (response.data.results.length > 0) {
            // prepend "None" option
            const departments = [{ id: 0, name_of_department: "None" }, ...response.data.results];
    
            // select the second item (index 1, after "None")
            const selectedDept = departments[1];
    
            this.setState({
                departments,
                department_id_selected: 0 //selectedDept.id
            });
        } else {
            this.setState({
                departments: [{ id: 0, name_of_department: "None" }],
                department_id_selected: 0
            });
        }
    }
    // async getDepartments(tenantId, token) {
    //     let response = await HardwareAssetDataService.getDepartments(token, tenantId);

    //     console.log("Respons from get departments: ", response);

    //     if(response.data.results.length > 0) {
    //         this.setState({
    //             departments: [{id: 0, name_of_department: "None"}, ...response.data.results],
    //             department_id_selected: response.data.results[1].id,
    //             department_name_selected: response.data.results[1].name_of_department
    //         });
    //     }

    //     else {
    //         this.setState({
    //             departments: [{id: 0, name_of_department: "None"}],
    //             department_id_selected: 0,
    //             department_name_selected: "None"
    //         });
    //     }
    // }

    // similar to getManagingGroups, but is run once on page load of edit form and does not set the selected group - this has already been set
    async getInitialManagingGroups(tenantId) {
        let response = await HardwareAssetDataService.getManagingGroups(tenantId);
    
        console.log("Response from get initial managing groups: ", response);
    
        if (response.data.results.length > 0) {
            // prepend "None" option
            const managing_groups = [{ id: 0, name: "None" }, ...response.data.results];
    
            // select the second item (index 1, after "None")
            //const selectedGroup = managing_groups[1];
    
            this.setState({
                managing_groups,
                //managing_group_id_selected: 0 //selectedGroup.id
            });
        } else {
            this.setState({
                managing_groups: [{ id: 0, name: "None" }],
                managing_group_id_selected: 0
            });
        }
    }

    async getManagingGroups(tenantId) {
        let response = await HardwareAssetDataService.getManagingGroups(tenantId);
    
        console.log("Response from get managing groups: ", response);
    
        if (response.data.results.length > 0) {
            // prepend "None" option
            const managing_groups = [{ id: 0, name: "None" }, ...response.data.results];
    
            // select the second item (index 1, after "None")
            const selectedGroup = managing_groups[1];
    
            this.setState({
                managing_groups,
                managing_group_id_selected: 0 //selectedGroup.id
            });
        } else {
            this.setState({
                managing_groups: [{ id: 0, name: "None" }],
                managing_group_id_selected: 0
            });
        }
    }

    async submitCreateDepartmentForm() {
        console.log("Values submitting to backend");
        console.log("Name: ", this.state.department_name_entered);

        if(this.state.department_name_entered === "") {
            this.setState({
                canSeeDuplicateNameErrorCreateDepartment: false,
                canSeeErrorMessageCreateDepartment: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateDepartment: false
            });

            // check for duplicate department
            let dupeResponse = await HardwareAssetDataService.checkForDuplicateDepartment(this.state.department_name_entered, this.state.selected_tenant_id);
            if (dupeResponse.data.results === "DUPLICATE FOUND") {
                this.setState({
                    canSeeDuplicateNameErrorCreateDepartment: true
                });
            }

            else if (dupeResponse.data.results === "NO DUPLICATE FOUND") {
                this.setState({
                    canSeeDuplicateNameErrorCreateDepartment: false
                });

                // send data to backend for processing
                let data = {
                    name: this.state.department_name_entered,
                    tenantId: this.state.selected_tenant_id     // we're now saving vendors by tenant for better multitenancy
                };


                let addResponse = await HardwareAssetDataService.createDepartment(data);
                await this.getDepartments(this.state.selected_tenant_id);
                this.closeDepartmentModal();

            }
            
        }
    }

    async submitCreateManagingGroupForm() {
        console.log("Values submitting to backend");
        console.log("Name: ", this.state.managing_group_name_entered);

        if(this.state.managing_group_name_entered === "") {
            this.setState({
                canSeeDuplicateNameErrorCreateManagingGroup: false,
                canSeeErrorMessageCreateManagingGroup: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateManagingGroup: false
            });

            // check for duplicate group

            let dupeResponse = await HardwareAssetDataService.checkForDuplicateManagingGroup(this.state.managing_group_name_entered, this.state.selected_tenant_id);
            if (dupeResponse.data.results === "DUPLICATE FOUND") {
                this.setState({
                    canSeeDuplicateNameErrorCreateManagingGroup: true
                });
            }

            else if (dupeResponse.data.results === "NO DUPLICATE FOUND") {
                this.setState({
                    canSeeDuplicateNameErrorCreateManagingGroup: false
                });

                // send data to backend for processing
                let data = {
                    name: this.state.managing_group_name_entered,
                    tenantId: this.state.selected_tenant_id     // we're now saving vendors by tenant for better multitenancy
                };


                let addResponse = await HardwareAssetDataService.createManagingGroup(data);
                await this.getManagingGroups(this.state.selected_tenant_id);
                this.closeManagingGroupModal();

            }
        }
    }


    submitCreateVendorForm() {
        console.log("Values submitting to backend")
        console.log("Name: ", this.state.vendor_name_entered);

        if (this.state.vendor_name_entered === "") {
            this.setState({
                canSeeDuplicateNameErrorCreateVendor: false,
                canSeeErrorMessageCreateVendor: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateVendor: false
            });

            // check for duplicate vendor
            HardwareAssetDataService.checkForDuplicateVendor(this.state.vendor_name_entered, this.props.loggedStatus.primary_tenant_id).then(response => {
                if (response.data.results === "DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateVendor: true
                    });
                }

                else if (response.data.results === "NO DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateVendor: false
                    });

                    // send data to backend for processing
                    let data = {
                        vendorName: this.state.vendor_name_entered,
                        tenantId: this.props.loggedStatus.primary_tenant_id     // we're now saving vendors by tenant for better multitenancy
                    };

                    HardwareAssetDataService.createVendor(data).then(response => {
                        this.getVendors(this.props.loggedStatus.primary_tenant_id).then(response => {
                            this.setState({
                                vendors: [{ id: 0, name_of_vendor: "None" }, ...response.results],
                                selected_vendor_id: 0
                            });

                            this.closeVendorModal();
                        })
                            .catch(e => {
                                console.log(e);
                            });
                    })
                        .catch(e => {
                            console.log(e);
                        })

                }
            })
                .catch(e => {
                    console.log(e);
                });

        }
    }

    submitCreateLocationForm() {
        console.log("Values submitting to backend");
        console.log("Site Id: ", this.state.selected_site_id);
        console.log("Floor: ", this.state.location_floor_entered);
        console.log("Aisle: ", this.state.location_aisle_entered);
        console.log("Desk: ", this.state.location_desk_entered);

        if (this.state.selected_site_id === 0 || this.state.location_floor_entered === "" || this.state.location_aisle_entered === "" || this.state.location_desk_entered === "") {
            this.setState({
                canSeeDuplicateNameErrorCreateLocation: false,
                canSeeErrorMessageCreateLocation: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateLocation: false
            });

            // check for duplicate entry
            HardwareAssetDataService.checkForDuplicateLocation(this.state.location_floor_entered, this.state.location_aisle_entered, this.state.location_desk_entered, this.state.selected_site_id).then(response => {
                if (response.data.results === "DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateLocation: true
                    });
                }

                else if (response.data.results === "NO DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateLocation: false
                    });

                    // send data to backend for processing
                    let data = {
                        siteId: this.state.selected_site_id,
                        floorNumber: this.state.location_floor_entered,
                        aisleNumber: this.state.location_aisle_entered,
                        deskNumber: this.state.location_desk_entered
                    };

                    HardwareAssetDataService.createLocation(data).then(response => {
                        this.getLocations(this.state.selected_site_id).then(response => {
                            this.setState({
                                locations_at_site: [{ id: 0, floor_number: "None", aisle_number: "None", desk_number: "None" }, ...response.results],
                                selected_location_in_building_id: 0
                            });

                            this.closeLocationModal();
                        })
                            .catch(e => {
                                console.log(e);
                            });
                    })
                        .catch(e => {
                            console.log(e);
                        });

                }
            })
                .catch(e => {
                    console.log(e);
                });
        }
    }

    submitCreateSiteForm() {
        console.log("Values submitting to backend");
        console.log("Tenant Id: ", this.state.selected_tenant_id);
        console.log("Site Name: ", this.state.site_name_entered);
        console.log("Street Address: ", this.state.site_street_address_entered);
        console.log("City: ", this.state.site_city_entered);
        console.log("State: ", this.state.site_state_entered);
        console.log("Zip Code: ", this.state.site_zip_code_entered);

        if (this.state.selected_tenant_id === 0 || this.state.site_name_entered === "") {
            this.setState({
                canSeeDuplicateNameErrorCreateSite: false,
                canSeeErrorMessageCreateSite: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateSite: false
            });

            // check for duplicate name
            HardwareAssetDataService.checkForDuplicateSiteName(this.state.site_name_entered, this.state.selected_tenant_id).then(response => {
                if (response.data.results === "DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateSite: true
                    });
                }

                else if (response.data.results === "NO DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateSite: false
                    });

                    // send form data to backend

                    let data = {
                        tenantId: this.state.selected_tenant_id,
                        siteName: this.state.site_name_entered,
                        streetAddress: this.state.site_street_address_entered,
                        city: this.state.site_city_entered,
                        state: this.state.site_state_entered,
                        zipCode: this.state.site_zip_code_entered
                    };

                    HardwareAssetDataService.createSite(data).then(response => {
                        this.getSites(this.state.selected_tenant_id).then(response => {
                            this.setState({
                                sites: [{id: 0, name_of_site: "None"}, ...response.results]
                            });

                            if (response.results && response.results.length > 0) {
                                this.setState({
                                    selected_site_id: response.results[0].id
                                });
                            }

                            else {
                                this.setState({
                                    selected_site_id: 0
                                });
                            }

                            this.closeSiteModal();

                        })
                            .catch(e => {
                                console.log(e);
                            });
                    })
                        .catch(e => {
                            console.log(e);
                        });

                }
            })
                .catch(e => {
                    console.log(e);
                });

        }

    }

    submitCreateManufacturerForm() {
        console.log("Values submitting to backend");
        console.log("Manufacturer name: ", this.state.manufacturer_name_entered);
        console.log("Manufacturer type: ", this.state.manufacturer_type_entered);       // going to be hardcoded to Hardware now
        console.log("Phone number: ", this.state.manufacturer_phone_number_entered);

        if (this.state.manufacturer_name_entered === "" /* || this.state.manufacturer_type_entered === "" */) {
            this.setState({
                canSeeDuplicateNameErrorCreateManufacturer: false,
                canSeeErrorMessageCreateManufacturer: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateManufacturer: false
            });

            // check for duplicate name / type combo on this tenant
            HardwareAssetDataService.checkForDuplicateManufacturer(this.state.manufacturer_name_entered, "Hardware", this.state.selected_tenant_id).then(response => {

                if (response.data.results === "DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateManufacturer: true
                    });
                }

                else if (response.data.results === "NO DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateManufacturer: false
                    });

                    // send form data to backend

                    let data = {
                        manufacturerName: this.state.manufacturer_name_entered,
                        manufacturerType: "Hardware", //this.state.manufacturer_type_entered,       decided to hardcode this value as form field was confusing
                        phoneNumber: this.state.manufacturer_phone_number_entered,
                        tenantId: this.state.selected_tenant_id
                    };

                    HardwareAssetDataService.createManufacturer(data).then(response => {
                        this.getManufacturers().then(response => {
                            this.setState({
                                manufacturers: response.results,
                                manufacturer_name_entered: "",      // reset form fields
                                manufacturer_type_entered: "",
                                manufacturer_phone_number_entered: ""
                            });

                            if (response.results && response.results.length > 0) {
                                this.setState({
                                    manufacturer_id_selected: response.results[0].id
                                });
                            }

                            else {
                                this.setState({
                                    manufacturer_id_selected: 0
                                });
                            }

                            this.closeManufacturerModal();
                        })
                            .catch(e => {
                                console.log(e);
                            })
                    })
                        .catch(e => {
                            console.log(e);
                        });

                }


            })
                .catch(e => {
                    console.log(e);
                });
        }
    }

    submitCreateModelForm() {
        console.log("Values submitting to backend");
        console.log("Model Name: ", this.state.model_name_entered);
        console.log("Type id: ", this.state.selected_type_id);
        console.log("Cost: ", this.state.cost_entered);
        console.log("Manufacturer id: ", this.state.manufacturer_id_selected_create_model_form);

        if (this.state.model_name_entered === "" || this.state.selected_type_id === 0 || this.state.manufacturer_id_selected_create_model_form === 0) {
            this.setState({
                canSeeDuplicateNameErrorCreateModel: false,
                canSeeErrorMessageCreateModel: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateModel: false
            });


            // Check for duplicate model name
            HardwareAssetDataService.checkForDuplicateModelName(this.state.model_name_entered).then(response => {
                if (response.data.results === "DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateModel: true
                    });
                }

                else if (response.data.results === "NO DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateModel: false
                    });

                    // submit form data to backend for add

                    let data = {
                        modelName: this.state.model_name_entered,
                        typeId: this.state.selected_type_id,
                        cost: this.state.cost_entered,
                        manufacturerId: this.state.manufacturer_id_selected_create_model_form
                    };

                    HardwareAssetDataService.createModel(data).then(response => {
                        // update the model list
                        this.getModels(this.state.selected_type_id, this.state.manufacturer_id_selected).then(response => {
                            this.setState({
                                model_names: response.results,
                                model_name_entered: "",         // reset form fields
                                cost_entered: "",
                            });

                            if (response.results && response.results.length > 0) {
                                this.setState({
                                    selected_model_id: response.results[0].id
                                });
                            }

                            else {
                                this.setState({
                                    selected_model_id: 0
                                });
                            }

                            // reset the type id selected field of model form
                            if (this.state.asset_types && this.state.asset_types.length > 0) {
                                this.setState({
                                    model_type_id_selected: this.state.asset_types[0].id
                                });
                            }

                            else {
                                this.setState({
                                    model_type_id_selected: 0
                                });
                            }

                            // reset the manufacturer id selected field of model form
                            if (this.state.manufacturers && this.state.manufacturers.length > 0) {
                                this.setState({
                                    manufacturer_id_selected_create_model_form: this.state.manufacturers[0].id
                                });
                            }

                            else {
                                this.setState({
                                    manufacturer_id_selected_create_model_form: 0
                                });
                            }

                            this.closeModelModal();
                        })
                            .catch(e => {
                                console.log(e);
                            })
                    })
                        .catch(e => {
                            console.log(e);
                        });

                }
            })
                .catch(e => {
                    console.log(e);
                });
        }

    }

    submitAssetNote() {
            //console.log("Pushed submit");
            let data = {
                noteText: this.state.asset_note_text_input,
                tenantId: this.state.asset.tenant_id,       // using the tenant of the ASSET for assignment - not the tenant of the creator
                associatedAssetId: this.state.asset.id,
                creatorId: this.props.loggedStatus.id
            };
    
            if(this.state.asset_note_text_input && this.state.asset_note_text_input.length > 0) {
                this.setState({
                    showSaving: true,
                    show_notes_modal: false
                });
    
                
                HardwareAssetDataService.createAssetNote( data).then(response => {
                    // ask for the updated note information here
                    this.getAssetDetails(this.props.match.params.id, this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                        console.log("Response back after create note: ", response);
                        this.setState({
                            //notes: response.asset_notes
                        }, () => {
                            // create a history event for this asset
                            let historyData = {
                                assetId: this.state.asset.id,
                                creatorId: this.props.loggedStatus.id,  
                                itemText: "Asset Note Created", 
                                itemType: "Edit"
                            };
    
    
                            HardwareAssetDataService.createHistoryEvent(historyData).then(response => {
                                this.getHistoryDetails(this.state.asset.id).then(response => {
                                    this.setState({
                                        history: response.results,
                                        showSaving: false
                                    }, () => this.closeAssetNotesModal());
                                })
                            })
                            .catch(e => {
                                console.log(e);
                            });
    
                        });
                    })
                    .catch(e => {
                        console.log(e);
                    })
                })
                .catch(e => {
                    console.log(e);
                })
            }
            
    
            else {
                console.log("No note text input");
            }
        }

    submitCreateTypeForm() {
        console.log("Values submitting to backend");
        console.log("Type Name: ", this.state.type_name_entered);
        console.log("Is Core: ", this.state.selected_is_core_value);

        // First, ensure that all required form fields are filled out
        if (this.state.type_name_entered === "") {
            this.setState({
                canSeeDuplicateNameErrorCreateType: false,
                canSeeErrorMessageCreateType: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateType: false
            });

            // now tracking the tenant id information
            let tenant_id = this.state.selected_tenant_id;

            // Check for duplicate type name
            HardwareAssetDataService.checkForDuplicateTypeName(this.state.type_name_entered, tenant_id).then(response => {
                // If duplicate, show an error message
                if (response.data.results === "DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateType: true
                    });
                }

                else if (response.data.results === "NO DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateType: false
                    });

                    // submit form to backend for add

                    let data = {
                        typeName: this.state.type_name_entered,
                        isCore: this.state.selected_is_core_value,
                        isCustom: 1,
                        tenantId: tenant_id
                    };

                    HardwareAssetDataService.createType(data).then(response => {
                        this.getHardwareAssetTypes(this.props.hardwareAssetFilter.selectedHardwareAssetCustomerId).then(response => {

                            let type_array_to_use;

                            if(this.state.asset_field_settings.asset_types_to_show !== null) {
                                console.log("You'll be setting the specific type selections here");
                                // the string is comma separated, need to turn that into an array for asset_types population
                                // need to use the old default values to determine the id numbers of these

                                const sortedArray = this.state.asset_field_settings.asset_types_to_show
                                .split(",")                       // Split string into an array by comma
                                .map(item => item.trim())         // Remove extra whitespace around items
                                .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })); // Case-insensitive sort

                                // go through the original set of asset types that includes all of them and only include ones that appear in the array specified in the settings field
                                const filteredObjects = response.results.filter(obj => 
                                    sortedArray.includes(obj.name_of_type) || obj.tenant_id != null
                                );

                                type_array_to_use = filteredObjects;

                                //console.log("Original value of specific types to display: ", this.state.asset_field_settings.asset_types_to_show);
                                //console.log("Sorted array version: ", sortedArray);
                                //console.log("Original full default values: ", response.results);

                                // this.setState({
                                //     asset_types: filteredObjects
                                // });
                            }

                            else {
                                type_array_to_use = response.results;
                            }

                            this.setState({
                                asset_types: type_array_to_use,
                                type_name_entered: "",              // reset form fields
                                selected_is_core_value: true
                            });

                            if (response.results && response.results.length > 0) {
                                this.setState({
                                    selected_type_id: response.results[0].id,
                                    selected_assigned_asset_type_id: response.results[0].id,
                                    model_type_id_selected: response.results[0].id
                                });

                                // Get the models for that type
                                this.getModels(response.results[0].id, this.state.manufacturer_id_selected).then(response => {
                                    if (response.results && response.results.length > 0) {
                                        this.setState({
                                            model_names: response.results,
                                            selected_model_id: response.results[0].id
                                        });
                                    }

                                    else {
                                        this.setState({
                                            model_names: response.results,
                                            selected_model_id: 0
                                        });
                                    }
                                })
                                    .catch(e => {
                                        console.log(e);
                                    });
                            }

                            else {
                                this.setState({
                                    asset_types: response.results,
                                    selected_type_id: 0,
                                    selected_assigned_asset_type_id: 0,
                                    model_type_id_selected: 0,
                                    model_names: []
                                });
                            }

                            // if(response.results && response.results.length > 0) {
                            //     this.setState({
                            //         selected_type_id: response.results[0].id,
                            //         selected_assigned_asset_type_id: response.results[0].id
                            //     }, () => {
                            //         this.closeTypeModal();
                            //     });
                            // }

                            //else {
                            this.closeTypeModal();
                            //}

                        })
                            .catch(e => {
                                console.log(e);
                            });
                    })
                        .catch(e => {
                            console.log(e);
                        });
                }
            })
                .catch(e => {
                    console.log(e);
                });
        }
    }

    submitCreateCategoryForm() {
        console.log("Values submitting to backend");
        console.log("Category Name: ", this.state.createCategory_category_name_entered);

        // First, ensure that all required form fields are filled out
        if (this.state.createCategory_category_name_entered === "") {
            this.setState({
                canSeeDuplicateNameErrorCreateCategory: false,
                canSeeErrorMessageCreateCategory: true
            });
        }

        else {

            this.setState({
                canSeeErrorMessageCreateCategory: false
            });

            // Check for duplicate category name
            HardwareAssetDataService.checkForDuplicateCategoryName(this.state.createCategory_category_name_entered).then(response => {

                // If duplicate, show an error message
                if (response.data.results === "DUPLICATE FOUND") {
                    this.setState({
                        canSeeDuplicateNameErrorCreateCategory: true
                    });
                }

                // If not duplicate, submit entire form for asset add
                else if (response.data.results === "NO DUPLICATE FOUND") {

                    this.setState({
                        canSeeDuplicateNameErrorCreateCategory: false
                    });

                    // submit form to backend for add

                    let data = {
                        categoryName: this.state.createCategory_category_name_entered
                    };

                    HardwareAssetDataService.createCategory(data).then(response => {
                        // fetch the category names again for drop down so they update
                        this.getCategories().then(response => {
                            this.setState({
                                asset_categories: response.results,
                                createCategory_category_name_entered: ""    // reset form fields
                            });

                            if (response.results && response.results.length > 0) {
                                this.setState({
                                    selected_assigned_asset_category_id: response.results[0].id,
                                    selected_category_id: response.results[0].id
                                });
                            }

                            else {
                                this.setState({
                                    selected_assigned_asset_category_id: 0,
                                    selected_category_id: 0
                                });
                            }

                            // if(response.results && response.results.length > 0) {
                            //     this.setState({
                            //         selected_assigned_asset_category_id: response.results[0].id,
                            //         selected_category_id: response.results[0].id
                            //     }, () => {
                            //         // close the category modal
                            //         this.closeCategoryModal();
                            //     });
                            // }

                            //else {
                            this.closeCategoryModal();
                            //}

                        })
                            .catch(e => {
                                console.log(e);
                            });
                    })
                        .catch(e => {
                            console.log(e);
                        });

                }

            })
                .catch(e => {
                    console.log(e);
                });

        }

    }



    // after the UI rework, submitEditAssetForm now also handles ADD asset as well - which path is chosen depends on the value of this.state.interaction_mode
    submitEditAssetForm() {
        // console.log("Values submitting to backend");
        // console.log("Tenant id: ", this.state.selected_tenant_id);
        // console.log("Asset Name Entered: ", this.state.asset_name_entered);
        // console.log("Category Id: ", this.state.selected_category_id);
        // console.log("Type id: ", this.state.selected_type_id);
        // console.log("Model id: ", this.state.selected_model_id);
        // console.log("Site id: ", this.state.selected_site_id);
        // console.log("Location at site id: ", this.state.selected_location_in_building_id);
        // console.log("Person id: ", this.state.selected_person_id);
        // console.log("Vendor id: ", this.state.selected_vendor_id);
        // console.log("Asset tag: ", this.state.asset_tag_entered);
        // console.log("Serial Number: ", this.state.serial_number_entered);
        // console.log("Barcode: ", this.state.barcode_entered);
        // console.log("IP Address: ", this.state.ip_address_entered);
        // console.log("MAC Address: ", this.state.mac_address_entered);
        // console.log("RAM: ", this.state.ram_entered);
        // console.log("CPU: ", this.state.cpu_entered);
        // console.log("Aquisition Date: ", this.state.aquisition_date_entered);
        // console.log("Website: ", this.state.website_entered);
        // console.log("Warranty Start: ", this.state.warranty_start_date_entered);
        // console.log("Warranty end: ", this.state.warranty_end_date_entered);
        // console.log("Lease Start: ", this.state.lease_start_date_entered);
        // console.log("Lease End: ", this.state.lease_end_date_entered);
        // console.log("Track Asset: ", this.state.track_asset);
        // console.log("Is Peripheral: ", this.state.is_peripheral);
        // console.log("Contract Number: ", this.state.contract_number_entered);


        // console.log("Selected assigned asset category id: ", this.state.selected_assigned_asset_category_id);
        // console.log("Selected assigned asset type id: ", this.state.selected_assigned_asset_type_id);
        // console.log("Selected assigned asset name id: ", this.state.selected_assigned_asset_name_id);

        this.setState({
            showSaving: true
        });

        const { attachments } = this.state;
        if (!attachments || attachments.length === 0) {
          console.log("No files to upload");
          //return;
        }
      
        // Create a FormData object
        const formData = new FormData();
      
        // // Append each file (use same key if backend expects array)
        // attachments.forEach((file, index) => {
        //   formData.append("attachments[]", file); // "attachments[]" is common for arrays
        // });

        formData.append("selected_tenant_id", this.state.selected_tenant_id);
        formData.append("asset_name_entered", this.state.asset_name_entered);
        formData.append("selected_category_id", this.state.selected_category_id);
        formData.append("selected_type_id", this.state.selected_type_id);
        //formData.append("selected_type_name", this.state.selected_type_name);
        formData.append("selected_model_id", this.state.selected_model_id);
        formData.append("selected_site_id", this.state.selected_site_id);
        //formData.append("selected_location_in_building_id", this.state.selected_location_in_building_id);
        formData.append("selected_person_id", this.state.selected_person_id);
        formData.append("selected_vendor_id", this.state.selected_vendor_id);
        formData.append("asset_tag_entered", this.state.asset_tag_entered);
        formData.append("serial_number_entered", this.state.serial_number_entered);
        formData.append("barcode_entered", this.state.barcode_entered);
        formData.append("ip_address_entered", this.state.ip_address_entered);
        formData.append("mac_address_entered", this.state.mac_address_entered);
        formData.append("ram_entered", this.state.ram_entered);
        formData.append("cpu_entered", this.state.cpu_entered);
        formData.append("aquisition_date_entered", this.toMySQLDate(this.state.aquisition_date_entered));
        formData.append("website_entered", this.state.website_entered);
        formData.append("warranty_start_date_entered", this.toMySQLDate(this.state.warranty_start_date_entered));
        formData.append("warranty_end_date_entered", this.toMySQLDate(this.state.warranty_end_date_entered));
        formData.append("lease_start_date_entered", this.toMySQLDate(this.state.lease_start_date_entered));
        formData.append("lease_end_date_entered", this.toMySQLDate(this.state.lease_end_date_entered));
        formData.append("track_asset", this.state.track_asset);
        formData.append("is_peripheral", this.state.is_peripheral);
        formData.append("contract_number_entered", this.state.contract_number_entered);

        formData.append("impact_level_selected", this.state.impact_level_selected);
        formData.append("end_of_life_date", this.toMySQLDate(this.state.end_of_life_date));
        formData.append("location_description_entered", this.state.location_description_entered);
        formData.append("department_id_selected", this.state.department_id_selected);
        //formData.append("department_name_selected", this.state.department_name_selected);
        formData.append("managing_group_id_selected", this.state.managing_group_id_selected);
        //formData.append("managing_group_name_selected", this.state.managing_group_name_selected);
        formData.append("selected_managing_person_id", this.state.selected_managing_person_id);
        formData.append("assignment_time", this.toMySQLDateTime(this.state.assignment_time));
        formData.append("quote_status_entered", this.state.quote_status_entered);
        formData.append("renewal_status_entered", this.state.renewal_status_entered);
        //formData.append("attachments", this.state.attachments);
        formData.append("asset_cost_entered", this.state.asset_cost_entered);
        formData.append("salvage_cost_entered", this.state.salvage_cost_entered);
        formData.append("depreciation_type_selected", this.state.depreciation_type_selected);
        formData.append("usage_type_selected", this.state.usage_type_selected);
        formData.append("hardware_domain_selected", this.state.hardware_domain_selected);
        formData.append("hardware_asset_state_selected", this.state.hardware_asset_state_selected);
        formData.append("last_audit_date", this.toMySQLDateTime(this.state.last_audit_date));
        formData.append("firmware_entered", this.state.firmware_entered);
        formData.append("firmware_version_entered", this.state.firmware_version_entered);
        formData.append("ports_entered", this.state.ports_entered);
        formData.append("subnet_mask_entered", this.state.subnet_mask_entered);
        formData.append("cloud_cost_entered", this.state.cloud_cost_entered);
        formData.append("cloud_last_audit_date_entered", this.toMySQLDateTime(this.state.cloud_last_audit_date_entered));
        formData.append("cloud_region_selected", this.state.cloud_region_selected);
        formData.append("cloud_availability_zone_selected", this.state.cloud_availability_zone_selected);
        formData.append("cloud_provider_selected", this.state.cloud_provider_selected);
        formData.append("item_id_entered", this.state.item_id_entered);
        formData.append("item_name_entered", this.state.item_name_entered);
        formData.append("computer_os_selected", this.state.computer_os_selected);
        formData.append("computer_os_version_entered", this.state.computer_os_version_entered);
        formData.append("computer_os_service_pack_entered", this.state.computer_os_service_pack_entered);
        formData.append("computer_memory_entered", this.state.computer_memory_entered);
        formData.append("computer_disk_space_entered", this.state.computer_disk_space_entered);
        formData.append("computer_cpu_speed_entered", this.state.computer_cpu_speed_entered);
        formData.append("computer_cpu_core_count_entered", this.state.computer_cpu_core_count_entered);
        formData.append("computer_uuid_entered", this.state.computer_uuid_entered);
        formData.append("computer_hostname_entered", this.state.computer_hostname_entered);
        formData.append("computer_last_login_by_entered", this.state.computer_last_login_by_entered);
        formData.append("consumable_state_selected", this.state.consumable_state_selected);
        formData.append("consumable_quantity_entered", this.state.consumable_quantity_entered);
        formData.append("database_port_entered", this.state.database_port_entered);
        formData.append("database_engine_version_entered", this.state.database_engine_version_entered);
        formData.append("database_allocated_storage_entered", this.state.database_allocated_storage_entered);
        formData.append("database_max_allocated_storage_entered", this.state.database_max_allocated_storage_entered);
        formData.append("database_endpoint_entered", this.state.database_endpoint_entered);
        formData.append("database_created_time_entered", this.toMySQLDateTime(this.state.database_created_time_entered));
        formData.append("database_multiple_availabilty_zone", this.state.database_multiple_availabilty_zone);
        formData.append("database_license_model_entered", this.state.database_license_model_entered);
        formData.append("database_class_selected", this.state.database_class_selected);
        formData.append("database_status_selected", this.state.database_status_selected);
        formData.append("datacenter_state_selected", this.state.datacenter_state_selected);
        formData.append("datastore_state_selected", this.state.datastore_state_selected);
        formData.append("datastore_size_entered", this.state.datastore_size_entered);
        formData.append("datastore_free_space_entered", this.state.datastore_free_space_entered);
        formData.append("datastore_connection_state_selected", this.state.datastore_connection_state_selected);
        formData.append("disk_drive_type_selected", this.state.disk_drive_type_selected);
        formData.append("disk_space_entered", this.state.disk_space_entered);
        formData.append("disk_free_space_entered", this.state.disk_free_space_entered);
        formData.append("disk_free_space_checked_on", this.toMySQLDateTime(this.state.disk_free_space_checked_on));
        formData.append("document_status_selected", this.state.document_status_selected);
        formData.append("document_type_selected", this.state.document_type_selected);
        formData.append("document_version_entered", this.state.document_version_entered);
        formData.append("host_state_selected", this.state.host_state_selected);
        formData.append("host_creation_timestamp_entered", this.toMySQLDateTime(this.state.host_creation_timestamp_entered));
        formData.append("image_source_entered", this.state.image_source_entered);
        formData.append("guest_os_selected", this.state.guest_os_selected);
        formData.append("dns_name_entered", this.state.dns_name_entered);
        formData.append("mobile_os_selected", this.state.mobile_os_selected);
        formData.append("imei_number_entered", this.state.imei_number_entered);
        formData.append("network_state_selected", this.state.network_state_selected);
        formData.append("network_connection_state_selected", this.state.network_connection_state_selected);
        formData.append("bandwidth_entered", this.state.bandwidth_entered);
        formData.append("network_range_entered", this.state.network_range_entered);
        formData.append("network_interface_state_selected", this.state.network_interface_state_selected);
        formData.append("printer_type_selected", this.state.printer_type_selected);
        formData.append("public_ip_state_selected", this.state.public_ip_state_selected);
        formData.append("footprint_entered", this.state.footprint_entered);
        formData.append("power_consumption_entered", this.state.power_consumption_entered);
        formData.append("rack_units_entered", this.state.rack_units_entered);
        formData.append("rack_units_in_use_entered", this.state.rack_units_in_use_entered);
        formData.append("resource_pool_state_selected", this.state.resource_pool_state_selected);
        formData.append("resource_pool_last_updated", this.state.resource_pool_last_updated);
        formData.append("inbound_rule_count_entered", this.state.inbound_rule_count_entered);
        formData.append("outbound_rule_count_entered", this.state.outbound_rule_count_entered);
        formData.append("health_selected", this.state.health_selected);
        formData.append("sla_availability_entered", this.state.sla_availability_entered);
        formData.append("service_support_hours_entered", this.state.service_support_hours_entered);
        formData.append("system_oid_entered", this.state.system_oid_entered);
        formData.append("cidr_block_entered", this.state.cidr_block_entered);
        formData.append("battery_status_selected", this.state.battery_status_selected);
        formData.append("battery_voltage_entered", this.state.battery_voltage_entered);
        formData.append("battery_current_entered", this.state.battery_current_entered);
        formData.append("instance_type_selected", this.state.instance_type_selected);
        formData.append("vm_private_address_entered", this.state.vm_private_address_entered);
        formData.append("vm_public_address_entered", this.state.vm_public_address_entered);
        formData.append("vm_state_selected", this.state.vm_state_selected);
        formData.append("vm_os_name_entered", this.state.vm_os_name_entered);
        formData.append("volume_type_entered", this.state.volume_type_entered);
        formData.append("volume_state_selected", this.state.volume_state_selected);
        formData.append("iops_entered", this.state.iops_entered);

        // Extra Crowdstrike fields
        formData.append("os_build_entered", this.state.os_build_entered);
        formData.append("average_memory_utilization_entered", this.state.average_memory_utilization_entered);
        formData.append("disk_in_use_entered", this.state.disk_in_use_entered);
        formData.append("drive_encryption_status_selected", this.state.drive_encryption_status_selected);
        //formData.append("cpu_entered", this.state.cpu_entered);
        formData.append("average_processor_utlization_entered", this.state.average_processor_utlization_entered);
        formData.append("internal_ip_address_entered", this.state.internal_ip_address_entered);
        formData.append("last_login_timestamp_entered", this.state.last_login_timestamp_entered);
        
        formData.append("physical_location_entered", this.state.physical_location_entered);
        formData.append("ad_ou_entered", this.state.ad_ou_entered);

        formData.append("connection_types_entered", this.state.connection_types_entered);

        //formData.append("selected_assigned_asset_category_id", this.state.selected_assigned_asset_category_id);
        //formData.append("selected_assigned_asset_type_id", this.state.selected_assigned_asset_type_id);
        formData.append("selected_assigned_asset_name_id", this.state.selected_assigned_asset_name_id);

        formData.append("maintenance_dates", this.state.maintenance_dates_entered);

        formData.append("description_entered", this.state.description_entered);

        // Extra fields from Tony
        formData.append("asset_code_entered", this.state.asset_code_entered);
        formData.append("invoice_number_entered", this.state.invoice_number_entered);
        formData.append("order_number_entered", this.state.order_number_entered);

        // Power Details fields
        formData.append("power_type_entered", this.state.power_type_entered === null ? "" : this.state.power_type_entered);
        formData.append("kasa_name_entered", this.state.kasa_name_entered);
        formData.append("kasa_mac_address_entered", this.state.kasa_mac_address_entered);
        formData.append("kasa_ip_address_entered", this.state.kasa_ip_address_entered);
        formData.append("kasa_outlet_id_entered", this.state.kasa_outlet_id_entered);
        formData.append("kasa_plug_number_entered", this.state.kasa_plug_number_entered);
        formData.append("pdu_name_entered", this.state.pdu_name_entered);
        formData.append("pdu_ip_address_entered", this.state.pdu_ip_address_entered);
        formData.append("pdu_outlet_id_entered", this.state.pdu_outlet_id_entered);

        if(this.state.interaction_mode === "edit") {
            formData.append("asset_id", this.props.match.params.id);
        }

        // Append each file (use same key if backend expects array)
        attachments.forEach((file, index) => {
          formData.append("attachments[]", file); // "attachments[]" is common for arrays
        });

        // Log all key-value pairs
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }


        // First, ensure that all required form fields are filled out
        if (this.state.selected_tenant_id === 0 || this.state.asset_name_entered === "" || this.state.selected_category_id === 0 || this.state.selected_type_id === 0 || this.state.selected_model_id === 0 /* || this.state.selected_site_id === 0  */|| (this.state.is_peripheral && this.state.selected_assigned_asset_name_id === 0)) {
            this.setState({
                canSeeDuplicateNameError: false,
                canSeeErrorMessage: true,
                showSaving: false
            });
        }

        else {
            this.setState({
                canSeeErrorMessage: false
            });


            if(this.state.interaction_mode === "edit") {
                // Then, send entered asset name through to backend to check for duplicate
                HardwareAssetDataService.checkForDuplicateAssetNameEditVersion(this.state.asset_name_entered, this.props.match.params.id, this.state.selected_tenant_id).then(response => {

                    // If duplicate, show an error message
                    if (response.data.results === "DUPLICATE FOUND") {
                        this.setState({
                            canSeeDuplicateNameError: true
                        });
                    }

                    // If not duplicate, submit entire form for asset add
                    else if (response.data.results === "NO DUPLICATE FOUND") {
                        console.log("this name is good");
                        this.setState({
                            canSeeDuplicateNameError: false
                        });

                        // submit form to backend for add
                        // let data = {
                        //     tenantId: this.state.selected_tenant_id,
                        //     assetName: this.state.asset_name_entered,
                        //     categoryId: this.state.selected_category_id,
                        //     typeId: this.state.selected_type_id,
                        //     modelId: this.state.selected_model_id,
                        //     siteId: this.state.selected_site_id,
                        //     locationId: this.state.selected_location_in_building_id,
                        //     personId: this.state.selected_person_id,
                        //     vendorId: this.state.selected_vendor_id,
                        //     assetTag: this.state.asset_tag_entered,
                        //     serialNumber: this.state.serial_number_entered,
                        //     barcode: this.state.barcode_entered,
                        //     ipAddress: this.state.ip_address_entered,
                        //     macAddress: this.state.mac_address_entered,
                        //     ram: this.state.ram_entered,
                        //     cpu: this.state.cpu_entered,
                        //     aquisitionDate: this.state.aquisition_date_entered,
                        //     website: this.state.website_entered,
                        //     warrantyStartDate: this.state.warranty_start_date_entered,
                        //     warrantyEndDate: this.state.warranty_end_date_entered,
                        //     leaseStartDate: this.state.lease_start_date_entered,
                        //     leaseEndDate: this.state.lease_end_date_entered,
                        //     trackAsset: this.state.track_asset,
                        //     isPeripheral: this.state.is_peripheral,
                        //     assignedAssetId: this.state.selected_assigned_asset_name_id,
                        //     creatorId: this.props.loggedStatus.id,
                        //     contractNumber: this.state.contract_number_entered
                        // };

                        console.log("Values to submit to backend: ");
                        for (let [key, value] of formData.entries()) {
                            console.log(key, ": ", value);
                        }

                        /* Submit to the EDIT endpoint */
                        HardwareAssetDataService.editHardwareAsset(formData, this.props.match.params.id, this.props.loggedStatus.id).then(response => {
                            console.log("Returned from edit hardware asset endpoint: ", response);
                            this.populateDefaultValues(this.props.match.params.id, this.props.loggedStatus.timezone_adjustment_factor);   // the true signals to the function that we came from editHardwareAsset so we don't need drop down values pulled again
                            this.setState({
                                showSaving: false,
                                editModeActive: false
                            }, () => {
                                this.props.history.push(`/hardwareAssetDetails/${this.props.match.params.id}`);
                            });
                            
                        })
                        .catch(e => {
                            console.log(e);
                        });


                    }

                })
                .catch(e => {
                    console.log(e);
                });
            }


            // we're in the add version of this page, so we need to call add related items to add the asset
            else {
                HardwareAssetDataService.checkForDuplicateAssetName(this.state.asset_name_entered, this.state.selected_tenant_id).then(response => {
                
                    // If duplicate, show an error message
                    if (response.data.results === "DUPLICATE FOUND") {
                        this.setState({
                            canSeeDuplicateNameError: true
                        });
                    }

                    // If not duplicate, submit entire form for asset add
                    else if (response.data.results === "NO DUPLICATE FOUND") {
                        console.log("this name is good");
                        this.setState({
                            canSeeDuplicateNameError: false
                        });

                        // submit form to backend for add
                        // let data = {
                        //     tenantId: this.state.selected_tenant_id,
                        //     assetName: this.state.asset_name_entered,
                        //     categoryId: this.state.selected_category_id,
                        //     typeId: this.state.selected_type_id,
                        //     modelId: this.state.selected_model_id,
                        //     siteId: this.state.selected_site_id,
                        //     locationId: this.state.selected_location_in_building_id,
                        //     personId: this.state.selected_person_id,
                        //     vendorId: this.state.selected_vendor_id,
                        //     assetTag: this.state.asset_tag_entered,
                        //     serialNumber: this.state.serial_number_entered,
                        //     barcode: this.state.barcode_entered,
                        //     ipAddress: this.state.ip_address_entered,
                        //     macAddress: this.state.mac_address_entered,
                        //     ram: this.state.ram_entered,
                        //     cpu: this.state.cpu_entered,
                        //     aquisitionDate: this.state.aquisition_date_entered,
                        //     website: this.state.website_entered,
                        //     warrantyStartDate: this.state.warranty_start_date_entered,
                        //     warrantyEndDate: this.state.warranty_end_date_entered,
                        //     leaseStartDate: this.state.lease_start_date_entered,
                        //     leaseEndDate: this.state.lease_end_date_entered,
                        //     trackAsset: this.state.track_asset,
                        //     isPeripheral: this.state.is_peripheral,
                        //     assignedAssetId: this.state.selected_assigned_asset_name_id,
                        //     creatorId: this.props.loggedStatus.id,
                        //     contractNumber: this.state.contract_number_entered
                        // };

                        console.log("Values to submit to backend: ");
                        for (let [key, value] of formData.entries()) {
                            console.log(key, ": ", value);
                        }

                        /* TURN THIS BACK ON IN FINAL CODE !!!!!! */
                        HardwareAssetDataService.createNewHardwareAsset(formData, this.props.loggedStatus.id).then(response => {
                            console.log("Returned from create hardware asset endpoint");
                            this.props.history.push('/hardwareAssets');
                        })
                        .catch(e => {
                            console.log(e);
                        });


                    }

                })
                .catch(e => {
                    console.log(e);
                });
            }


        }
    }


    getHardwareAssetTypes(tenant_id) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getTypes(tenant_id)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets the list of users this tech is authorized to see for the filter drop down menu
    getUserList(asker_id, tenant_id) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getUsersAddAssetVersion(asker_id, tenant_id)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets list of tenant names this tech is authorized to see for the filter drop down menu
    getTenantList(asker_id) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getTenants(asker_id)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets list of categories for the add hardware asset drop down menu
    getCategories() {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getCategories()
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets list of vendors for the add hardware asset drop down menu
    getVendors(tenantId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getVendors(tenantId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets list of manufacturers for the add hardware asset drop down menu
    async getManufacturers(tenantId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getManufacturers(tenantId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets the list of models based on type user has selected for add hardware asset drop down menu
    getModels(typeId, manufacturerId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getModels(typeId, manufacturerId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets the list of sites based on company user has selected for company drop down menu
    getSites(tenantId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getSites(tenantId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets the list of locations in building based on site selected
    getLocations(siteId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getLocations(siteId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }

    // gets the list of assignable assets based on selected type and company
    getAssignableAssets(tenantId, typeId, categoryId) {
        return new Promise((resolve, reject) => {

            HardwareAssetDataService.getAssignableAssets(tenantId, typeId, categoryId)
                .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        });
    }


    // updated version of convertDateToSQLFormat - used when the MySQL field it's going into expects a DATE
    toMySQLDate(dateObj) {
        if (!dateObj || isNaN(dateObj.getTime())) return null;
      
        const pad = (n) => String(n).padStart(2, "0");
      
        const year = dateObj.getFullYear();
        const month = pad(dateObj.getMonth() + 1);
        const day = pad(dateObj.getDate());
      
        return `${year}-${month}-${day}`;
    }

    calculateMemoryPercent(total_memory, memory_used) {
        try {
            let percent = (Number(memory_used) / Number(total_memory)) * 100;
            return Math.round(percent);
        }

        catch {
            return "";
        }
    }


    // used when the MySQL field the input is going into expects a DATETIME - we're hiding the fact it's just going to have midnight as the time
    toMySQLDateTime(dateObj) {
        if (!dateObj || isNaN(dateObj.getTime())) return null;
      
        const pad = (n) => String(n).padStart(2, "0");
      
        const year = dateObj.getFullYear();
        const month = pad(dateObj.getMonth() + 1);
        const day = pad(dateObj.getDate());
      
        // Mantine DateInput has no time, but JS Date always includes one
        const hours = pad(dateObj.getHours());
        const minutes = pad(dateObj.getMinutes());
        const seconds = pad(dateObj.getSeconds());
      
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }


    // convert a string from Mantine date to MySQL format for saving
    convertDateToSQLFormat(dateString) {
        if(dateString === "" || dateString === null) {
            return "";
        }

        else {
            let dateArray = dateString.split(" ");
            console.log(dateArray);
            //['Fri', 'Jan', '05', '2024', '00:00:00', 'GMT+0000', '(Coordinated', 'Universal', 'Time)']

            let month;
            let day = dateArray[2];
            let year = dateArray[3];
            // MySQL expects date in format YYYY-MM-DD
            switch(dateArray[1]) {
                case "Jan":
                    month = "01";
                    break;

                case "Feb":
                    month = "02";
                    break;

                case "Mar":
                    month = "03";
                    break;

                case "Apr":
                    month = "04";
                    break;

                case "May":
                    month = "05";
                    break;

                case "Jun":
                    month = "06";
                    break;

                case "Jul":
                    month = "07";
                    break;

                case "Aug":
                    month = "08";
                    break;

                case "Sep":
                    month = "09";
                    break;

                case "Oct":
                    month = "10";
                    break;

                case "Nov":
                    month = "11";
                    break;

                default:
                    month = "12";
            }

            console.log("Month value = ", month);

            // construct the date string in the proper format
            console.log(year + "-" + month + "-" + day);

            let formattedString = year + "-" + month + "-" + day;

            return formattedString;
        }
    }


    render() {

        if (!this.props.loggedStatus.loggedIn) {
            return (
                <Redirect to='/' />
            );
        }



        return (
            <>
                {this.state.interaction_mode === "edit" ? 
                    <Navbar pageTitle={`Hardware Asset - ${this.state.asset.name_of_asset}`} />
                    :
                    <Navbar pageTitle={`Create Hardware Asset`} />
                }
                <div style={{ paddingTop: "15px" }} />
                <Group align="flex-start" noWrap style={{width: "100%"}}>
                <Box pos="relative" style={{ flex: 1, minWidth: 0 }}>
                    <LoadingOverlay visible={this.state.show_loading_overlay} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
                    <Container fluid>
                        <Paper withBorder p="md" radius="md" display="block" m="5px">
                            <Grid>
                                <Grid.Col span={6}>
                                    <Table withRowBorders={false} style={{cursor: "default"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Company</Table.Td>
                                            <Table.Td c="blue">
                                                {
                                                    this.state.tenants && this.state.tenants.find((e) => e.id === this.state.selected_tenant_id) ? 
                                                        this.state.tenants.find((e) => e.id === this.state.selected_tenant_id).name_of_tenant
                                                    :
                                                        ""
                                                }
                                            </Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Manufacturer</Table.Td>
                                            <Table.Td c="blue">
                                                {
                                                    this.state.manufacturers && this.state.manufacturers.find((e) => e.id === this.state.manufacturer_id_selected) ? 
                                                        this.state.manufacturers.find((e) => e.id === this.state.manufacturer_id_selected).name_of_manufacturer
                                                    :
                                                        ""
                                                }
                                            </Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Grid.Col>
                                <Grid.Col span={6}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "10px" }}>
                                        {this.state.interaction_mode === "edit" &&
                                            <Switch
                                                checked={this.state.editModeActive}
                                                label="Edit Mode"
                                                labelPosition="left"
                                                onChange={(event) => this.setState({ editModeActive: event.currentTarget.checked })}
                                            >
                                                Edit Mode
                                            </Switch>
                                        }
                                        {this.state.editModeActive && this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                            <div><Button onClick={() => this.openWelcomeModal()}><IconEdit/></Button></div>
                                            :
                                            undefined
                                        }
                                        {this.state.inTuneAssetId !== null ? 
                                            <div>
                                                <a href={`${process.env.REACT_APP_BASE_INTUNE_URL}${this.state.inTuneAssetId}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                                                    <Button>Screen Share / RDP</Button>
                                                </a>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </div>
                                </Grid.Col>
                            </Grid>
                        </Paper>
                        <div style={{marginTop: "25px"}}></div>
                        <Paper withBorder p="md" radius="md" display="flex" m="5px" style={{minHeight: "535px", flexDirection: "column"}}>
                            <Tabs 
                                radius="md" 
                                orientation="vertical" 
                                defaultValue="Basic Info" 
                                classNames={{ 
                                    tab: classes.tab,
                                    root: classes.root,
                                    list: classes.list,
                                }}>
                                <Tabs.List>
                                    <Tabs.Tab value="Basic Info" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Basic Info</strong></Tabs.Tab>
                                    <Tabs.Tab value="Assignments" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Assignments</strong></Tabs.Tab>
                                    <Tabs.Tab value="Identifying Details" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Identifying Details</strong></Tabs.Tab>
                                    <Tabs.Tab value="Purchase Info" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Purchase Info</strong></Tabs.Tab>
                                    {/* <Tabs.Tab value="Internal Specs">Internal Specs</Tabs.Tab> */}
                                    {this.state.selected_type_name === "Services" ?
                                        <Tabs.Tab value="Services" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Services</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Cloud" || 
                                    this.state.selected_type_name === "Virtual Machine" ||
                                    this.state.selected_type_name === "Volume" ||
                                    this.state.selected_type_name === "Host" || 
                                    this.state.selected_type_name === "Datacenter" || 
                                    this.state.selected_type_name === "Datastore" || 
                                    this.state.selected_type_name === "Image" || 
                                    this.state.selected_type_name === "Load Balancer" || 
                                    this.state.selected_type_name === "Security Group" || 
                                    this.state.selected_type_name === "Network" || 
                                    this.state.selected_type_name === "Resource Pool" || 
                                    this.state.selected_type_name === "Network Interface" || 
                                    this.state.selected_type_name === "Public IP Address" || 
                                    this.state.selected_type_name === "VPC" || 
                                    this.state.selected_type_name === "Subnet" || 
                                    this.state.selected_type_name === "Database" || 
                                    this.state.selected_type_name === "Key Pair" || 
                                    this.state.selected_type_name === "Object Storage" || 
                                    this.state.selected_type_name === "Key Vault" || 
                                    this.state.selected_type_name === "Subscription" || 
                                    this.state.selected_type_name === "Resource Group" || 
                                    this.state.selected_type_name === "Application Gateway" ?
                                        <Tabs.Tab value="Cloud" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Cloud</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Virtual Machine" ?
                                        <Tabs.Tab value="Virtual Machine" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Virtual Machine</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Volume" ? 
                                        <Tabs.Tab value="Volume" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Volume</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Host" ? 
                                        <Tabs.Tab value="Host" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Host</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Datacenter" ? 
                                        <Tabs.Tab value="Datacenter" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Datacenter</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Datastore" ? 
                                        <Tabs.Tab value="Datastore" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Datastore</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Image" ? 
                                        <Tabs.Tab value="Image" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Image</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Load Balancer" ? 
                                        <Tabs.Tab value="Load Balancer" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Load Balancer</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Security Group" ? 
                                        <Tabs.Tab value="Security Group" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Security Group</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Network" ? 
                                        <Tabs.Tab value="Network" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Network</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Resource Pool" ? 
                                        <Tabs.Tab value="Resource Pool" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Resource Pool</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Network Interface" ? 
                                        <Tabs.Tab value="Network Interface" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Network Interface</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Public IP Address" ? 
                                        <Tabs.Tab value="Public IP Address" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Public IP Address</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "VPC" ? 
                                        <Tabs.Tab value="VPC" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>VPC</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Subnet" ? 
                                        <Tabs.Tab value="Subnet" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Subnet</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Database" ? 
                                        <Tabs.Tab value="Database" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Database</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Key Pair" ? 
                                        <Tabs.Tab value="Key Pair" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Key Pair</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Object Storage" ? 
                                        <Tabs.Tab value="Object Storage" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Object Storage</strong></Tabs.Tab> :undefined
                                    }
                                    {this.state.selected_type_name === "Key Vault" ? 
                                        <Tabs.Tab value="Key Vault" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Key Vault</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Subscription" ? 
                                        <Tabs.Tab value="Subscription" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Subscription</strong></Tabs.Tab> :undefined
                                    }
                                    {this.state.selected_type_name === "Resource Group" ? 
                                        <Tabs.Tab value="Resource Group" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Resource Group</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Application Gateway" ? 
                                        <Tabs.Tab value="Application Gateway" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Application Gateway</strong></Tabs.Tab> : undefined
                                    }
                                    {(this.state.selected_type_name === "Hardware" || 
                                    this.state.selected_type_name === "Computer" || 
                                    this.state.selected_type_name === "Desktop" || 
                                    this.state.selected_type_name === "Laptop" || 
                                    this.state.selected_type_name === "Server" || 
                                    this.state.selected_type_name === "Storage" || 
                                    this.state.selected_type_name === "Disk" || 
                                    this.state.selected_type_name === "Datacenter" || 
                                    this.state.selected_type_name === "Rack" || 
                                    this.state.selected_type_name === "UPS" || 
                                    this.state.selected_type_name === "Mobile Devices" || 
                                    this.state.selected_type_name === "Monitor" || 
                                    this.state.selected_type_name === "Printer" || 
                                    this.state.selected_type_name === "Projector" || 
                                    this.state.selected_type_name === "Scanner" || 
                                    this.state.selected_type_name === "Router" || 
                                    this.state.selected_type_name === "Switch" || 
                                    this.state.selected_type_name === "Access Point" || 
                                    this.state.selected_type_name === "Firewall" || 
                                    this.state.selected_type_name === "Other Devices" || 
                                    this.state.selected_type_name === "SNMP") && (this.state.asset_field_settings.show_usage_type === 1 || this.state.asset_field_settings.show_domain === 1 || this.state.asset_field_settings.show_connection_types === 1 || this.state.asset_field_settings.show_last_audit_date === 1) ? 
                                        <Tabs.Tab value="Hardware" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Hardware</strong></Tabs.Tab> : undefined
                                    }
                                    {(this.state.selected_type_name === "Hardware" || 
                                    this.state.selected_type_name === "Computer" || 
                                    this.state.selected_type_name === "Desktop" || 
                                    this.state.selected_type_name === "Laptop" || 
                                    this.state.selected_type_name === "Server" || 
                                    this.state.selected_type_name === "Storage" || 
                                    this.state.selected_type_name === "Disk" || 
                                    this.state.selected_type_name === "Datacenter" || 
                                    this.state.selected_type_name === "Rack" || 
                                    this.state.selected_type_name === "UPS" || 
                                    this.state.selected_type_name === "Mobile Devices" || 
                                    this.state.selected_type_name === "Monitor" || 
                                    this.state.selected_type_name === "Printer" || 
                                    this.state.selected_type_name === "Projector" || 
                                    this.state.selected_type_name === "Scanner" || 
                                    this.state.selected_type_name === "Router" || 
                                    this.state.selected_type_name === "Switch" || 
                                    this.state.selected_type_name === "Access Point" || 
                                    this.state.selected_type_name === "Firewall" || 
                                    this.state.selected_type_name === "Other Devices" || 
                                    this.state.selected_type_name === "SNMP") && (this.state.asset_field_settings.show_salvage === 1 || this.state.asset_field_settings.show_depreciation_type === 1) ? 
                                        <Tabs.Tab value="Cost" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Cost</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Computer" || 
                                    this.state.selected_type_name === "Desktop" || 
                                    this.state.selected_type_name === "Laptop" || 
                                    this.state.selected_type_name === "Server" ? 
                                        <Tabs.Tab value="Computer" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Computer</strong></Tabs.Tab> : undefined
                                    }
                                    {/* <Tabs.Tab value="Desktop">Desktop</Tabs.Tab>
                                    <Tabs.Tab value="Laptop">Laptop</Tabs.Tab>
                                    <Tabs.Tab value="Server">Server</Tabs.Tab>
                                    <Tabs.Tab value="Storage">Storage</Tabs.Tab> */}
                                    {this.state.selected_type_name === "Disk" ? 
                                        <Tabs.Tab value="Disk" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Disk</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Rack" ? 
                                        <Tabs.Tab value="Rack" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Rack</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "UPS" ? 
                                        <Tabs.Tab value="UPS" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>UPS</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Mobile Devices" ? 
                                        <Tabs.Tab value="Mobile Devices" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Mobile Devices</strong></Tabs.Tab> : undefined
                                    }
                                    {/* <Tabs.Tab value="Monitor">Monitor</Tabs.Tab> */}
                                    {this.state.selected_type_name === "Printer" ? 
                                        <Tabs.Tab value="Printer" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Printer</strong></Tabs.Tab> : undefined
                                    }
                                    {/* <Tabs.Tab value="Projector">Projector</Tabs.Tab>
                                    <Tabs.Tab value="Scanner">Scanner</Tabs.Tab> */}
                                    {this.state.selected_type_name === "Router" ? 
                                        <Tabs.Tab value="Router" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Router</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Switch" ? 
                                        <Tabs.Tab value="Switch" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Switch</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Access Point" ? 
                                        <Tabs.Tab value="Access Point" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Access Point</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Firewall" ? 
                                        <Tabs.Tab value="Firewall" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Firewall</strong></Tabs.Tab> : undefined
                                    }
                                    {/* <Tabs.Tab value="Other Devices">Other Devices</Tabs.Tab> */}
                                    {this.state.selected_type_name === "SNMP" ? 
                                        <Tabs.Tab value="SNMP" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>SNMP</strong></Tabs.Tab> : undefined
                                    }
                                    {this.state.selected_type_name === "Consumable" ? 
                                        <Tabs.Tab value="Consumable" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Consumable</strong></Tabs.Tab> : undefined
                                    }
                                    {/* {this.state.selected_type_name === "Network" ? 
                                        <Tabs.Tab value="Network">Network</Tabs.Tab> : undefined
                                    } */}
                                    {this.state.selected_type_name === "Document" ? 
                                        <Tabs.Tab value="Document" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Document</strong></Tabs.Tab> : undefined
                                    }
                                    <Tabs.Tab value="Power Details" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Power Details</strong></Tabs.Tab>
                                    {/* <Tabs.Tab value="Others">Others</Tabs.Tab> */}
                                    <Tabs.Tab value="Warranty Lease and Maintenance" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Warranty Lease and Maintenance</strong></Tabs.Tab>
                                    {this.state.asset_field_settings.show_isTracked === 1 || this.state.asset_field_settings.show_is_peripheral === 1 || this.state.asset_field_settings.show_description === 1 || this.state.asset_field_settings.allow_asset_attachments === 1 ? 
                                        <Tabs.Tab value="Misc" onClick={(e) => this.setState({selected_form_tab: e.target.innerText})}><strong>Misc</strong></Tabs.Tab> : undefined
                                    }
                                </Tabs.List>
                                <Tabs.Panel value="Basic Info">
                                    {this.state.selected_form_tab === "Basic Info" ?
                                        <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                            <Form>
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetName">
                                                    <span style={{ 
                                                        display: "flex", 
                                                        alignItems: "center",
                                                        width: "95%"
                                                    }}
                                                    >
                                                        <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Asset Name{this.state.editModeActive && <span style={{ color: "red" }}>*</span>}</Text>
                                                        {this.state.editModeActive ?
                                                            <TextInput 
                                                                style={{ flex: 1, width: "100%"}}
                                                                placeholder="Enter Name Here" 
                                                                value={this.state.asset_name_entered} 
                                                                onChange={this.handleAssetNameEnteredChange} 
                                                                required 
                                                            />
                                                            :
                                                            <Text c="blue">{this.state.asset.name_of_asset}</Text>
                                                        }
                                                    </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                {this.state.asset_field_settings.show_asset_state === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormHardwareAssetState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Asset State</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Active - Assigned", "Active - Ready to Deploy", "Active - Loaner", "Inactive - Donated", "Inactive - Ewasted", "Inactive - Missing"]}
                                                                    value={this.state.hardware_asset_state_selected}
                                                                    onChange={(s) => this.handleHardwareAssetStateSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_asset_category_id === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetCategory">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px",  whiteSpace: "nowrap"}}>Category{this.state.editModeActive && <span style={{ color: "red" }}>*</span>}</Text>
                                                            {this.state.editModeActive ? 
                                                                <>
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Pick a Value"
                                                                    data={this.state.asset_categories && this.state.asset_categories.map((category) => (
                                                                        category.name_of_category
                                                                    ))}
                                                                    value={
                                                                            this.state.selected_category_id !== 0 && this.state.asset_categories.length > 0 && this.state.asset_categories && this.state.asset_categories.find((e) => e.id === this.state.selected_category_id) ?
                                                                                this.state.asset_categories.find((e) => e.id === this.state.selected_category_id).name_of_category
                                                                            :
                                                                            ""  
                                                                    }
                                                                    onChange={(s) => {
                                                                            var catId = this.state.asset_categories.find((e) => e.name_of_category === s).id;
                                                                            if(catId !== null) {
                                                                                this.handleSelectedCategoryChange(catId);
                                                                            }
                                                                        }
                                                                    }
                                                                    allowDeselect={false}
                                                                    searchable
                                                                    required
                                                                />
                                                                    {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                                                    <span style={{ 
                                                                        position: "absolute", 
                                                                        right: "-28px", 
                                                                        top: "50%", 
                                                                        transform: "translateY(-50%)", 
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center" 
                                                                    }}>
                                                                        <Tooltip label="Click to create a new category"><IconPlus color="#00abfb" onClick={() => this.openCategoryModal()}/></Tooltip>
                                                                    </span>
                                                                    :
                                                                    undefined
                                                                    }
                                                                </>
                                                                :
                                                                <Text c="blue">{this.state.asset.asset_category_name}</Text>
                                                            }
                                                            </span>
                                                            
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetType">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Type{this.state.editModeActive && <span style={{ color: "red" }}>*</span>}</Text>
                                                                {this.state.editModeActive ? 
                                                                    <>
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Pick a Value"
                                                                        data={this.state.asset_types && this.state.asset_types.map((type) => (
                                                                            type.name_of_type
                                                                        ))}
                                                                        value={
                                                                            this.state.selected_type_id !== 0 && this.state.asset_types && this.state.asset_types.length > 0 && this.state.asset_types.find((e) => e.id === this.state.selected_type_id) ? 
                                                                                this.state.asset_types.find((e) => e.id === this.state.selected_type_id).name_of_type
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(s) => {
                                                                            var typeId = this.state.asset_types.find((e) => e.name_of_type === s).id;
                                                                            if(typeId !== null) {
                                                                                this.handleSelectedTypeChange(typeId);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                        required
                                                                    />
                                                                    {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                                                        <span style={{ 
                                                                            position: "absolute", 
                                                                            right: "-28px", 
                                                                            top: "50%", 
                                                                            transform: "translateY(-50%)", 
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center" 
                                                                        }}>
                                                                            <Tooltip label="Click to create a new type"><IconPlus color="#00abfb" onClick={() => this.openTypeModal(false)} /></Tooltip>
                                                                        </span>
                                                                        :
                                                                        undefined
                                                                    }
                                                                    </>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.asset_type_name}</Text>
                                                                }
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                    </Form.Row>
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetModel">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Model{this.state.editModeActive && <span style={{ color: "red" }}>*</span>}</Text>
                                                                {this.state.editModeActive ?
                                                                    <>
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Pick a Value"
                                                                        data={this.state.model_names && this.state.model_names.length > 0 && this.state.model_names.map((model) => (
                                                                            model.name_of_model !== null ? model.name_of_model : []
                                                                        ))
                                                                        }
                                                                        value={
                                                                            this.state.selected_model_id !== 0 && this.state.model_names && this.state.model_names.length > 0 && this.state.model_names.find((e) => e.id === this.state.selected_model_id) ? 
                                                                                this.state.model_names.find((e) => e.id === this.state.selected_model_id).name_of_model
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(s) => {
                                                                            var modelId = this.state.model_names.find((e) => e.name_of_model === s).id;
                                                                            if(modelId !== null) {
                                                                                this.handleSelectedModelChange(modelId);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                        required
                                                                    />
                                                                    <span style={{ 
                                                                        position: "absolute", 
                                                                        right: "-28px", 
                                                                        top: "50%", 
                                                                        transform: "translateY(-50%)", 
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center" 
                                                                    }}>
                                                                        <Tooltip label="Click to create a new model"><IconPlus color="#00abfb" onClick={() => this.openModelModal()}/></Tooltip>
                                                                    </span>
                                                                    </>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.model_name}</Text>
                                                                }
                                                            </span>
                                                            
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                                {this.state.asset_field_settings.show_impact === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormImpact">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Impact Level</Text>
                                                                {this.state.editModeActive ?
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Low", "Medium", "High"]}
                                                                        value={this.state.impact_level_selected}
                                                                        onChange={(s) => {
                                                                            this.handleImpactLevelChange(s);
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.impact}</Text>
                                                                }
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_end_of_life === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormEndOfLife">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>End of Life Date</Text>
                                                                {this.state.editModeActive ?
                                                                    <DateInput 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a Value"
                                                                        value={this.state.end_of_life_date}
                                                                        onChange={(e) => {this.handleEndofLifeDateChange(e)}}
                                                                        clearable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.end_of_life}</Text>
                                                                }
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                    {/* <Form.Group as={Col} controlId="addFormHealth">
                                                        <div>
                                                            <span style={{ display: "inline-block", width: "95%" }}><Select 
                                                                label="What is the asset's health?"
                                                                placeholder="Not final"
                                                            />
                                                            </span>
                                                        </div>
                                                    </Form.Group> */}
                                                </Form.Row>
                                                }
                                            </Form>
                                        </div>
                                        :
                                        undefined
                                    }
                                </Tabs.Panel>
                                <Tabs.Panel value="Assignments">
                                    {this.state.selected_form_tab === "Assignments" ? 
                                        <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                            <Form>
                                            {this.state.asset_field_settings.show_assigned_person_id === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssignedPerson">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                        <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Assigned To</Text>
                                                        {this.state.editModeActive ? 
                                                            <Select 
                                                                style={{ flex: 1, width: "100%"}}
                                                                placeholder="Pick a Value"
                                                                data={this.state.people && this.state.people.map((person) => (
                                                                    `${person.full_name} - (${person.email})`
                                                                ))}
                                                                value={
                                                                    this.state.selected_person_id !== 0 && this.state.people && this.state.people.length > 0 && this.state.people.find((e) => e.id === this.state.selected_person_id) ? 
                                                                        `${this.state.people.find((e) => e.id === this.state.selected_person_id).full_name} - (${this.state.people.find((e) => e.id === this.state.selected_person_id).email})`
                                                                        :
                                                                        ""
                                                                }
                                                                onChange={(s) => {
                                                                    
                                                                    var fullNameChosen = s.split(' - (')[0];
                                                                    var personId;

                                                                    if(fullNameChosen !== "None") {
                                                                        var emailChosenTemp = s.split(' - (')[1];
                                                                        var emailChosen = emailChosenTemp.split(')')[0];
                                                                        // first get the list of records that match the full name provided
                                                                        let matchingList = this.state.people.filter(item => item.full_name === fullNameChosen);

                                                                        //console.log("Full Name Chosen = ", fullNameChosen);
                                                                        //console.log("Email Chosen Temp = ", emailChosenTemp);
                                                                        //console.log("Email Chosen = ", emailChosen);

                                                                        // now find the record in that list that matches the email address provided
                                                                        personId = matchingList.find((e) => e.email === emailChosen).id;
                                                                    }

                                                                    else {
                                                                        personId = 0;
                                                                    }

                                                                    if(personId !== null) {
                                                                        //console.log("Match found!", personId);
                                                                        this.handleSelectedAssignedPersonChange(personId)
                                                                    }
                                                                }}
                                                                allowDeselect={false}
                                                                searchable
                                                            />
                                                            :
                                                            <Text c="blue">{this.state.asset.first_name !== null && this.state.asset.last_name !== null ? `${this.state.asset.first_name} ${this.state.asset.last_name}` : ''}</Text>
                                                        }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_date_assigned === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormDateTimeAssigned">
                                                        <div>
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Assigned On</Text>
                                                                {this.state.editModeActive ?
                                                                    <DateTimePicker style={{ flex: 1, width: "100%"}} placeholder="Select a date" valueFormat='MM/DD/YYYY HH:mm' value={this.state.assignment_time} onChange={(e) => this.handleAssignmentTimeChange(e)} clearable/>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.date_assigned}</Text>
                                                                }
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_site_id === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormSite">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Assigned Location</Text>
                                                                {this.state.editModeActive ? 
                                                                    <>
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Pick a Value"
                                                                        data={this.state.sites && this.state.sites.map((site) => (
                                                                            site.name_of_site
                                                                        ))}
                                                                        value={
                                                                            this.state.selected_site_id !== 0 && this.state.sites && this.state.sites.length > 0 && this.state.sites.find((e) => e.id === this.state.selected_site_id) ? 
                                                                                this.state.sites.find((e) => e.id === this.state.selected_site_id).name_of_site
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(s) => {
                                                                            var siteId = this.state.sites.find((e) => e.name_of_site === s).id;
                                                                            if(siteId !== null) {
                                                                                this.handleSelectedSiteChange(siteId);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                    />
                                                            
                                                                    <span style={{ 
                                                                        position: "absolute", 
                                                                        right: "-28px", 
                                                                        top: "50%", 
                                                                        transform: "translateY(-50%)", 
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center" 
                                                                    }}>
                                                                        <Tooltip label="Click to create a new site"><IconPlus color="#00abfb" onClick={() => this.openSiteModal()}/></Tooltip>
                                                                    </span>
                                                                    </>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.name_of_site}</Text>
                                                                }
                                                        </span>
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_physical_location === 1 && 
                                                <Form.Row>
                                                   <Form.Group as={Col} controlId="addFormPhysicalLocation">
                                                        <div>
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Physical Location</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.physical_location_entered} onChange={(e) => this.handlePhysicalLocationEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.physical_location}</Text>
                                                                }
                                                            </span>
                                                        </div>
                                                    </Form.Group> 
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_location_description === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormLocationAtSite" /* xs={6} */>
                                                        <div>
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Further Location Description</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.location_description_entered} onChange={(e) => this.handleLocationDescriptionChange(e)}/>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.location_description}</Text>
                                                                }
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_department_id === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormDepartmentAssigned">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Department Assigned</Text>
                                                                {this.state.editModeActive ? 
                                                                    <>
                                                                    <Select
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={this.state.departments.map(d => ({ value: d.id.toString(), label: d.name_of_department }))}
                                                                        value={this.state.department_id_selected.toString()}
                                                                        onChange={(value) => {
                                                                            const departmentId = parseInt(value);
                                                                            const department = this.state.departments.find(d => d.id === departmentId);
                                                                            if (department) {
                                                                                this.handleSelectedDepartmentChange(departmentId, department.name_of_department);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                    />
                                                                    
                                                                    <span style={{ 
                                                                        position: "absolute", 
                                                                        right: "-28px", 
                                                                        top: "50%", 
                                                                        transform: "translateY(-50%)", 
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center" 
                                                                    }}>
                                                                        <Tooltip label="Click to create a new department"><IconPlus color="#00abfb" onClick={() => this.openDepartmentModal()}/></Tooltip>
                                                                    </span>
                                                                    </>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.name_of_department}</Text>
                                                                }
                                                        </span>
                                                        </div>
                                                    </Form.Group> 
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_managing_group_id === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormManagingGroup">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Managing Group</Text>
                                                                {this.state.editModeActive ? 
                                                                    <>
                                                                        <Select
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={this.state.managing_groups.map(d => ({ value: d.id.toString(), label: d.name }))}
                                                                        value={this.state.managing_group_id_selected.toString()}
                                                                        onChange={(value) => {
                                                                            const managingGroupId = parseInt(value);
                                                                            const managingGroup = this.state.managing_groups.find(d => d.id === managingGroupId);
                                                                            if (managingGroup) {
                                                                                this.handleSelectedManagingGroupChange(managingGroupId, managingGroup.name);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                        />
                                                                    
                                                                        <span style={{ 
                                                                            position: "absolute", 
                                                                            right: "-28px", 
                                                                            top: "50%", 
                                                                            transform: "translateY(-50%)", 
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center" 
                                                                        }}>
                                                                            <Tooltip label="Click to create a new group"><IconPlus color="#00abfb" onClick={() => this.openManagingGroupModal()}/></Tooltip>
                                                                        </span>
                                                                    </>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.managing_group_name}</Text>
                                                                }
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_person_managing_id === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormManagingPerson">
                                                        <div>
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Managing Person</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Pick a Value"
                                                                    data={this.state.people && this.state.people.map((person) => (
                                                                        `${person.full_name} - (${person.email})`
                                                                    ))}
                                                                    value={
                                                                        this.state.selected_managing_person_id !== 0 && this.state.people && this.state.people.length > 0 && this.state.people.find((e) => e.id === this.state.selected_managing_person_id) ? 
                                                                            `${this.state.people.find((e) => e.id === this.state.selected_managing_person_id).full_name} - (${this.state.people.find((e) => e.id === this.state.selected_managing_person_id).email})`
                                                                            :
                                                                            ""
                                                                    }
                                                                    onChange={(s) => {
                                                                        
                                                                        var fullNameChosen = s.split(' - (')[0];
                                                                        var personId;
        
                                                                        if(fullNameChosen !== "None") {
                                                                            var emailChosenTemp = s.split(' - (')[1];
                                                                            var emailChosen = emailChosenTemp.split(')')[0];
                                                                            // first get the list of records that match the full name provided
                                                                            let matchingList = this.state.people.filter(item => item.full_name === fullNameChosen);
        
                                                                            //console.log("Full Name Chosen = ", fullNameChosen);
                                                                            //console.log("Email Chosen Temp = ", emailChosenTemp);
                                                                            //console.log("Email Chosen = ", emailChosen);
        
                                                                            // now find the record in that list that matches the email address provided
                                                                            personId = matchingList.find((e) => e.email === emailChosen).id;
                                                                        }
        
                                                                        else {
                                                                            personId = 0;
                                                                        }
        
                                                                        if(personId !== null) {
                                                                            //console.log("Match found!", personId);
                                                                            this.handleSelectedAssignedManagingPersonChange(personId)
                                                                        }
                                                                    }}
                                                                    allowDeselect={false}
                                                                    searchable
                                                                />
                                                                :
                                                                <>
                                                                    {this.state.asset.manager_first_name !== null && this.state.asset.manager_last_name !== null ? 
                                                                        <Text c="blue">{`${this.state.asset.manager_first_name} ${this.state.asset.manager_last_name}`}</Text>
                                                                        :
                                                                        undefined
                                                                    }
                                                                </>
                                                            }
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_ad_ou === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormADOU">
                                                        <div>
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>AD OU</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.ad_ou_entered} onChange={(e) => this.handleADOUEnteredChange(e)}/>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ad_ou}</Text>
                                                                }
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            </Form>
                                        </div>
                                        :
                                        undefined
                                    }
                                </Tabs.Panel>
                                <Tabs.Panel value="Identifying Details">
                                    {this.state.selected_form_tab === "Identifying Details" ? 
                                        <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                            <Form>
                                            {this.state.asset_field_settings.show_asset_tag === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetTag">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Asset Tag</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.asset_tag_entered} onChange={this.handleAssetTagEnteredChange} />
                                                                :
                                                                <Text c="blue">{this.state.asset.asset_tag}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_asset_code === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetCode">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Asset Code</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.asset_code_entered} onChange={this.handleAssetCodeEnteredChange} />
                                                                :
                                                                <Text c="blue">{this.state.asset.asset_code}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_asset_bar_code === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetBarCode">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Bar Code</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.barcode_entered} onChange={this.handleBarcodeEnteredChange} />
                                                                :
                                                                <Text c="blue">{this.state.asset.asset_bar_code}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_asset_serial_number === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetSerialNumber">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Serial Number</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.serial_number_entered} onChange={this.handleSerialNumberEnteredChange} />
                                                                :
                                                                <Text c="blue">{this.state.asset.asset_serial_number}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            </Form>
                                        </div>
                                        :
                                        undefined
                                    }
                                </Tabs.Panel>
                                <Tabs.Panel value="Purchase Info">
                                    {this.state.selected_form_tab === "Purchase Info" ? 
                                        <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                            <Form>
                                                {this.state.asset_field_settings.show_vendor_id === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAssetVendor">
                                                        <div>
                                                            <span style={{ display: "flex", alignItems: "center", width: "95%", position: "relative" }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Vendor</Text>
                                                                {this.state.editModeActive ? 
                                                                    <>
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Pick a Value"
                                                                        data={this.state.vendors && this.state.vendors.map((vendor) => (
                                                                            vendor.name_of_vendor
                                                                        ))}
                                                                        value={
                                                                            this.state.selected_vendor_id !== 0 && this.state.vendors && this.state.vendors.length > 0 && this.state.vendors.find((e) => e.id === this.state.selected_vendor_id) ?
                                                                                this.state.vendors.find((e) => e.id === this.state.selected_vendor_id).name_of_vendor
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(s) => {
                                                                            // var siteId = this.state.sites.find((e) => e.name_of_site === s).id;
                                                                            // if(siteId !== null) {
                                                                            //     this.handleSelectedSiteChange(siteId);
                                                                            // }
                                                                            var vendorId = this.state.vendors.find((e) => e.name_of_vendor === s).id;
                                                                            if(vendorId !== null) {
                                                                                this.handleSelectedVendorChange(vendorId);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                    />
                                                                    {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                                                        <span style={{ 
                                                                            position: "absolute", 
                                                                            right: "-28px", 
                                                                            top: "50%", 
                                                                            transform: "translateY(-50%)", 
                                                                            cursor: "pointer",
                                                                            display: "flex",
                                                                            alignItems: "center" 
                                                                        }}>
                                                                            <Tooltip label="Click to create a new vendor"><IconPlus color="#00abfb" onClick={() => this.openVendorModal()}/></Tooltip>
                                                                    </span>
                                                                   
                                                                
                                                                    :
                                                                    undefined
                                                                    }
                                                                    
                                                                    </>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.vendor_name}</Text>
                                                                }
                                                                
                                                                
                                                            </span>
                                                            
                                                        </div>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_acquisition_date === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAcquisitionDate">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Purchase Date</Text>
                                                            {this.state.editModeActive ?
                                                                <DateInput 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Pick a Date"
                                                                    onChange={(s) => {
                                                                        let dateString;
                                                                        if(s === null) {
                                                                            dateString = "";
                                                                        }

                                                                        else {
                                                                            dateString = s.toString();
                                                                        }
                                                                        this.handleAcquisitionDateChange(s);
                                                                    }}
                                                                    value={this.state.aquisition_date_entered}
                                                                    clearable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.acquisition_date !== null ? this.state.asset.acquisition_date : ""}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_cost === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormHardwareCost">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Cost</Text>
                                                            {this.state.editModeActive ? 
                                                                <NumberInput
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Enter $ amount"
                                                                    allowNegative={false}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale
                                                                    step={0.01}
                                                                    prefix="$"
                                                                    hideControls
                                                                    value={this.state.asset_cost_entered}
                                                                    onChange={(e) => this.handleAssetCostEnteredChange(e)}
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.cost}</Text>
                                                            }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_asset_invoice_number === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormInvoiceNumber">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Invoice Number</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.invoice_number_entered} onChange={this.handleInvoiceNumberEnteredChange}/>
                                                                :
                                                                <Text c="blue">{this.state.asset.invoice_number}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_asset_order_number === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormOrderNumber">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Order Number</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.order_number_entered} onChange={this.handleOrderNumberEnteredChange}/>
                                                                :
                                                                <Text c="blue">{this.state.asset.order_number}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_contract_number === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormContractNumber">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Contract Number</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.contract_number_entered} onChange={this.handleContractNumberEnteredChange}/>
                                                                :
                                                                <Text c="blue">{this.state.asset.contract_number}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_quote_status === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormQuoteStatus">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Quote Status</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}} 
                                                                    placeholder="Select a value" 
                                                                    data={["Complete", "In Progress", "Cancelled"]}
                                                                    value={this.state.quote_status_entered} 
                                                                    onChange={(e) => this.handleQuoteStatusEnteredChange(e)} 
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.quote_status}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_renewal_status === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormRenewalStatus">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Renewal Status</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}} 
                                                                    placeholder="Select a value" 
                                                                    data={["Complete", "In Progress", "Cancelled"]}
                                                                    value={this.state.renewal_status_entered} 
                                                                    onChange={(e) => this.handleRenewalStatusEnteredChange(e)}
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.renewal_status}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_manufacturer_website === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormManufacturerWebsite">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Manufacturer Website</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.website_entered} onChange={this.handleWebsiteEnteredChange} />
                                                                :
                                                                <Text c="blue">{this.state.asset.manufacturer_website}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                            </Form>
                                        </div>
                                        :
                                        undefined
                                    }
                                </Tabs.Panel>
                                {/* <Tabs.Panel value="Internal Specs">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                <Form.Group as={Col} controlId="addFormRAM">
                                                    <span style={{ display: "inline-block", width: "95%" }}>
                                                        <TextInput label="RAM" placeholder="Enter Text Here" value={this.state.ram_entered} onChange={this.handleRAMEnteredChange} />
                                                    </span>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="addFormCPU">
                                                    <span style={{ display: "inline-block", width: "95%" }}>
                                                        <TextInput label="CPU" placeholder="Enter Text Here" value={this.state.cpu_entered} onChange={this.handleCPUEnteredChange} />
                                                    </span>
                                                </Form.Group>
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel> */}
                                <Tabs.Panel value="Power Details">
                                    {this.state.selected_form_tab === "Power Details" ? 
                                        <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                            <Form>
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormPowerType">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Power Type</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}} 
                                                                    placeholder="Select a value" 
                                                                    data={["PDU", "Kasa"]}
                                                                    value={this.state.power_type_entered} 
                                                                    onChange={(e) => this.handlePowerTypeEnteredChange(e)}
                                                                    //allowDeselect={false}
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.power_type}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                {this.state.power_type_entered === "Kasa" ?
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKasaName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Kasa Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.kasa_name_entered} onChange={(e) => this.handleKasaNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.kasa_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    :
                                                    undefined
                                                }
                                                {this.state.power_type_entered === "Kasa" ?
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKasaMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Kasa MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.kasa_mac_address_entered} onChange={(e) => this.handleKasaMACAddressEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.kasa_mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    :
                                                    undefined
                                                }
                                                {this.state.power_type_entered === "Kasa" ?
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKasaIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Kasa IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.kasa_ip_address_entered} onChange={(e) => this.handleKasaIPAddressEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.kasa_ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    :
                                                    undefined
                                                }
                                                {this.state.power_type_entered === "Kasa" ? 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKasaOutletID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Kasa Outlet ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.kasa_outlet_id_entered} onChange={(e) => this.handleKasaOutletIDEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.kasa_outlet_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    :
                                                    undefined
                                                }
                                                {this.state.power_type_entered === "Kasa" ? 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKasaPlugNumber">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Kasa Plug Number</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.kasa_plug_number_entered} onChange={(e) => this.handleKasaPlugNumberEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.kasa_plug_number}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    :
                                                    undefined
                                                }
                                                {this.state.power_type_entered === "PDU" ? 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPDUName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>PDU Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.pdu_name_entered} onChange={(e) => this.handlePDUNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.pdu_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    :
                                                    undefined
                                                }
                                                {this.state.power_type_entered === "PDU" ? 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPDUIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>PDU IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.pdu_ip_address_entered} onChange={(e) => this.handlePDUIPAddressEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.pdu_ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    :
                                                    undefined
                                                }
                                                {this.state.power_type_entered === "PDU" ? 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPDUOutletID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>PDU Outlet ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.pdu_outlet_id_entered} onChange={(e) => this.handlePDUOutletIDEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.pdu_outlet_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    :
                                                    undefined
                                                }

                                            </Form>
                                        </div>
                                        :
                                        undefined
                                    }
                                </Tabs.Panel>
                                <Tabs.Panel value="Warranty Lease and Maintenance">
                                    {this.state.selected_form_tab === "Warranty Lease and Maintenance" ? 
                                        <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                            <Form>
                                                {this.state.asset_field_settings.show_warranty_start_date === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormWarrantyStartDate">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Warranty Start Date</Text>
                                                            {this.state.editModeActive ? 
                                                                <DateInput 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Pick a Date"
                                                                    value={this.state.warranty_start_date_entered}
                                                                    onChange={(s) => {
                                                                        let dateString;
                                                                        if(s === null) {
                                                                            dateString = "";
                                                                        }

                                                                        else {
                                                                            dateString = s.toString();
                                                                        }
                                                                        this.handleWarrantyStartDateChange(s);
                                                                    }}
                                                                    clearable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.warranty_start_date !== null ? this.state.asset.warranty_start_date : ""}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_warranty_expiration_date === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormWarrantyEndDate">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Warranty End Date</Text>
                                                            {this.state.editModeActive ? 
                                                                <DateInput 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Pick a Date"
                                                                    value={this.state.warranty_end_date_entered}
                                                                    onChange={(s) => {
                                                                        let dateString;
                                                                        if(s === null) {
                                                                            dateString = "";
                                                                        }

                                                                        else {
                                                                            dateString = s.toString();
                                                                        }
                                                                        this.handleWarrantyEndDateChange(s);
                                                                    }}
                                                                    clearable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.warranty_expiration_date !== null ? this.state.asset.warranty_expiration_date : ""}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_lease_start_date === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormLeaseStartDate">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Lease Start Date</Text>
                                                            {this.state.editModeActive ? 
                                                                <DateInput 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Pick a Date"
                                                                    value={this.state.lease_start_date_entered}
                                                                    onChange={(s) => {
                                                                        let dateString;
                                                                        if(s === null) {
                                                                            dateString = "";
                                                                        }

                                                                        else {
                                                                            dateString = s.toString();
                                                                        }
                                                                        this.handleLeaseStartDateChange(s);
                                                                    }}
                                                                    clearable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.lease_start_date !== null ? this.state.asset.lease_start_date : ""}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_lease_end_date === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormLeaseEndDate">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Lease End Date</Text>
                                                            {this.state.editModeActive ? 
                                                                <DateInput 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Pick a Date"
                                                                    value={this.state.lease_end_date_entered}
                                                                    onChange={(s) => {
                                                                        let dateString;
                                                                        if(s === null) {
                                                                            dateString = "";
                                                                        }

                                                                        else {
                                                                            dateString = s.toString();
                                                                        }
                                                                        this.handleLeaseEndDateChange(s);
                                                                    }}
                                                                    clearable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.lease_end_date !== null ? this.state.asset.lease_end_date : ""}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_maintenance_dates === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormMaintenanceDates">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Maintenance Dates</Text>
                                                            {this.state.editModeActive ?
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.maintenance_dates_entered} onChange={(e) => this.handleMaintenanceDatesChange(e)} />
                                                                :
                                                                <Text c="blue">{this.state.asset.maintenance_dates !== undefined ? this.state.asset.maintenance_dates : ""}</Text>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                            </Form>
                                        </div>
                                        :
                                        undefined
                                    }
                                </Tabs.Panel> 
                                <Tabs.Panel value="Misc">
                                    {this.state.selected_form_tab === "Misc" ? 
                                        <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                            <Form>
                                            {this.state.asset_field_settings.show_isTracked === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormTrackAsset">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Track Location and Ownership History</Text>
                                                        {/* <Form.Label><Text size="sm">Should we track location and ownership history of this asset?</Text></Form.Label> */}
                                                            {this.state.editModeActive ?
                                                                <Switch style={{marginTop: "10px"}} size="lg" onLabel="YES" offLabel="NO" checked={this.state.track_asset} onChange={(e) => this.handleTrackAssetChange(e)}/>
                                                                :
                                                                <Switch disabled style={{marginTop: "10px"}} size="lg" onLabel="YES" offLabel="NO" checked={this.state.track_asset} onChange={(e) => this.handleTrackAssetChange(e)}/>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                            {this.state.asset_field_settings.show_is_peripheral === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormIsPeripheral">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Asset is a Peripheral</Text>
                                                        {/* <Form.Label><Text size="sm">Is this asset a peripheral of another one?</Text></Form.Label> */}
                                                            {this.state.editModeActive ? 
                                                                <Switch style={{marginTop: "10px"}} size="lg" onLabel="YES" offLabel="NO" checked={this.state.is_peripheral} onChange={(e) => { this.toggleAddFormAssignedAssetInputVisible(e.target.checked); this.handleIsPeripheralChange(e) }}/>
                                                                :
                                                                <Switch disabled style={{marginTop: "10px"}} size="lg" onLabel="YES" offLabel="NO" checked={this.state.is_peripheral} onChange={(e) => { this.toggleAddFormAssignedAssetInputVisible(e.target.checked); this.handleIsPeripheralChange(e) }}/>
                                                            }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row>
                                            }
                                                {this.state.enable_assigned_asset_input ?
                                                    <>
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormAssignedAssetCategory">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Parent Asset Category</Text>
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Pick a Value"
                                                                        data={this.state.asset_categories && this.state.asset_categories.map((category) => (
                                                                            category.name_of_category
                                                                        ))}
                                                                        value={
                                                                            this.state.selected_assigned_asset_category_id !== 0 && this.state.asset_categories && this.state.asset_categories.length > 0 && this.state.asset_categories.find((e) => e.id === this.state.selected_assigned_asset_category_id) ?
                                                                                this.state.asset_categories.find((e) => e.id === this.state.selected_assigned_asset_category_id).name_of_category
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(s) => {

                                                                            var categoryId = this.state.asset_categories.find((e) => e.name_of_category === s).id;
                                                                            if(categoryId !== null) {
                                                                                this.handleAssignedAssetCategoryChange(categoryId);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                    />
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormAssignedAssetType">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Parent Asset Type</Text>
                                                                    <Select
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder='Pick a Value'
                                                                        data={
                                                                            this.state.asset_types && this.state.asset_types.map((type) => (
                                                                                type.name_of_type
                                                                            ))
                                                                        }
                                                                        value={
                                                                            this.state.selected_assigned_asset_type_id !== 0 && this.state.asset_types && this.state.asset_types.length > 0 && this.state.asset_types.find((e) => e.id === this.state.selected_assigned_asset_type_id) ? 
                                                                                this.state.asset_types.find((e) => e.id === this.state.selected_assigned_asset_type_id).name_of_type
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(s) => {
                                                                            var typeId = this.state.asset_types.find((e) => e.name_of_type === s).id;
                                                                            if(typeId !== null) {
                                                                                this.handleAssignedAssetTypeChange(typeId);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                    />
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormAssignedAssetName">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Parent Asset Name</Text>
                                                                    <Select
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder='Pick a Value'
                                                                        data={
                                                                            this.state.assigned_asset_names && this.state.assigned_asset_names.map((asset) => (
                                                                                asset.name_of_asset
                                                                            ))
                                                                        }
                                                                        value={
                                                                            // this.state.selected_model_id !== 0 && this.state.model_names && this.state.model_names.length > 0 && this.state.model_names.find((e) => e.id === this.state.selected_model_id) ? 
                                                                            //     this.state.model_names.find((e) => e.id === this.state.selected_model_id).name_of_model
                                                                            //     :
                                                                            //     ""
                                                                            this.state.selected_assigned_asset_name_id !== 0 && this.state.assigned_asset_names && this.state.assigned_asset_names.length > 0 && this.state.assigned_asset_names.find((e) => e.id === this.state.selected_assigned_asset_name_id) ? 
                                                                                this.state.assigned_asset_names.find((e) => e.id === this.state.selected_assigned_asset_name_id).name_of_asset
                                                                                :
                                                                                ""
                                                                        }
                                                                        onChange={(s) => {
                                                                            // var siteId = this.state.sites.find((e) => e.name_of_site === s).id;
                                                                            // if(siteId !== null) {
                                                                            //     this.handleSelectedSiteChange(siteId);
                                                                            // }

                                                                            var assetId = this.state.assigned_asset_names.find((e) => e.name_of_asset === s).id;
                                                                            if(assetId !== null) {
                                                                                this.handleAssignedAssetNameChange(assetId);
                                                                            }
                                                                        }}
                                                                        allowDeselect={false}
                                                                        searchable
                                                                    />
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    </>
                                                    :
                                                    undefined
                                                }
                                                {this.state.asset_field_settings.show_description === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormDescription">
                                                        <span style={{ 
                                                            display: "flex", 
                                                            alignItems: "center",
                                                            width: "95%"
                                                        }}
                                                        >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Description</Text>
                                                        {this.state.editModeActive ? 
                                                            <Textarea style={{ flex: 1, width: "100%"}} placeholder="Enter text here" value={this.state.description_entered} onChange={(e) => this.handleDescriptionEnteredChange(e)} />
                                                            :
                                                            <Text c="blue">{this.state.description_entered}</Text>
                                                        }
                                                        </span>
                                                    </Form.Group>
                                                </Form.Row> 
                                                }
                                                {this.state.asset_field_settings.allow_asset_attachments === 1 && 
                                                <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormFileInput">
                                                        {this.state.editModeActive ? 
                                                            <FileInput  
                                                                label="Upload a file" 
                                                                placeholder="Click to upload"
                                                                description="(optional - must be .jpg, .jpeg, .png, .bmp, .heic, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .dwg, or .txt and less than 50MB)"
                                                                accept=".jpeg, .jpg, .png, .bmp, .heic, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .dwg, .txt"
                                                                multiple
                                                                clearable
                                                                onChange={(e) => this.handleAttachmentUploadChange(e)}
                                                            />
                                                            :
                                                            undefined
                                                        }
                                                    </Form.Group>
                                                </Form.Row>
                                                }
                                            </Form>
                                        </div>
                                        :
                                        undefined
                                    }
                                </Tabs.Panel>
                                {this.state.selected_type_name === "Services" ?
                                    <Tabs.Panel value="Services">
                                        {this.state.selected_form_tab === "Services" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    {this.state.asset_field_settings.show_health === 1 && 
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormHealth">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Health</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Good", "Neutral", "Poor"]}
                                                                        value={this.state.health_selected}
                                                                        onChange={(s) => this.handleHealthSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.health}</Text>
                                                                    }
                                                                </span> 
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_sla_availability === 1 && 
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormSLAAvailability">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>SLA Availability (in %)</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <NumberInput
                                                                            style={{ flex: 1, width: "100%"}}
                                                                            placeholder="Enter a value"
                                                                            allowNegative={false}
                                                                            decimalScale={0}
                                                                            fixedDecimalScale
                                                                            step={1}
                                                                            max={100}
                                                                            //prefix="$"
                                                                            //hideControls
                                                                            value={this.state.sla_availability_entered}
                                                                            onChange={(e) => this.handleSLAAvailabilityEnteredChange(e)}
                                                                        />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.sla_availability}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_cost === 1 && 
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormServiceCost">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Cost</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <NumberInput
                                                                            style={{ flex: 1, width: "100%"}}
                                                                            placeholder="Enter a value"
                                                                            allowNegative={false}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale
                                                                            step={0.01}
                                                                            prefix="$"
                                                                            //hideControls
                                                                            value={this.state.asset_cost_entered}
                                                                            onChange={(e) => this.handleAssetCostEnteredChange(e)}
                                                                        />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.cost}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_service_support_hours === 1 && 
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormServiceSupportHours">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Service Support Hours</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.service_support_hours_entered} onChange={(e) => this.handleServiceSupportHoursEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.service_support_hours}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Cloud" || 
                                    this.state.selected_type_name === "Virtual Machine" ||
                                    this.state.selected_type_name === "Volume" ||
                                    this.state.selected_type_name === "Host" || 
                                    this.state.selected_type_name === "Datacenter" || 
                                    this.state.selected_type_name === "Datastore" || 
                                    this.state.selected_type_name === "Image" || 
                                    this.state.selected_type_name === "Load Balancer" || 
                                    this.state.selected_type_name === "Security Group" || 
                                    this.state.selected_type_name === "Network" || 
                                    this.state.selected_type_name === "Resource Pool" || 
                                    this.state.selected_type_name === "Network Interface" || 
                                    this.state.selected_type_name === "Public IP Address" || 
                                    this.state.selected_type_name === "VPC" || 
                                    this.state.selected_type_name === "Subnet" || 
                                    this.state.selected_type_name === "Database" || 
                                    this.state.selected_type_name === "Key Pair" || 
                                    this.state.selected_type_name === "Object Storage" || 
                                    this.state.selected_type_name === "Key Vault" || 
                                    this.state.selected_type_name === "Subscription" || 
                                    this.state.selected_type_name === "Resource Group" || 
                                    this.state.selected_type_name === "Application Gateway" ? 
                                    <Tabs.Panel value="Cloud">
                                        {this.state.selected_form_tab === "Cloud" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                {this.state.asset_field_settings.show_cloud_cost === 1 &&
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormCloudCost">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Cost</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter an amount"
                                                                        allowNegative={false}
                                                                        decimalScale={2}
                                                                        fixedDecimalScale
                                                                        step={0.01}
                                                                        prefix="$"
                                                                        hideControls
                                                                        value={this.state.cloud_cost_entered}
                                                                        onChange={(e) => this.handleCloudCostChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.cloud_cost}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_cloud_last_audit_date === 1 &&
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormLastAuditDate">
                                                            <div>
                                                                <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Last Audit Date</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <DateTimePicker style={{ flex: 1, width: "100%"}} placeholder="Select a date" valueFormat="MM/DD/YYYY hh:mm A" clearable value={this.state.cloud_last_audit_date_entered} onChange={(e) => this.handleCloudLastAuditDateEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.last_audit_date}</Text>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_cloud_region === 1 &&
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRegion">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Region</Text>
                                                                {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["US West", "US Central", "US East"]}
                                                                    value={this.state.cloud_region_selected}
                                                                    onChange={(s) => this.handleCloudRegionSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.cloud_region}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_cloud_availability_zone === 1 &&
                                                    <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormAvailabilityZone">
                                                                <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Availability Zone</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["US West", "US Central", "US East"]}
                                                                        value={this.state.cloud_availability_zone_selected}
                                                                        onChange={(s) => this.handleCloudAvailabilityZoneSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.cloud_availability_zone}</Text>
                                                                    }
                                                                </span> 
                                                            </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_provider === 1 &&
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormProvider">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Provider</Text>
                                                                {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Placeholder"]}
                                                                    value={this.state.cloud_provider_selected}
                                                                    onChange={(s) => this.handleCloudProviderSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.provider}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Virtual Machine" ? 
                                    <Tabs.Panel value="Virtual Machine">
                                        {this.state.selected_form_tab === "Virtual Machine" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    {this.state.asset_field_settings.show_item_id === 1 && 
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVMItemId">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.item_id}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_item_name === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVMItemName">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.item_name}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_instance_type === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormInstanceType">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Instance Type</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Placeholder"]}
                                                                        value={this.state.instance_type_selected}
                                                                        onChange={(s) => this.handleInstanceTypeSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.instance_type}</Text>
                                                                    }
                                                                </span> 
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_private_address === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormPrivateAddress">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Private Address</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.vm_private_address_entered} onChange={(e) => this.handleVMPrivateAddressEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.private_address}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_public_address === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormPublicAddress">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Public Address</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.vm_public_address_entered} onChange={(e) => this.handleVMPublicAddressEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.public_address}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_vm_state === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVMState">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["In use", "Not in use"]}
                                                                        value={this.state.vm_state_selected}
                                                                        onChange={(s) => this.handleVMStateSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.vm_state}</Text>
                                                                    }
                                                                </span> 
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_vm_os_name === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormOSName">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>OS Name</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.vm_os_name_entered} onChange={(e) => this.handleVMOSNameEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.vm_os_name}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Volume" ? 
                                    <Tabs.Panel value="Volume">
                                        {this.state.selected_form_tab === "Volume" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    {this.state.asset_field_settings.show_item_id === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVolumeItemId">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.item_id}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_item_name === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVolumeItemName">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.item_name}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_volume_type === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVolumeType">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Volume Type</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.volume_type_entered} onChange={(e) => this.handleVolumeTypeEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.volume_type}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_size === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVolumeSize">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Size(GB)</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.datastore_size_entered}
                                                                        onChange={(e) => this.handleDatastoreSizeEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.size}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_volume_state === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVolumeState">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["In use", "Not in use"]}
                                                                        value={this.state.volume_state_selected}
                                                                        onChange={(s) => this.handleVolumeStateSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.volume_state}</Text>
                                                                    }
                                                                </span> 
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_iops === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormIOPS">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IOPS</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.iops_entered} onChange={(e) => this.handleIOPSEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.iops}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_creation_timestamp === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormVolumeCreationTimestamp">
                                                                <div>
                                                                    <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Creation Timestamp</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <DateTimePicker style={{ flex: 1, width: "100%"}} placeholder="Enter a value" valueFormat="MM/DD/YYYY hh:mm A" value={this.state.host_creation_timestamp_entered} onChange={(e) => this.handleHostCreationTimestampEnteredChange(e)} clearable/>
                                                                        :
                                                                        <Text c="blue">{this.state.asset.creation_timestamp}</Text>
                                                                    }
                                                                    </span>
                                                                </div>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Host" ? 
                                    <Tabs.Panel value="Host">
                                        {this.state.selected_form_tab === "Host" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    {this.state.asset_field_settings.show_item_id === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormHostItemId">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.item_id}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_item_name === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormHostItemName">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.item_name}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_memory_size === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormHostMemorySize">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Memory Size(GB)</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.computer_memory_entered}
                                                                        onChange={(e) => this.handleComputerMemoryEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.memory_size}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_cpu_core_count === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormHostCPUCoreCount">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>CPU Core Count</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.computer_cpu_core_count_entered}
                                                                        onChange={(e) => this.handleComputerCPUCoreCountEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.cpu_core_count}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_total_disk_size === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormTotalDiskSize">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Total Disk Size(GB)</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.computer_disk_space_entered}
                                                                        onChange={(e) => this.handleComputerDiskSpaceEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.total_disk_size}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_host_state === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormHostState">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                                    {this.state.editModeActive ?
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Active", "Inactive"]}
                                                                        value={this.state.host_state_selected}
                                                                        onChange={(s) => this.handleHostStateSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.host_state}</Text>
                                                                    }
                                                                </span> 
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_ip_address === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormHostIPAddress">
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IP Address</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                        :
                                                                        <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                    }
                                                                </span>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                    {this.state.asset_field_settings.show_creation_timestamp === 1 &&
                                                        <Form.Row>
                                                            <Form.Group as={Col} controlId="addFormHostCreationTimestamp">
                                                                <div>
                                                                    <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Creation Timestamp</Text>
                                                                        {this.state.editModeActive ? 
                                                                            <DateTimePicker style={{ flex: 1, width: "100%"}} placeholder="Enter a value" valueFormat="MM/DD/YYYY hh:mm A" value={this.state.host_creation_timestamp_entered} onChange={(e) => this.handleHostCreationTimestampEnteredChange(e)} clearable/>
                                                                            :
                                                                            <Text c="blue">{this.state.asset.creation_timestamp}</Text>
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </Form.Group>
                                                        </Form.Row>
                                                    }
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Datacenter" ? 
                                    <Tabs.Panel value="Datacenter">
                                        {this.state.selected_form_tab === "Datacenter" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatacenterItemId">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatacenterItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatacenterState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Active", "Inactive"]}
                                                                    value={this.state.datacenter_state_selected}
                                                                    onChange={(s) => this.handleDatacenterStateSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.datacenter_state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Datastore" ? 
                                    <Tabs.Panel value="Datastore">
                                        {this.state.selected_form_tab === "Datastore" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatastoreItemId">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatastoreItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatastoreState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Active", "Inactive"]}
                                                                    value={this.state.datastore_state_selected}
                                                                    onChange={(s) => this.handleDatastoreStateSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.datastore_state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatastoreSize">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Size (GB)</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.datastore_size_entered}
                                                                        onChange={(e) => this.handleDatastoreSizeEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.size}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatastoreFreeSpace">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Free Space (GB)</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.datastore_free_space_entered}
                                                                        onChange={(e) => this.handleDatastoreFreeSpaceEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.free_space}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatastoreConnectionState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Connection State</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Active", "Inactive"]}
                                                                    value={this.state.datastore_connection_state_selected}
                                                                    onChange={(s) => this.handleDatastoreConnectionStateSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.connection_state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Image" ? 
                                    <Tabs.Panel value="Image">
                                        {this.state.selected_form_tab === "Image" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormImageItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormImageItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormImageSource">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Image Source</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.image_source_entered} onChange={(e) => this.handleImageSourceEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.image_source}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormImageGuestOS">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Guest OS</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Windows 10", "Windows 11", "Linux", "MacOS"]}
                                                                    value={this.state.guest_os_selected}
                                                                    onChange={(s) => this.handleGuestOSSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.guest_os}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Load Balancer" ? 
                                    <Tabs.Panel value="Load Balancer">
                                        {this.state.selected_form_tab === "Load Balancer" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormLoadBalancerItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormLoadBalancerItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormDNSName">
                                                        <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>DNS Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.dns_name_entered} onChange={(e) => this.handleDNSNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.dns_name}</Text>
                                                                }
                                                        </span>
                                                    </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Security Group" ? 
                                    <Tabs.Panel value="Security Group">
                                        {this.state.selected_form_tab === "Security Group" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSecurityGroupItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSecurityGroupItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormInboundRuleCount">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Inbound Rule Count</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.inbound_rule_count_entered}
                                                                        onChange={(e) => this.handleInboundRuleCountEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.inbound_rule_count}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormOutboundRuleCount">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Outbound Rule Count</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.outbound_rule_count_entered}
                                                                        onChange={(e) => this.handleOutboundRuleCountEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.outbound_rule_count}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Network" ? 
                                    <Tabs.Panel value="Network">
                                        {this.state.selected_form_tab === "Network" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Active", "Inactive"]}
                                                                    value={this.state.network_state_selected}
                                                                    onChange={(s) => this.handleNetworkStateSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.network_state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkConnectionState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Connection State</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Active", "Inactive"]}
                                                                    value={this.state.network_connection_state_selected}
                                                                    onChange={(s) => this.handleNetworkConnectionStateSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.network_connection_state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormBandwidth">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Bandwidth</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.bandwidth_entered} onChange={(e) => this.handleBandwidthEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.bandwidth}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkRange">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Network Range</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.network_range_entered} onChange={(e) => this.handleNetworkRangeEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.network_range}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Resource Pool" ? 
                                    <Tabs.Panel value="Resource Pool">
                                        {this.state.selected_form_tab === "Resource Pool" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormResourcePoolItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormResourcePoolItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                :
                                                                <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormResourcePoolState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                            {this.state.editModeActive ? 
                                                            <Select 
                                                                style={{ flex: 1, width: "100%"}}
                                                                placeholder="Select a value"
                                                                data={["Active", "Inactive"]}
                                                                value={this.state.resource_pool_state_selected}
                                                                onChange={(s) => this.handleResourcePoolStateSelectedChange(s)}
                                                                allowDeselect={true}
                                                                searchable
                                                            />
                                                            :
                                                            <Text c="blue">{this.state.asset.resource_pool_state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormLastUpdated">
                                                            <div>
                                                                <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Last Updated</Text>
                                                                    {this.state.editModeActive ? 
                                                                    <DateTimePicker style={{ flex: 1, width: "100%"}} placeholder="Select a value" valueFormat="MM/DD/YYYY hh:mm A" value={this.state.resource_pool_last_updated} onChange={(e) => this.handleResourcePoolLastUpdatedChange(e)} clearable/>
                                                                    :
                                                                    <Text c="blue">{this.state.asset.last_updated}</Text>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Network Interface" ? 
                                    <Tabs.Panel value="Network Interface">
                                        {this.state.selected_form_tab === "Network Interface" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkInterfaceItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkInterfaceItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkInterfaceMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.mac_address_entered} onChange={this.handleMACAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkInterfacePublicDNSName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Public DNS Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.dns_name_entered} onChange={(e) => this.handleDNSNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.public_dns_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPrivateIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormNetworkInterfaceState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                            {this.state.editModeActive ? 
                                                            <Select 
                                                                style={{ flex: 1, width: "100%"}}
                                                                placeholder="Select a value"
                                                                data={["Active", "Inactive"]}
                                                                value={this.state.network_interface_state_selected}
                                                                onChange={(s) => this.handleNetworkInterfaceStateSelectedChange(s)}
                                                                allowDeselect={true}
                                                                searchable
                                                            />
                                                            :
                                                            <Text c="blue">{this.state.asset.network_interface_state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Public IP Address" ? 
                                    <Tabs.Panel value="Public IP Address">
                                        {this.state.selected_form_tab === "Public IP Address" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPublicIPItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPublicIPItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPublicIP">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Public IP</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={(e) => this.handleIPAddressEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.public_ip}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPublicIPState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                            {this.state.editModeActive ? 
                                                            <Select 
                                                                style={{ flex: 1, width: "100%"}}
                                                                placeholder="Select a value"
                                                                data={["Active", "Inactive"]}
                                                                value={this.state.public_ip_state_selected}
                                                                onChange={(s) => this.handlePublicIPStateSelectedChange(s)}
                                                                allowDeselect={true}
                                                                searchable
                                                            />
                                                            :
                                                            <Text c="blue">{this.state.asset.public_ip_state}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPublicDNS">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Public DNS</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.dns_name_entered} onChange={(e) => this.handleDNSNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.public_dns_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "VPC" ? 
                                    <Tabs.Panel value="VPC">
                                        {this.state.selected_form_tab === "VPC" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormVPCItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormVPCItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormVPCCIDRBlock">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>CIDR Block</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.cidr_block_entered} onChange={(e) => this.handleCIDRBlockEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.cidr_block}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Subnet" ? 
                                    <Tabs.Panel value="Subnet">
                                        {this.state.selected_form_tab === "Subnet" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormSubnetItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSubnetItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSubnetCIDRBlock">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>CIDR Block</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.cidr_block_entered} onChange={(e) => this.handleCIDRBlockEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.cidr_block}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Database" ? 
                                    <Tabs.Panel value="Database">
                                        {this.state.selected_form_tab === "Database" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatabaseItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatabaseItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPort">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Port</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.database_port_entered} onChange={(e) => this.handleDatabasePortEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.database_port}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormEngineVersion">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Engine Version</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.database_engine_version_entered} onChange={(e) => this.handleDatabaseEngineVersionEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.engine_version}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormAllocatedStorage">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Allocated Storage (GiB)</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.database_allocated_storage_entered}
                                                                        onChange={(e) => this.handleDatabaseAllocatedStorageEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.allocated_storage}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormMaxAllocatedStorage">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Max Allocated Storage (GiB)</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.database_max_allocated_storage_entered}
                                                                        onChange={(e) => this.handleDatabaseMaxAllocatedStorageEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.max_allocated_storage}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormEndpoint">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Endpoint</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.database_endpoint_entered} onChange={(e) => this.handleDatabaseEndpointEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.endpoint}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormCreatedTime">
                                                            <div>
                                                                <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Created Time</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <DateTimePicker style={{ flex: 1, width: "100%"}} placeholder="Select a value" valueFormat="MM/DD/YYYY hh:mm A" value={this.state.database_created_time_entered} onChange={(e) => this.handleDatabaseCreatedTimeEnteredChange(e)} clearable/>
                                                                        :
                                                                        <Text c="blue">{this.state.asset.created_time}</Text>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormMultipleAvailabilityZone-Not final">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Multiple Availability Zone</Text>
                                                                {this.state.editModeActive ? 
                                                                    <Switch style={{ flex: 1, width: "100%"}} size="lg" onLabel="YES" offLabel="NO" checked={this.state.database_multiple_availabilty_zone} onChange={() => this.handleDatabaseMultipleAvailabilityZoneChange()}/>
                                                                    :
                                                                    <Switch disabled style={{ flex: 1, width: "100%"}} size="lg" onLabel="YES" offLabel="NO" checked={this.state.database_multiple_availabilty_zone} onChange={() => this.handleDatabaseMultipleAvailabilityZoneChange()}/>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormLicenseModel">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>License Model</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.database_license_model_entered} onChange={(e) => this.handleDatabaseLicenseModelEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.license_model}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatabaseClass">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Database Class</Text>
                                                            {this.state.editModeActive ? 
                                                            <Select 
                                                                style={{ flex: 1, width: "100%"}}
                                                                placeholder="Select a value"
                                                                data={["Placeholder"]}
                                                                value={this.state.database_class_selected}
                                                                onChange={(s) => this.handleDatabaseClassSelectedChange(s)}
                                                                allowDeselect={true}
                                                                searchable
                                                            />
                                                            :
                                                            <Text c="blue">{this.state.asset.database_class}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDatabaseStatus">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Status</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Active", "Inactive"]}
                                                                    value={this.state.database_status_selected}
                                                                    onChange={(s) => this.handleDatabaseStatusSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.database_status}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Key Pair" ? 
                                    <Tabs.Panel value="Key Pair">
                                        {this.state.selected_form_tab === "Key Pair" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKeyPairItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKeyPairItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Object Storage" ? 
                                    <Tabs.Panel value="Object Storage">
                                        {this.state.selected_form_tab === "Object Storage" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormObjectStorageItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormObjectStorageItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Key Vault" ? 
                                    <Tabs.Panel value="Key Vault">
                                        {this.state.selected_form_tab === "Key Vault" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKeyVaultItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormKeyVaultItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Subscription" ? 
                                    <Tabs.Panel value="Subscription">
                                        {this.state.selected_form_tab === "Subscription" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSubscriptionItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSubscriptionItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Resource Group" ? 
                                    <Tabs.Panel value="Resource Group">
                                        {this.state.selected_form_tab === "Resource Group" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormResourceGroupItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormResourceGroupItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Application Gateway" ? 
                                    <Tabs.Panel value="Application Gateway">
                                        {this.state.selected_form_tab === "Application Gateway" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormApplicationGatewayItemID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item ID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_id_entered} onChange={(e) => this.handleItemIdEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_id}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormApplicationGatewayItemName">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Item Name</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.item_name_entered} onChange={(e) => this.handleItemNameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.item_name}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Hardware" || 
                                    this.state.selected_type_name === "Computer" || 
                                    this.state.selected_type_name === "Desktop" || 
                                    this.state.selected_type_name === "Laptop" || 
                                    this.state.selected_type_name === "Server" || 
                                    this.state.selected_type_name === "Storage" || 
                                    this.state.selected_type_name === "Disk" || 
                                    this.state.selected_type_name === "Datacenter" || 
                                    this.state.selected_type_name === "Rack" || 
                                    this.state.selected_type_name === "UPS" || 
                                    this.state.selected_type_name === "Mobile Devices" || 
                                    this.state.selected_type_name === "Monitor" || 
                                    this.state.selected_type_name === "Printer" || 
                                    this.state.selected_type_name === "Projector" || 
                                    this.state.selected_type_name === "Scanner" || 
                                    this.state.selected_type_name === "Router" || 
                                    this.state.selected_type_name === "Switch" || 
                                    this.state.selected_type_name === "Access Point" || 
                                    this.state.selected_type_name === "Firewall" || 
                                    this.state.selected_type_name === "Other Devices" || 
                                    this.state.selected_type_name === "SNMP" ? 
                                    <Tabs.Panel value="Hardware">
                                        {this.state.selected_form_tab === "Hardware" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                {this.state.asset_field_settings.show_usage_type === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormUsageType">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Usage Type</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Permanent", "Temporary"]}
                                                                    value={this.state.usage_type_selected}
                                                                    onChange={(s) => this.handleUsageTypeSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.usage_type}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_domain === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormHardwareDomain">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Domain</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Enter Text Here"
                                                                    value={this.state.hardware_domain_selected}
                                                                    onChange={(s) => this.handleHardwareDomainSelectedChange(s)}
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.domain}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_connection_types === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormConnectionTypes">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Connection Types</Text>
                                                            {this.state.editModeActive ? 
                                                                <TextInput 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Enter Text Here"
                                                                    value={this.state.connection_types_entered}
                                                                    onChange={(s) => this.handleConnectionTypesEnteredChange(s)}
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.connection_types}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_last_audit_date === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormHardwareLastAuditDate">
                                                            <div>
                                                                <span style={{ 
                                                                    display: "flex", 
                                                                    alignItems: "center",
                                                                    width: "95%"
                                                                }}
                                                                >
                                                                    <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Last Audit Date</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <DateTimePicker style={{ flex: 1, width: "100%"}} placeholder="Select a date" valueFormat="MM/DD/YYYY hh:mm A" clearable value={this.state.last_audit_date} onChange={(e) => this.handleLastAuditDateChange(e)}/>
                                                                        :
                                                                        <Text c="blue">{this.state.asset.last_audit_date}</Text>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Hardware" || 
                                    this.state.selected_type_name === "Computer" || 
                                    this.state.selected_type_name === "Desktop" || 
                                    this.state.selected_type_name === "Laptop" || 
                                    this.state.selected_type_name === "Server" || 
                                    this.state.selected_type_name === "Storage" || 
                                    this.state.selected_type_name === "Disk" || 
                                    this.state.selected_type_name === "Datacenter" || 
                                    this.state.selected_type_name === "Rack" || 
                                    this.state.selected_type_name === "UPS" || 
                                    this.state.selected_type_name === "Mobile Devices" || 
                                    this.state.selected_type_name === "Monitor" || 
                                    this.state.selected_type_name === "Printer" || 
                                    this.state.selected_type_name === "Projector" || 
                                    this.state.selected_type_name === "Scanner" || 
                                    this.state.selected_type_name === "Router" || 
                                    this.state.selected_type_name === "Switch" || 
                                    this.state.selected_type_name === "Access Point" || 
                                    this.state.selected_type_name === "Firewall" || 
                                    this.state.selected_type_name === "Other Devices" || 
                                    this.state.selected_type_name === "SNMP" ? 
                                    <Tabs.Panel value="Cost">
                                        {this.state.selected_form_tab === "Cost" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                {this.state.asset_field_settings.show_salvage === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSalvage">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Salvage</Text>
                                                            {this.state.editModeActive ? 
                                                                <NumberInput
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Enter $ amount"
                                                                    allowNegative={false}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale
                                                                    step={0.01}
                                                                    prefix="$"
                                                                    hideControls
                                                                    value={this.state.salvage_cost_entered}
                                                                    onChange={(e) => this.handleSalvageCostEnteredChange(e)}
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.salvage}</Text>
                                                            }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_depreciation_type === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDepreciationType">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}
                                                            >
                                                            <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Depreciation Type</Text>
                                                                {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Accelerated", "Straight-Line"]}
                                                                        value={this.state.depreciation_type_selected}
                                                                        onChange={(s) => this.handleDepeciationTypeSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.depreciation_type}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Computer" || 
                                    this.state.selected_type_name === "Desktop" || 
                                    this.state.selected_type_name === "Laptop" || 
                                    this.state.selected_type_name === "Server" ? 
                                    <Tabs.Panel value="Computer">
                                        {this.state.selected_form_tab === "Computer" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                {this.state.asset_field_settings.show_os === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerOS">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>OS</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.computer_os_selected} onChange={(e) => this.handleComputerOSSelectedChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.os_name}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_os_version === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerOSVersion">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>OS Version</Text>
                                                                {this.state.editModeActive ?
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.computer_os_version_entered} onChange={(e) => this.handleComputerOSVersionEnteredChange(e)} /> 
                                                                    :
                                                                    <Text c="blue">{this.state.asset.os_version}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_os_build === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerOSBuild">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>OS Build</Text>
                                                                {this.state.editModeActive ?
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.os_build_entered} onChange={(e) => this.handleOSBuildEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.os_build}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_os_service_pack === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormOSServicePack">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>OS Service Pack</Text>
                                                                {this.state.editModeActive ?
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.computer_os_service_pack_entered} onChange={(e) => this.handleComputerServicePackEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.os_service_pack}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_memory === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerMemory">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Memory - GB</Text>
                                                                {this.state.editModeActive ?
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.computer_memory_entered}
                                                                        onChange={(e) => this.handleComputerMemoryEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.memory}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_average_memory_utilization === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormAverageMemoryUtilization">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Average Memory Utilization</Text>
                                                                {this.state.editModeActive ?
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.average_memory_utilization_entered} onChange={(e) => this.handleAverageMemoryUtilizationEnteredChange(e)} />
                                                                    :
                                                                    <>
                                                                    {this.state.asset.average_memory_utilization !== null && this.state.asset.average_memory_utilization_percent !== null ?
                                                                        <Text c="blue">{`${this.state.asset.average_memory_utilization} (${this.state.asset.average_memory_utilization_percent}%)`}</Text>
                                                                        :
                                                                        <>
                                                                        {this.state.asset.average_memory_utilization !== null && this.state.asset.memory !== null ? 
                                                                            <Text c="blue">{`${this.state.asset.average_memory_utilization} (${this.calculateMemoryPercent(this.state.asset.memory, this.state.asset.average_memory_utilization)}%)`}</Text>
                                                                            :
                                                                            undefined
                                                                        }
                                                                        </>
                                                                    }
                                                                    </>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_computer_disk_space === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerDiskSpace">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Disk Space - GB</Text>
                                                                {this.state.editModeActive ?
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.computer_disk_space_entered}
                                                                        onChange={(e) => this.handleComputerDiskSpaceEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.computer_disk_space}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_disk_in_use === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDiskInUse">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Disk in Use</Text>
                                                                {this.state.editModeActive ?
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.disk_in_use_entered} onChange={(e) => this.handleDiskInUseEnteredChange(e)} />
                                                                    :
                                                                    <>
                                                                    {this.state.asset.disk_in_use !== null && this.state.asset.disk_in_use_percent !== null ? 
                                                                        <Text c="blue">{`${this.state.asset.disk_in_use} (${this.state.asset.disk_in_use_percent}%)`}</Text>
                                                                        :
                                                                        <>
                                                                        {this.state.asset.disk_in_use !== null && this.state.asset.computer_disk_space !== null ? 
                                                                            <Text c="blue">{`${this.state.asset.disk_in_use} (${this.calculateMemoryPercent(this.state.asset.computer_disk_space, this.state.asset.disk_in_use)}%)`}</Text>
                                                                            :
                                                                            undefined
                                                                        }
                                                                        </>
                                                                    }
                                                                    </>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_drive_encryption_status === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addDriveEncryptionStatus">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Drive Encryption Status</Text>
                                                                {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Encrypted", "Unencrypted"]}
                                                                        value={this.state.drive_encryption_status_selected}
                                                                        onChange={(s) => this.handleDriveEncryptionStatusSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.drive_encryption_status}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_cpu === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addCPUData">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>CPU</Text>
                                                                {this.state.editModeActive ?
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.cpu_entered} onChange={(e) => this.handleCPUEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.cpu}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_cpu_speed === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormCPUSpeed">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>CPU Speed - GHz</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.computer_cpu_speed_entered} onChange={(e) => this.handleComputerCPUSpeedEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.cpu_speed}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_cpu_core_count === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerCPUCoreCount">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>CPU Core Count</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //hideControls
                                                                        value={this.state.computer_cpu_core_count_entered}
                                                                        onChange={(e) => this.handleComputerCPUCoreCountEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.cpu_core_count}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_average_processor_utilization === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormProcessorUtilization">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Average Processor Utilization</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.average_processor_utlization_entered} onChange={(e) => this.handleAverageProcessorUtilizationEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.average_processor_utilization}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_mac_address === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.mac_address_entered} onChange={this.handleMACAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_uuid === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormUUID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>UUID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.computer_uuid_entered} onChange={(e) => this.handleComputerUUIDEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.uuid}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_hostname === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerHostname">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Hostname</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.computer_hostname_entered} onChange={(e) => this.handleComputerHostnameEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.hostname}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_ip_address === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerPublicIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Public IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_internal_ip_address === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormComputerInternalIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Internal IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.internal_ip_address_entered} onChange={(e) => this.handleInternalIPAddressEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.internal_ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_last_login_by === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormLastLoginBy">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Last Login By</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.computer_last_login_by_entered} onChange={(e) => this.handleComputerLastLoginByEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.last_login_by}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                {this.state.asset_field_settings.show_last_login_timestamp === 1 && 
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormLastLoginTimestamp">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Last Login Timestamp</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.last_login_timestamp_entered} onChange={(e) => this.handleLastLoginTimestampEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.last_login_timestamp}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                }
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {/* <Tabs.Panel value="Desktop">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel>
                                <Tabs.Panel value="Laptop">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel>
                                <Tabs.Panel value="Server">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel>
                                <Tabs.Panel value="Storage">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel> */}
                                {this.state.selected_type_name === "Disk" ? 
                                    <Tabs.Panel value="Disk">
                                        {this.state.selected_form_tab === "Disk" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDriveType">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Drive Type</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Placeholder"]}
                                                                    value={this.state.disk_drive_type_selected}
                                                                    onChange={(s) => this.handleDiskDriveTypeSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.drive_type}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDiskDiskSpace">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Disk Space (GB)</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.disk_space_entered} onChange={(e) => this.handleDiskSpaceEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.disk_space}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDiskFreeSpace">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Free Space (GB)</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.disk_free_space_entered} onChange={(e) => this.handleDiskFreeSpaceEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.disk_free_space}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormFreeSpaceCheckedOn">
                                                            <div>
                                                                <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Free Space Checked On</Text>
                                                                    {this.state.editModeActive ? 
                                                                        <DateTimePicker style={{ flex: 1, width: "100%"}} placeholder="Select a value" valueFormat="MM/DD/YYYY hh:mm A" value={this.state.disk_free_space_checked_on} onChange={(e) => this.handleDiskFreeSpaceCheckedOnChange(e)} clearable/>
                                                                        :
                                                                        <Text c="blue">{this.state.asset.free_space_checked_on}</Text>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Rack" ? 
                                    <Tabs.Panel value="Rack">
                                        {this.state.selected_form_tab === "Rack" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormFootprint">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Footprint</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.footprint_entered} onChange={(e) => this.handleFootprintEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.footprint}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPowerConsumption">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Power Consumption</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.power_consumption_entered} onChange={(e) => this.handlePowerConsumptionEnteredChage(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.power_consumption}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRackUnits">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Rack Units</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.rack_units_entered} onChange={(e) => this.handleRackUnitsEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.rack_units}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRackUnitsInUse">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Rack Units in Use</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.rack_units_in_use_entered} onChange={(e) => this.handleRackUnitsInUseEnteredChage(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.rack_units_in_use}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "UPS" ? 
                                    <Tabs.Panel value="UPS">
                                        {this.state.selected_form_tab === "UPS" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormUPSIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormBatteryStatus">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Battery Status</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Healthy", "Intermediate", "Poor", "Unusable"]}
                                                                    value={this.state.battery_status_selected}
                                                                    onChange={(s) => this.handleBatteryStatusSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.battery_status}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormBatteryVoltage">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Battery Voltage</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.battery_voltage_entered} onChange={(e) => this.handleBatteryVoltageEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.battery_voltage}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormBatteryCurrent">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Battery Current</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.battery_current_entered} onChange={(e) => this.handleBatteryCurrentEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.battery_current}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Mobile Devices" ? 
                                    <Tabs.Panel value="Mobile Devices">
                                        {this.state.selected_form_tab === "Mobile Devices" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormMobileDeviceOS">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>OS</Text>
                                                            {this.state.editModeActive ? 
                                                                <Select 
                                                                    style={{ flex: 1, width: "100%"}}
                                                                    placeholder="Select a value"
                                                                    data={["Android", "iOS"]}
                                                                    value={this.state.mobile_os_selected}
                                                                    onChange={(s) => this.handleMobileOSSelectedChange(s)}
                                                                    allowDeselect={true}
                                                                    searchable
                                                                />
                                                                :
                                                                <Text c="blue">{this.state.asset.mobile_os}</Text>
                                                            }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormMobileDeviceOSVersion">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>OS Version</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.computer_os_version_entered} onChange={(e) => this.handleComputerOSVersionEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.os_version}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormMobileDeviceMemory">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Memory (GB)</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.computer_memory_entered}
                                                                        onChange={(e) => this.handleComputerMemoryEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.memory}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormIMEINumber">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IMEI Number</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.imei_number_entered} onChange={(e) => this.handleIMEINumberEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.imei_number}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {/* <Tabs.Panel value="Monitor">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel> */}
                                {this.state.selected_type_name === "Printer" ? 
                                    <Tabs.Panel value="Printer">
                                        {this.state.selected_form_tab === "Printer" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPrinterType">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Printer Type</Text>
                                                                {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Laser", "InkJet"]}
                                                                        value={this.state.printer_type_selected}
                                                                        onChange={(s) => this.handlePrinterTypeSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.printer_type}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPrinterIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                }
                                                                    </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPrinterMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.mac_address_entered} onChange={this.handleMACAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormPrinterSubnetMask">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Subnet Mask</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.subnet_mask_entered} onChange={(e) => this.handleSubnetMaskEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.subnet_mask}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {/* <Tabs.Panel value="Projector">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel>
                                <Tabs.Panel value="Scanner">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel> */}
                                {this.state.selected_type_name === "Router" ? 
                                    <Tabs.Panel value="Router">
                                        {this.state.selected_form_tab === "Router" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRouterFirmware">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Firmware</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.firmware_entered} onChange={(e) => this.handleFirmwareEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.firmware}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRouterFirmwareVersion">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Firmware Version</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.firmware_version_entered} onChange={(e) => this.handleFirmwareVersionEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.firmware_version}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRouterIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRouterPorts">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Ports</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ports_entered} onChange={(e) => this.handlePortsEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.port}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRouterMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.mac_address_entered} onChange={this.handleMACAddressEnteredChange} />
                                                                :
                                                                <Text c="blue">{this.state.asset.mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormRouterSubnetMask">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Subnet Mask</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.subnet_mask_entered} onChange={(e) => this.handleSubnetMaskEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.subnet_mask}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Switch" ? 
                                    <Tabs.Panel value="Switch">
                                        {this.state.selected_form_tab === "Switch" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormSwitchFirmware">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Firmware</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.firmware_entered} onChange={(e) => this.handleFirmwareEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.firmware}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSwitchFirmwareVersion">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Firmware Version</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.firmware_version_entered} onChange={(e) => this.handleFirmwareVersionEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.firmware_version}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSwitchIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSwitchPorts">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Ports</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ports_entered} onChange={(e) => this.handlePortsEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.port}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSwitchMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.mac_address_entered} onChange={this.handleMACAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSwitchSubnetMask">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Subnet Mask</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.subnet_mask_entered} onChange={(e) => this.handleSubnetMaskEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.subnet_mask}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Access Point" ? 
                                    <Tabs.Panel value="Access Point">
                                        {this.state.selected_form_tab === "Access Point" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormAccessPointFirmware">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Firmware</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.firmware_entered} onChange={(e) => this.handleFirmwareEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.firmware}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormAccessPointFirmwareVersion">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Firmware Version</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.firmware_version_entered} onChange={(e) => this.handleFirmwareVersionEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.firmware_version}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormAccessPointIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormAccessPointPorts">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Ports</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ports_entered} onChange={(e) => this.handlePortsEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.port}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormAccessPointMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.mac_address_entered} onChange={this.handleMACAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormAccessPointSubnetMask">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Subnet Mask</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.subnet_mask_entered} onChange={(e) => this.handleSubnetMaskEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.subnet_mask}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Firewall" ?  
                                    <Tabs.Panel value="Firewall">
                                        {this.state.selected_form_tab === "Firewall" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormFirewallFirmware">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Firmware</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.firmware_entered} onChange={(e) => this.handleFirmwareEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.firmware}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormFirewallFirmwareVersion">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Firmware Version</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.firmware_version_entered} onChange={(e) => this.handleFirmwareVersionEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.firmware_version}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormFirewallIPAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>IP Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ip_address_entered} onChange={this.handleIPAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.ip_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormFirewallPorts">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Ports</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.ports_entered} onChange={(e) => this.handlePortsEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.port}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormFirewallMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter Text Here" value={this.state.mac_address_entered} onChange={this.handleMACAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormFirewallSubnetMask">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Subnet Mask</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.subnet_mask_entered} onChange={(e) => this.handleSubnetMaskEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.subnet_mask}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {/* <Tabs.Panel value="Other Devices">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel> */}
                                {this.state.selected_type_name === "SNMP" ? 
                                    <Tabs.Panel value="SNMP">
                                        {this.state.selected_form_tab === "SNMP" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSystemOID">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>System OID</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.system_oid_entered} onChange={(e) => this.handleSystemOIDEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.system_oid}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormSNMPMACAddress">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>MAC Address</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.mac_address_entered} onChange={this.handleMACAddressEnteredChange} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.mac_address}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {this.state.selected_type_name === "Consumable" ? 
                                    <Tabs.Panel value="Consumable">
                                        {this.state.selected_form_tab === "Consumable" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormConsumableState">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>State</Text>
                                                                {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Active", "Inactive"]}
                                                                        value={this.state.consumable_state_selected}
                                                                        onChange={(s) => this.handleConsumableStateSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.consumable_state}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormConsumableQuantity">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Quantity</Text>
                                                                {this.state.editModeActive ? 
                                                                    <NumberInput
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Enter a value"
                                                                        allowNegative={false}
                                                                        decimalScale={0}
                                                                        fixedDecimalScale
                                                                        step={1}
                                                                        //prefix="$"
                                                                        //hideControls
                                                                        value={this.state.consumable_quantity_entered}
                                                                        onChange={(e) => this.handleConsumableQuantityEnteredChange(e)}
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.quantity}</Text>
                                                                }
                                                            </span>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {/* <Tabs.Panel value="Network">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel> */}
                                {this.state.selected_type_name === "Document" ? 
                                    <Tabs.Panel value="Document">
                                        {this.state.selected_form_tab === "Document" ? 
                                            <div style={{marginTop: "0px", marginLeft: "20px"}}>
                                                <Form>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDocumentStatus">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Status</Text>
                                                                {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Active", "Inactive"]}
                                                                        value={this.state.document_status_selected}
                                                                        onChange={(s) => this.handleDocumentStatusSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.document_status}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="addFormDocumentType">
                                                            <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Type</Text>
                                                                {this.state.editModeActive ? 
                                                                    <Select 
                                                                        style={{ flex: 1, width: "100%"}}
                                                                        placeholder="Select a value"
                                                                        data={["Placeholder"]}
                                                                        value={this.state.document_type_selected}
                                                                        onChange={(s) => this.handleDocumentTypeSelectedChange(s)}
                                                                        allowDeselect={true}
                                                                        searchable
                                                                    />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.document_type}</Text>
                                                                }
                                                            </span> 
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                    <Form.Group as={Col} controlId="addFormDocumentVersion">
                                                        <span style={{ 
                                                                display: "flex", 
                                                                alignItems: "center",
                                                                width: "95%"
                                                            }}>
                                                                <Text size="sm" style={{width: "250px", minWidth: "250px", whiteSpace: "nowrap"}}>Version</Text>
                                                                {this.state.editModeActive ? 
                                                                    <TextInput style={{ flex: 1, width: "100%"}} placeholder="Enter a value" value={this.state.document_version_entered} onChange={(e) => this.handleDocumentVersionEnteredChange(e)} />
                                                                    :
                                                                    <Text c="blue">{this.state.asset.version}</Text>
                                                                }
                                                        </span>
                                                    </Form.Group>
                                                    </Form.Row>
                                                </Form>
                                            </div>
                                            :
                                            undefined
                                        }
                                    </Tabs.Panel>
                                    :
                                    undefined
                                }
                                {/* <Tabs.Panel value="Others">
                                    <div style={{marginTop: "30px"}}>
                                        <Form>
                                            <Form.Row>
                                                
                                            </Form.Row>
                                        </Form>
                                    </div>
                                </Tabs.Panel> */}
                            </Tabs>
                        </Paper>
                        {this.state.editModeActive &&
                            <>
                            <div style={{textAlign: 'center'}}><Text c="dimmed" size="sm" style={{cursor: "default"}}>Note: Only the fields in the basic info tab are required</Text></div>
                            
                                <div style={{textAlign: 'center', marginTop: "50px"}}>
                                    {/* <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeEditPage()}>Cancel</Button></span> */}
                                    <span><Button onClick={() => this.submitEditAssetForm()}>Save</Button></span>
                                </div>
                            </>
                        }
                        <div style={{ textAlign: "center", marginTop: "15px" }}>
                            {this.state.canSeeErrorMessage ?
                                <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields before submitting.</Text>
                                :
                                undefined
                            }
                            {this.state.canSeeDuplicateNameError ?
                                <Text c="red">Error: An asset with this name already exists. Please try a different name.</Text>
                                :
                                undefined
                            }
                        </div>
                        {this.state.interaction_mode === "edit" &&
                            <Paper withBorder p="md" radius="md" display="block" m="5px">
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('notesSection')}>
                                    <Text><strong>Notes</strong></Text>
                                    {this.state.notesSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.notesSection}>
                                    <div style={{"marginLeft": '10px', "marginBottom": '10px'}}><Button onClick={() => this.openAssetNotesModal()}>Add +</Button></div>
                                    <Table withRowBorders={true} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Thead>
                                            <Table.Th w='68%'>Note Text</Table.Th>
                                            <Table.Th w='20%'>Created By</Table.Th>
                                            <Table.Th w='12%'>Time Created</Table.Th>
                                        </Table.Thead>
                                        <Table.Tbody>
                                            {this.state.notes && this.state.notes.map((note) => (
                                                <Table.Tr>
                                                    <Table.Td w='68%'>{parse(cleanHTML(note.note_text))}</Table.Td>
                                                    <Table.Td w='20%'>{`${note.creator_first_name} ${note.creator_last_name}`}</Table.Td>
                                                    <Table.Td w='12%'>{note.formatted_date_time_created}</Table.Td>
                                                </Table.Tr>
                                            ))}
                                        </Table.Tbody>
                                    </Table>
                                </Collapse>
                            </Paper>
                        }
                        {this.state.interaction_mode === "edit" && this.state.asset_field_settings.allow_asset_attachments === 1 && 
                            <Paper withBorder p="md" radius="md" display="block" m="5px">
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('attachmentsSection')}>
                                    <Text><strong>Attachments</strong></Text>
                                    {this.state.attachmentsSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.attachmentsSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        {this.state.attachments && this.state.attachments.map((attachment) => (
                                            <Table.Tr>
                                                <Anchor href={attachment.attachment_url} target="_blank">{attachment.filename}</Anchor>
                                            </Table.Tr>
                                        ))}
                                    </Table>
                                </Collapse>
                            </Paper>
                        }
                        {this.state.installed_software && this.state.installed_software.length > 0 ?
                            <Paper withBorder p="md" radius="md" display="block" m="5px">
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('installedSoftwareSection')}>
                                    <Text><strong>Installed Software</strong></Text>
                                    {this.state.installedSoftwareSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.installedSoftwareSection}>
                                    <Table style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Thead>
                                            <Table.Tr>
                                                <Table.Th style={{width: "50%"}}>Name</Table.Th>
                                                <Table.Th style={{width: "25%"}}>Vendor</Table.Th>
                                                <Table.Th style={{width: "25%"}}>Version</Table.Th>
                                            </Table.Tr>
                                        </Table.Thead>
                                        <Table.Tbody>
                                            {this.state.installed_software && this.state.installed_software.map((item, index) => (
                                                (item.name !== null && item.vendor !== null && item.version !== null) ? (
                                                    <Table.Tr key={`softwareRow-${index}`}>
                                                        <Table.Td style={{width: "50%"}}>{item.name !== null ? item.name : "-"}</Table.Td>
                                                        <Table.Td style={{width: "25%"}}>{item.vendor !== null ? item.vendor : "-"}</Table.Td>
                                                        <Table.Td style={{width: "25%"}}>{item.version !== null ? item.version : "-"}</Table.Td>
                                                    </Table.Tr>
                                                ) : undefined 
                                            ))}
                                        </Table.Tbody>
                                    </Table>
                                </Collapse>
                            </Paper>
                            :
                            undefined
                        }
                            
                    </Container>
                </Box>
                <Paper withBorder p="md" radius="md" mr="20px" mt="5px" w="325px" style={{ flexShrink: 0 }} className={classes.showHideMiniKnowledgebase}>
                    <div style={{marginBottom: "10px"}}><Text td="underline" fw={700} ta="center">Asset History Timeline</Text></div>
                    <span className="miniKnowledgebase showHideMiniKnowledgebase">
                        {this.state.history && this.state.history.map((event, index) => (
                            <div style={{ textAlign: "center" }} key={`history_item-${event.id}`}>
                                <div><Text size="sm" fw={600}>{event.item_text}</Text></div>
                                <div><Text size="xs" fs="italic">{`${event.creator_first_name} ${event.creator_last_name}`}</Text></div>
                                <div><Text size="xs" fs="italic">{event.formatted_date_time_created}</Text></div>
                                {index === this.state.history.length - 1 ?
                                    undefined
                                    :
                                    <div style={{ paddingTop: "10px", paddingBottom: "10px", color: "blue" }}>|</div>
                                }
                            </div>
                        ))}
                    </span>
                </Paper>
                </Group>

                {/* This modal is the welcome modal that controls company and manufacturer choice */}
                <Modal
                    opened={this.state.show_welcome_modal}
                    onClose={() => this.closeWelcomeModal()}
                    //title="Let's Start With the Following Data"
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                >
                    <Form>
                        
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Let's Start With the Following Data</Text></div>
                        {/* THE HIDDEN ELEMENT WAS NEEDED AT THE TOP OF THE FORM TO ALLOW THE FIRST ELEMENT TO BE SEARCHABLE - WAS CAUSING ERROR OTHERWISE */}
                        <Form.Group as={Col} controlId="hiddenElementWelcomModal"><TextInput hidden></TextInput></Form.Group>
                        <Form.Group as={Col} controlId="addFormTenant">
                            {this.props.loggedStatus.email && this.props.loggedStatus.email.split("@").length > 1 && this.state.authorizedDomainsForTenantChange.includes(this.props.loggedStatus.email.split("@")[1].toLowerCase()) ? 
                                <Select 
                                    label="What company does this asset belong to?"
                                    placeholder="Pick a Value"
                                    data={this.state.tenants && this.state.tenants.map((tenant) => (
                                        tenant.name_of_tenant
                                    ))}
                                    value={
                                        this.state.selected_tenant_id !== 0 && this.state.tenants && this.state.tenants.length > 0 && this.state.tenants.find((e) => e.id === this.state.selected_tenant_id) ? 
                                            this.state.tenants.find((e) => e.id === this.state.selected_tenant_id).name_of_tenant
                                            :
                                            ""
                                    }
                                    onChange={(s) => {
                                        var tenantId = this.state.tenants.find((e) => e.name_of_tenant === s).id;
                                        if(tenantId !== null) {
                                            this.handleTenantChange(tenantId);
                                        }
                                    }}
                                    allowDeselect={false}
                                    searchable
                                    disabled
                                />
                                :
                                <Select 
                                    label="What company does this asset belong to?"
                                    placeholder="Pick a Value"
                                    data={this.state.tenants && this.state.tenants.map((tenant) => (
                                        tenant.name_of_tenant
                                    ))}
                                    value={
                                        this.state.selected_tenant_id !== 0 && this.state.tenants && this.state.tenants.length > 0 && this.state.tenants.find((e) => e.id === this.state.selected_tenant_id) ? 
                                            this.state.tenants.find((e) => e.id === this.state.selected_tenant_id).name_of_tenant
                                            :
                                            ""
                                    }
                                    onChange={(s) => {
                                        var tenantId = this.state.tenants.find((e) => e.name_of_tenant === s).id;
                                        if(tenantId !== null) {
                                            this.handleTenantChange(tenantId);
                                        }
                                    }}
                                    allowDeselect={false}
                                    disabled
                                />
                            }
                        </Form.Group>
                        <Form.Group as={Col} controlId="addFormModelManufacturer">
                            <Select
                                label="Who made this asset?"
                                placeholder="Pick a Value"
                                data={
                                    this.state.manufacturers && this.state.manufacturers.map((manufacturer) => (
                                        manufacturer.name_of_manufacturer
                                    ))
                                }
                                value={
                                    this.state.manufacturer_id_selected !== 0 && this.state.manufacturers && this.state.manufacturers.length > 0 && this.state.manufacturers.find((e) => e.id === this.state.manufacturer_id_selected) ? 
                                        this.state.manufacturers.find((e) => e.id === this.state.manufacturer_id_selected).name_of_manufacturer
                                        :
                                        ""
                                }
                                onChange={(s) => {
                                    var manufacturerId = this.state.manufacturers.find((e) => e.name_of_manufacturer === s).id;
                                    if(manufacturerId !== null) {
                                        this.handleCreateModelManufacturerChange(manufacturerId)
                                    }
                                }}
                                allowDeselect={false}
                                searchable
                            />
                        </Form.Group>
                        <div style={{textAlign: 'center', marginTop: '50px'}}><Text c="dimmed" size="sm">Note: Changing these values will change options available in other form fields</Text></div>
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span>
                                {this.state.manufacturer_id_selected !== 0 ? 
                                    <Button onClick={() => this.closeWelcomeModal()}>Ok</Button>
                                    :
                                    <Button disabled>Ok</Button>
                                }
                            </span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for adding asset categories */}
                <Modal
                    opened={this.state.show_category_modal}
                    onClose={() => this.closeCategoryModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create A Category</Text></div>
                        {/* <Modal.Body>
                            <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormCategoryName" className="mb-3">
                                        {/* <Form.Label>Category Name</Form.Label> */}
                                        <TextInput label="Category Name" placeholder="ex: IT" value={this.state.createCategory_category_name_entered} onChange={this.handleCreateCategoryNameChange} required />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                {this.state.canSeeErrorMessageCreateCategory ?
                                    <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                    :
                                    undefined
                                }
                                {this.state.canSeeDuplicateNameErrorCreateCategory ?
                                    <Text c="red">Error: A category with this name already exists. Please try a different name.</Text>
                                    :
                                    undefined
                                }
                            </div>
                        {/* </Modal.Body> */}
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeCategoryModal()} className="gothamNarrowFont">Cancel</Button></span>
                            <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateCategoryForm() }} className="gothamNarrowFont">Submit</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for adding an asset type */}
                <Modal
                    opened={this.state.show_type_modal}
                    onClose={() => this.closeTypeModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create Asset Type</Text></div>
                        {/* <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{ textAlign: "center", cursor: "default" }} className="gothamNarrowFont">Create Asset Type</div>
                                <div style={{ cursor: "default", fontSize: "15px" }} className="gothamNarrowLightFont"><span className="requiredStar">*</span> indicates a required field</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormTypeName" className="mb-3">
                                        {/* <Form.Label>Type Name<span className="requiredStar">*</span></Form.Label> */}
                                        <TextInput label="Type Name" placeholder="ex: Printer" value={this.state.createType_type_name} onChange={this.handleCreateTypeNameChange} required />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            <div style={{ width: "100%", textAlign: "left" }}>
                                <span style={{ display: "inline-block", width: "95%" }}>
                                    <Form.Group controlId="addFormIsCoreAsset" className="mb-3">
                                        <Form.Label><Text size="sm">Can this asset have peripherals assigned to it?</Text></Form.Label>
                                        <Switch size="md" onLabel="YES" offLabel="NO" checked={this.state.selected_is_core_value} onChange={(e) => this.handleIsCoreChange(e.target.checked)} required/>
                                        {/* <Form.Label>Is Core Asset<span className="requiredStar">*</span></Form.Label>
                                        <div className="mb-3">
                                            <Form.Check
                                                inline
                                                checked={this.state.selected_is_core_value}
                                                label="Yes"
                                                name="peripheral radio"
                                                type="radio"
                                                id="Yes Is Core Radio"
                                                value="true"
                                                onChange={() => this.handleIsCoreChange(true)}
                                            />
                                            <Form.Check
                                                inline
                                                checked={!this.state.selected_is_core_value}
                                                label="No"
                                                name="peripheral radio"
                                                type="radio"
                                                id="Not Core Radio"
                                                value="false"
                                                onChange={() => this.handleIsCoreChange(false)}
                                            />
                                        </div> */}
                                    </Form.Group>
                                </span>
                            </div>
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                {this.state.canSeeErrorMessageCreateType ?
                                    <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                    :
                                    undefined
                                }
                                {this.state.canSeeDuplicateNameErrorCreateType ?
                                    <Text c="red">Error: A type with this name already exists. Please try a different name.</Text>
                                    :
                                    undefined
                                }
                            </div>
                        {/* </Modal.Body> */}
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeTypeModal()} className="gothamNarrowFont">Cancel</Button></span>
                            <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateTypeForm() }} className="gothamNarrowFont">Submit</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for creating asset models */}
                <Modal
                    opened={this.state.show_model_modal}
                    onClose={() => this.closeModelModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create Asset Model</Text></div>
                        {/* <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{ textAlign: "center", cursor: "default" }} className="gothamNarrowFont">Create Asset Model</div>
                                <div style={{ cursor: "default", fontSize: "15px" }} className="gothamNarrowLightFont"><span className="requiredStar">*</span> indicates a required field</div>
                            </Modal.Title>
                        </Modal.Header>
                            <Modal.Body>*/}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormModelName" className="mb-3">
                                        {/* <Form.Label>Model Name<span className="requiredStar">*</span></Form.Label> */}
                                        <TextInput label="Model Name" placeholder="ex: Lenovo Thinkpad x51" value={this.state.model_name_entered} onChange={this.handleCreateModelNameChange} required />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%", textAlign: "left" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormModelType" className="mb-3">
                                        {/* <Form.Label>{`Asset Type (based on type selected in outer form)`}<span className="requiredStar">*</span></Form.Label> */}
                                        <Select
                                            label="Asset Type (based on type selected in outer form)"
                                            placeholder="Pick a Value"
                                            data={
                                                this.state.asset_types && this.state.asset_types.map((type) => (
                                                    type.name_of_type
                                                ))
                                            }
                                            value={
                                                this.state.selected_type_id !== 0 && this.state.asset_types && this.state.asset_types.length > 0 && this.state.asset_types.find((e) => e.id === this.state.selected_type_id) ?
                                                    this.state.asset_types.find((e) => e.id === this.state.selected_type_id).name_of_type
                                                    :
                                                    ""
                                            }
                                            disabled
                                        />
                                        {/* <Form.Control as="select" required disabled>
                                            {this.state.asset_types && this.state.asset_types.map((type) => (
                                                <>
                                                    {this.state.selected_type_id === type.id ?
                                                        <option key={`modelType_${type.id}`} onClick={() => this.handleCreateModelTypeChange(type.id)} selected>{type.name_of_type}</option>
                                                        :
                                                        <option key={`modelType_${type.id}`} onClick={() => this.handleCreateModelTypeChange(type.id)}>{type.name_of_type}</option>
                                                    }
                                                </>
                                            ))}
                                        </Form.Control> */}
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormModelCost" className="mb-3">
                                        {/* <Form.Label>Cost</Form.Label> */}
                                        <NumberInput
                                            label="Cost"
                                            placeholder="Enter cost here"
                                            allowNegative={false}
                                            decimalScale={2}
                                            fixedDecimalScale
                                            step={0.01}
                                            prefix="$"
                                            hideControls
                                            value={this.state.cost_entered/* parseFloat(this.state.cost_entered).toString() */}
                                            onChange={this.handleCreateModelCostChange}
                                        />
                                        {/* <Form.Control type="number" min="0" step="0.01" placeholder="ex: 1250.59" value={parseFloat(this.state.cost_entered).toString()} onChange={(e)=> this.handleCreateModelCostChange(e)} /> */}
                                        {/* Within the form's submit fxn use: Math.round(3.14159265359 * 100) / 100 to make sure value has 2 decimal places */}
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            <div style={{ width: "100%", textAlign: "left" }}>
                                <span style={{ display: "inline-block", width: "95%" }}>
                                    <Form.Group controlId="addFormModelManufacturer" className="mb-3">
                                        {/* <Form.Label>Manufacturer<span className="requiredStar">*</span></Form.Label> */}
                                        <Select 
                                            label="Manufacturer"
                                            placeholder="Pick a Value"
                                            data={
                                                this.state.manufacturers && this.state.manufacturers.map((manufacturer) => (
                                                    manufacturer.name_of_manufacturer
                                                ))
                                            }
                                            value={
                                                this.state.manufacturer_id_selected_create_model_form !== 0 && this.state.manufacturers && this.state.manufacturers.length > 0 && this.state.manufacturers.find((e) => e.id === this.state.manufacturer_id_selected_create_model_form) ? 
                                                    this.state.manufacturers.find((e) => e.id === this.state.manufacturer_id_selected_create_model_form).name_of_manufacturer
                                                    :
                                                    ""
                                            }
                                            onChange={(s) => {
                                                // var siteId = this.state.sites.find((e) => e.name_of_site === s).id;
                                                // if(siteId !== null) {
                                                //     this.handleSelectedSiteChange(siteId);
                                                // }

                                                var manufacturerId = this.state.manufacturers.find((e) => e.name_of_manufacturer === s).id;
                                                if(manufacturerId !== null) {
                                                    this.handleCreateModelManufacturerChangeCreateModelModalForm(manufacturerId);
                                                }
                                            }}
                                            allowDeselect={false}
                                            searchable
                                            required
                                        />
                                        {/* <Form.Control as="select" required>
                                            {this.state.manufacturers && this.state.manufacturers.map((manufacturer) => (
                                                <>
                                                    {this.state.manufacturer_id_selected === manufacturer.id ?
                                                        <option key={`manufacturer_${manufacturer.id}`} onClick={() => this.handleCreateModelManufacturerChange(manufacturer.id)} selected>{manufacturer.name_of_manufacturer}</option>
                                                        :
                                                        <option key={`manufacturer_${manufacturer.id}`} onClick={() => this.handleCreateModelManufacturerChange(manufacturer.id)}>{manufacturer.name_of_manufacturer}</option>
                                                    }
                                                </>
                                            ))}
                                        </Form.Control> */}
                                    </Form.Group>
                                </span>
                                {/* <span style={{ display: "inline-block", paddingLeft: "15px" }}> */}
                                <span style={{ display: "inline-block", paddingLeft: "5px", cursor: "pointer" }}>
                                    <Tooltip label="Click to create a new manufacturer"><IconPlus color="#00abfb" onClick={() => this.openManufacturerModal()}/></Tooltip>
                                </span>
                                    {/* <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>Click to add a new item</Tooltip>
                                        }
                                    >
                                        <FontAwesomeIcon className="addFormPlusIcon" style={{ color: "black", cursor: "pointer" }} icon={faPlus} onClick={() => this.openManufacturerModal()} />
                                    </OverlayTrigger> */}
                                {/* </span> */}
                            </div>
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                {this.state.canSeeErrorMessageCreateModel ?
                                    <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                    :
                                    undefined
                                }
                                {this.state.canSeeDuplicateNameErrorCreateModel ?
                                    <Text c="red">Error: A model with this name already exists. Please try a different name.</Text>
                                    :
                                    undefined
                                }
                            </div>
                        {/* </Modal.Body> */}
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeModelModal()} className="gothamNarrowFont">Cancel</Button></span>
                            <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateModelForm() }} className="gothamNarrowFont">Submit</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for creating a new manufacturer */}
                <Modal
                    opened={this.state.show_manufacturer_modal}
                    onClose={() => this.closeManufacturerModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create Manufacturer</Text></div>
                        {/* <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{ textAlign: "center", cursor: "default" }} className="gothamNarrowFont">Create Manufacturer</div>
                                <div style={{ cursor: "default", fontSize: "15px" }} className="gothamNarrowLightFont"><span className="requiredStar">*</span> indicates a required field</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormManufacturerName" className="mb-3">
                                        {/* <Form.Label>Manufacturer Name<span className="requiredStar">*</span></Form.Label> */}
                                        <TextInput label="Manufacturer Name" placeholder="ex: Lenovo" value={this.state.manufacturer_name_entered} onChange={this.handleCreateManufacturerNameChange} required />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    {/* <Form.Group controlId="addFormManufacturerType" className="mb-3">
                                        
                                        <TextInput label="Manufacturer Type" placeholder="ex: Hardware" value={this.state.manufacturer_type_entered} onChange={this.handleCreateManufacturerTypeChange} required />
                                    </Form.Group> */}
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormManufacturerPhone" className="mb-3">
                                        {/* <Form.Label>Phone Number</Form.Label> */}
                                        <TextInput label="Phone Number" placeholder="ex: 555-555-5555" value={this.state.manufacturer_phone_number_entered} onChange={this.handleCreateManufacturerPhoneChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                {this.state.canSeeErrorMessageCreateManufacturer ?
                                    <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                    :
                                    undefined
                                }
                                {this.state.canSeeDuplicateNameErrorCreateManufacturer ?
                                    <Text c="red">Error: A manufacturer with this name and type already exists. Please try again.</Text>
                                    :
                                    undefined
                                }
                            </div>
                        {/* </Modal.Body> */}
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeManufacturerModal()} className="gothamNarrowFont">Cancel</Button></span>
                            <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateManufacturerForm() }} className="gothamNarrowFont">Submit</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for adding sites */}
                <Modal
                    opened={this.state.show_site_modal}
                    onClose={() => this.closeSiteModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create Site</Text></div>
                        {/* <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{ textAlign: "left", cursor: "default" }} className="gothamNarrowFont">Create Site</div>
                                <div style={{ cursor: "default", fontSize: "15px" }} className="gothamNarrowLightFont"><span className="requiredStar">*</span> indicates a required field</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ width: "100%", textAlign: "left" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormSiteCompany" className="mb-3">
                                        <Select 
                                            label="Company"
                                            placeholder="Pick a Value"
                                            data={
                                                this.state.tenants && this.state.tenants.map((tenant) => (
                                                    tenant.name_of_tenant
                                                ))
                                            }
                                            value={
                                                this.state.selected_tenant_id !== 0 && this.state.tenants && this.state.tenants.length > 0 && this.state.tenants.find((e) => e.id === this.state.selected_tenant_id) ? 
                                                    this.state.tenants.find((e) => e.id === this.state.selected_tenant_id).name_of_tenant
                                                    :
                                                    ""
                                            }
                                            disabled
                                            required
                                        />
                                        {/* <Form.Label>Company<span className="requiredStar">*</span></Form.Label>
                                        <Form.Control as="select" required disabled>
                                            {this.state.tenants && this.state.tenants.map((tenant) => (
                                                <>
                                                    {this.state.selected_tenant_id === tenant.id ?
                                                        <option key={`add_site_tenant_${tenant.id}`} selected>{tenant.name_of_tenant}</option>
                                                        :
                                                        <option key={`add_site_tenant_${tenant.id}`}>{tenant.name_of_tenant}</option>
                                                    }
                                                </>
                                            ))}
                                        </Form.Control> */}
                                        <Form.Text className="text-muted">
                                            Note: This value is controlled by which company you have selected on the add hardware asset screen
                                        </Form.Text>
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormSiteName" className="mb-3">
                                        {/* <Form.Label>Site Name<span className="requiredStar">*</span></Form.Label> */}
                                        <TextInput label="Site Name" placeholder="ex: Irvine Office" value={this.state.site_name_entered} onChange={this.handleCreateSiteNameChange} required />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormSiteStreetAddress" className="mb-3">
                                        {/* <Form.Label>Street Address</Form.Label> */}
                                        <TextInput label="Street Address" placeholder="ex: 1111 Wilmington Pl" value={this.state.site_street_address_entered} onChange={this.handleCreateSiteStreetAddressChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormSiteCity" className="mb-3">
                                        {/* <Form.Label>City</Form.Label> */}
                                        <TextInput label="City" placeholder="ex: Irvine" value={this.state.site_city_entered} onChange={this.handleCreateSiteCityChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormSiteState" className="mb-3">
                                        {/* <Form.Label>State</Form.Label> */}
                                        <TextInput label="State" placeholder="ex: CA" value={this.state.site_state_entered} onChange={this.handleCreateSiteStateChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormSiteZipCode" className="mb-3">
                                        {/* <Form.Label>Zip Code</Form.Label> */}
                                        <TextInput label="Zip Code" placeholder="ex: 99999" value={this.state.site_zip_code_entered} onChange={this.handleCreateSiteZipCodeChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                {this.state.canSeeErrorMessageCreateSite ?
                                    <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                    :
                                    undefined
                                }
                                {this.state.canSeeDuplicateNameErrorCreateSite ?
                                    <Text c="red">Error: A site with this name already exists. Please try again.</Text>
                                    :
                                    undefined
                                }
                            </div>
                        {/* </Modal.Body> */}
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeSiteModal()} className="gothamNarrowFont">Cancel</Button></span>
                            <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateSiteForm() }} className="gothamNarrowFont">Submit</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for adding locations at sites */}
                <Modal
                    opened={this.state.show_location_modal}
                    onClose={() => this.closeLocationModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create Location at Site</Text></div>
                        {/* <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{ textAlign: "center", cursor: "default" }} className="gothamNarrowFont">Create Location at Site</div>
                                <div style={{ cursor: "default", fontSize: "15px" }} className="gothamNarrowLightFont"><span className="requiredStar">*</span> indicates a required field</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ width: "100%", textAlign: "left" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormLocationSite" className="mb-3">
                                        <Select 
                                            label="Site (based on selection in outer form)"
                                            placeholder="Pick a Value"
                                            data={
                                                this.state.sites && this.state.sites.map((site) => (
                                                    site.name_of_site
                                                ))
                                            }
                                            value={
                                                // this.state.selected_model_id !== 0 && this.state.model_names && this.state.model_names.length > 0 && this.state.model_names.find((e) => e.id === this.state.selected_model_id) ? 
                                                //     this.state.model_names.find((e) => e.id === this.state.selected_model_id).name_of_model
                                                //     :
                                                //     ""
                                                this.state.selected_site_id !== 0 && this.state.sites && this.state.sites.length > 0 && this.state.sites.find((e) => e.id === this.state.selected_site_id) ? 
                                                    this.state.sites.find((e) => e.id === this.state.selected_site_id).name_of_site
                                                    :
                                                    ""
                                            }
                                            required
                                            disabled
                                        />
                                        {/* <Form.Label>{`Site (based on selection in outer form)`}<span className="requiredStar">*</span></Form.Label>
                                        <Form.Control as="select" required disabled>
                                            {this.state.sites && this.state.sites.map((site) => (
                                                <>
                                                    {this.state.selected_site_id === site.id ?
                                                        <option key={`add_site_${site.id}`} selected>{site.name_of_site}</option>
                                                        :
                                                        <option key={`add_site_${site.id}`}>{site.name_of_site}</option>
                                                    }
                                                </>
                                            ))}
                                        </Form.Control> */}
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormLocationFloor" className="mb-3">
                                        {/* <Form.Label>Floor<span className="requiredStar">*</span></Form.Label> */}
                                        <TextInput label="Floor" placeholder="ex: 1" required value={this.state.location_floor_entered} onChange={this.handleCreateLocationFloorChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormLocationAisle" className="mb-3">
                                        {/* <Form.Label>Aisle<span className="requiredStar">*</span></Form.Label> */}
                                        <TextInput label="Aisle" placeholder="ex: 1" required value={this.state.location_aisle_entered} onChange={this.handleCreateLocationAisleChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            {/* <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormLocationDesk" className="mb-3">
                                        {/* <Form.Label>Desk<span className="requiredStar">*</span></Form.Label> */}
                                        <TextInput label="Desk" placeholder="ex: 1" required value={this.state.location_desk_entered} onChange={this.handleCreateLocationDeskChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                {this.state.canSeeErrorMessageCreateLocation ?
                                    <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                    :
                                    undefined
                                }
                                {this.state.canSeeDuplicateNameErrorCreateLocation ?
                                    <Text c="red">Error: A location with this information already exists. Please try again.</Text>
                                    :
                                    undefined
                                }
                            </div>
                        {/* </Modal.Body> */}
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeLocationModal()} className="gothamNarrowFont">Cancel</Button></span>
                            <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateLocationForm() }} className="gothamNarrowFont">Submit</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for adding vendors */}
                <Modal
                    opened={this.state.show_vendor_modal}
                    onClose={() => this.closeVendorModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create Vendor</Text></div>
                        {/* <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{ textAlign: "center", cursor: "default" }} className="gothamNarrowFont">Create Vendor</div>
                                <div style={{ cursor: "default", fontSize: "15px" }} className="gothamNarrowLightFont"><span className="requiredStar">*</span> indicates a required field</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ width: "100%" }}>
                                <span style={{ display: "inline-block", width: "90%" }}> */}
                                    <Form.Group controlId="addFormVendorName" className="mb-3">
                                        {/* <Form.Label>Vendor Name<span className="requiredStar">*</span></Form.Label> */}
                                        <TextInput label="Vendor Name" placeholder="ex: Dell EMC" required value={this.state.vendor_name_entered} onChange={this.handleCreateVendorNameChange} />
                                    </Form.Group>
                                {/* </span>
                            </div> */}
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                {this.state.canSeeErrorMessageCreateVendor ?
                                    <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                    :
                                    undefined
                                }
                                {this.state.canSeeDuplicateNameErrorCreateVendor ?
                                    <Text c="red">Error: A vendor with this name already exists. Please try again.</Text>
                                    :
                                    undefined
                                }
                            </div>
                        {/* </Modal.Body> */}
                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeVendorModal()} className="gothamNarrowFont">Cancel</Button></span>
                            <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateVendorForm() }} className="gothamNarrowFont">Submit</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for adding departments */}
                <Modal
                    opened={this.state.show_department_modal}
                    onClose={() => this.closeDepartmentModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create Department</Text></div>
                        <Form.Group controlId="addFormDepartmentName" className="mb-3">
                                        
                                        <TextInput label="Department Name" placeholder="ex: Accounting" required value={this.state.department_name_entered} onChange={(e) => this.handleCreateDepartmentNameChange(e)} />
                                    </Form.Group>
                                
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                {this.state.canSeeErrorMessageCreateDepartment ?
                                    <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                    :
                                    undefined
                                }
                                {this.state.canSeeDuplicateNameErrorCreateDepartment ?
                                    <Text c="red">Error: A department with this name already exists. Please try again.</Text>
                                    :
                                    undefined
                                }
                            </div>

                            <div style={{textAlign: 'center', marginTop: "50px"}}>
                                <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeDepartmentModal()} className="gothamNarrowFont">Cancel</Button></span>
                                <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateDepartmentForm() }} className="gothamNarrowFont">Submit</Button></span>
                            </div>
                    </Form>
                </Modal>

                {/* This modal is for adding mananaging groups */}
                <Modal
                    opened={this.state.show_managing_group_modal}
                    onClose={() => this.closeManagingGroupModal()}
                    size="lg"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                    // backdrop="static"
                    // keyboard={false}
                    // size="lg"
                    // centered
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create Managing Group</Text></div>
                        <Form.Group controlId="addFormManagingGroupName" className="mb-3">           
                            <TextInput label="Managing Group Name" placeholder="Enter a value" required value={this.state.managing_group_name_entered} onChange={(e) => this.handleCreateManagingGroupNameChange(e)} />
                        </Form.Group>
                                
                        <div style={{ textAlign: "center", marginTop: "15px" }}>
                            {this.state.canSeeErrorMessageCreateManagingGroup ?
                                <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                                :
                                undefined
                            }
                            {this.state.canSeeDuplicateNameErrorCreateManagingGroup ?
                                <Text c="red">Error: A group with this name already exists. Please try again.</Text>
                                :
                                undefined
                            }
                        </div>

                        <div style={{textAlign: 'center', marginTop: "50px"}}>
                            <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeManagingGroupModal()} className="gothamNarrowFont">Cancel</Button></span>
                            <span><Button id="newDepartmentFormOkButton" onClick={() => { this.submitCreateManagingGroupForm() }} className="gothamNarrowFont">Submit</Button></span>
                        </div>
                    </Form>
                </Modal>

                {/* This modal is for the loading screen */}
                <Modal
                    opened={this.state.showSaving}
                    onClose={() => { this.setState({ showSaving: false }) }}
                    size="xl"
                    centered
                    withCloseButton={false}
                >


                    <Modal.Body>
                        <div className="gothamNarrowLightFont" style={{ cursor: "default", textAlign: "center" }}>Saving... Please wait.</div>
                    </Modal.Body>

                </Modal>

                {/* This modal is for the create asset note form */}
                <Modal
                    opened={this.state.show_notes_modal}
                    onClose={() => this.closeAssetNotesModal()}
                    title="Create Asset Note"
                    size="xl"
                    centered
                >
                    <Modal.Body>
                        <div>
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="assetNotesFormInput">
                                        <Form.Label>Note Text</Form.Label>
                                        <div data-text-editor="name">
                                            <RichTextInput defaultValue={this.state.asset_note_text_input} onChange={e => this.onChangeAssetNote(e)} />
                                        </div>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                            <div style={{textAlign: 'center', marginTop: "50px"}}>
                                <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeAssetNotesModal()}>Cancel</Button></span>
                                <span>
                                    {this.state.asset_note_text_input && this.state.asset_note_text_input !== "<p></p>" && this.state.asset_note_text_input.length > 0 ?
                                        <Button color="blue" onClick={() => this.submitAssetNote()}>Submit</Button>
                                        :
                                        <Button color="blue" disabled>Submit</Button>
                                    }
                                </span>
                            </div>
                        </div>
                    </Modal.Body>
                    
                </Modal>

            </>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,
        userPermissions: state.userPermissions,
        hardwareAssetFilter: state.hardwareAssetFilter
    };
}

export default connect(mapStateToProps, { LOGOUT, UPDATE_SELECTED_COMPANY_IN_ADD_ASSET_FORM_HARDWARE })(EditHardwareAsset);